
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";

// const API_URL = "https://grocerrybackend.vercel.app/api/prices";
// const CATEGORY_URL = "https://grocerrybackend.vercel.app/api/categories";

// export default function PriceList() {
//   const [items, setItems] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);

//   const [form, setForm] = useState({
//     name: "",
//     category: "",
//     subcategory: "",
//     description: "",
//     basePrice: "",
//     profitLoss: "",
//     validTill: "",
//     file: null,
//     status: "inactive",
//   });

//   const [editId, setEditId] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [activeMenu, setActiveMenu] = useState(null);

//   const [selectedItems, setSelectedItems] = useState([]);
//   const [bulkMode, setBulkMode] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 30;

//   const [filterCategory, setFilterCategory] = useState("");
//   const [filterSubcategory, setFilterSubcategory] = useState("");
//   const [filterSubs, setFilterSubs] = useState([]);

//   // Quick edit states for inline editing
//   const [quickBasePrices, setQuickBasePrices] = useState({});
//   const [quickProfitLoss, setQuickProfitLoss] = useState({});

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     if (categories.length > 0) fetchItems();
//   }, [categories]);

//   useEffect(() => {
//     if (!filterCategory) {
//       setFilterSubs([]);
//       setFilterSubcategory("");
//       return;
//     }
//     const cat = categories.find((c) => c._id === filterCategory);
//     setFilterSubs(cat?.subcategories || []);
//     setFilterSubcategory("");
//   }, [filterCategory, categories]);

//   useEffect(() => {
//     if (!form.category) {
//       setSubcategories([]);
//       setForm((prev) => ({ ...prev, subcategory: "" }));
//       return;
//     }
//     const cat = categories.find((c) => c._id === form.category);
//     setSubcategories(cat?.subcategories || []);
//   }, [form.category, categories]);

//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(CATEGORY_URL);
//       if (res.data?.success) setCategories(res.data.categories || []);
//     } catch (err) {
//       console.error("Fetch categories error", err);
//       alert("Could not fetch categories");
//     }
//   };

//   const fetchItems = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(API_URL);
//       if (res.data?.success) {
//         const raw = res.data.data || [];
//         // const enriched = raw.map((item) => {
//         //   const catObj = categories.find((c) => c._id === (item.category?._id || item.category));
//         //   const subObj = catObj?.subcategories?.find((s) => s._id === (item.subcategory?.id || item.subcategory?._id));

//         //   return {
//         //     ...item,
//         //     basePrice: item.basePrice || 0,
//         //     profitLoss: item.profitLoss || 0,
//         //     salePrice: item.salePrice || 0,
//         //     lockedPrice: item.lockedPrice || 0,
//         //     yesterdayLock: item.yesterdayLock || 0,
//         //     brokerDisplay: item.brokerDisplay || 0,
//         //     category: catObj ? { _id: catObj._id, name: catObj.name } : item.category,
//         //     subcategory: subObj ? { _id: subObj._id, name: subObj.name } : item.subcategory,
//         //   };
//         // });
//         const enriched = raw.map((item) => {
//   const catObj = categories.find((c) => c._id === (item.category?._id || item.category));

//   const subObj = catObj?.subcategories?.find(
//     (s) => s._id === item.subcategory?.id
//   );

//   return {
//     ...item,
//     category: catObj ? { _id: catObj._id, name: catObj.name } : null,
//     subcategory: subObj
//       ? { _id: subObj._id, name: subObj.name }
//       : item.subcategory?.id
//       ? { _id: item.subcategory.id, name: item.subcategory.name }
//       : null,
//   };
// });

//         setItems(enriched);
//       }
//     } catch (err) {
//       console.error("Fetch items error", err);
//       alert("Could not fetch items");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files?.length) {
//       setForm((p) => ({ ...p, file: files[0] }));
//     } else {
//       setForm((p) => ({ ...p, [name]: value }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       if (!form.name || !form.category || !form.basePrice) {
//         alert("Name, category & base price are required");
//         setLoading(false);
//         return;
//       }

//       const fd = new FormData();
//       fd.append("name", form.name);
//       fd.append("category", form.category);
//       // if (form.subcategory) fd.append("subcategory", form.subcategory);
//       if (form.subcategory) {
//   const sub = subcategories.find((s) => s._id === form.subcategory);
//   fd.append("subcategory[id]", sub._id);
//   fd.append("subcategory[name]", sub.name);
//   fd.append("subcategory[image]", sub.image || "");
// }

//       fd.append("basePrice", form.basePrice);
//       fd.append("profitLoss", form.profitLoss || 0);
//       if (form.description) fd.append("description", form.description);
//       if (form.validTill) fd.append("validTill", form.validTill);
//       fd.append("status", form.status);
//       if (form.file) fd.append("file", form.file);

//       if (editId) {
//         await axios.put(`${API_URL}/${editId}`, fd);
//         alert("Updated successfully");
//       } else {
//         await axios.post(API_URL, fd);
//         alert("Added successfully");
//       }

//       await fetchItems();
//       resetForm();
//     } catch (err) {
//       console.error("Save error", err);
//       alert("Save failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetForm = () => {
//     setForm({
//       name: "",
//       category: "",
//       subcategory: "",
//       description: "",
//       basePrice: "",
//       profitLoss: "",
//       validTill: "",
//       file: null,
//       status: "inactive",
//     });
//     setEditId(null);
//     setShowModal(false);
//     setShowForm(false);
//   };

//   const handleEdit = (item) => {
//     setForm({
//       name: item.name || "",
//       category: item.category?._id?.toString() || "",
//       // subcategory: item.subcategory?.id?.toString() || "",
//       subcategory: item.subcategory?._id || "",

//       description: item.description || "",
//       basePrice: item.basePrice || "",
//       profitLoss: item.profitLoss || 0,
//       validTill: item.validTill ? item.validTill.split("T")[0] : "",
//       file: null,
//       status: item.status || "inactive",
//     });

//     const cat = categories.find((c) => c._id === item.category?._id);
//     setSubcategories(cat?.subcategories || []);

//     setEditId(item._id);
//     setShowModal(true);
//     setActiveMenu(null);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this item?")) return;
//     try {
//       await axios.delete(`${API_URL}/${id}`);
//       setItems((prev) => prev.filter((x) => x._id !== id));
//       setSelectedItems((prev) => prev.filter((x) => x !== id));
//       setActiveMenu(null);
//     } catch (err) {
//       console.error("Delete error", err);
//       alert("Delete failed");
//     }
//   };

//   const handleStatusToggle = async (item) => {
//     try {
//       const newStatus = item.status === "active" ? "inactive" : "active";
//       await axios.put(`${API_URL}/status/${item._id}`, { status: newStatus });
//       setItems((prev) => prev.map((x) => (x._id === item._id ? { ...x, status: newStatus } : x)));
//     } catch (err) {
//       console.error("Status toggle error", err);
//       alert("Status update failed");
//     }
//   };

//   const updateLocalItemField = (id, key, value) => {
//     setItems((prev) => prev.map((x) => (x._id === id ? { ...x, [key]: value } : x)));
//   };

//   const handleBulkSave = async () => {
//     if (!selectedItems.length) return alert("No items selected");

//     const updates = items
//       .filter((x) => selectedItems.includes(x._id))
//       .map((x) => ({
//         id: x._id,
//         basePrice: Number(x.basePrice),
//         profitLoss: Number(x.profitLoss),
//         status: x.status,
//       }));

//     try {
//       await axios.post(`${API_URL}/bulk-update`, { products: updates });
//       alert("Bulk save successful");
//       setBulkMode(false);
//       setSelectedItems([]);
//       fetchItems();
//     } catch (err) {
//       console.error("Bulk save error", err);
//       alert("Bulk save failed");
//     }
//   };

//   const handleBulkDelete = async () => {
//     if (!selectedItems.length) return alert("No items selected");
//     if (!window.confirm("Delete selected items?")) return;

//     try {
//       await Promise.all(selectedItems.map((id) => axios.delete(`${API_URL}/${id}`)));
//       setSelectedItems([]);
//       fetchItems();
//       setBulkMode(false);
//     } catch (err) {
//       console.error("Bulk delete error", err);
//       alert("Bulk delete failed");
//     }
//   };

//   // Update Base Price inline
//   const updateBasePrice = async (item) => {
//     const newBase = Number(quickBasePrices[item._id] ?? item.basePrice);
//     if (isNaN(newBase)) return alert("Invalid Base Price");

//     try {
//       setLoading(true);
//       const fd = new FormData();
//       fd.append("name", item.name);
//       fd.append("category", item.category?._id);
//       if (item.subcategory?.id) fd.append("subcategory", item.subcategory.id);
//       fd.append("description", item.description || "");
//       fd.append("basePrice", newBase);
//       fd.append("profitLoss", item.profitLoss);
//       fd.append("status", item.status);

//       const res = await axios.put(`${API_URL}/${item._id}`, fd);
//       if (res.data.success) {
//         await fetchItems();
//         setQuickBasePrices((p) => ({ ...p, [item._id]: undefined }));
//         alert("Base price updated");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Update failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update Profit/Loss inline using updateDiff
//   const updateProfitLoss = async (item) => {
//     const diff = Number(quickProfitLoss[item._id] ?? 0);
//     if (isNaN(diff)) return alert("Invalid Profit/Loss");

//     try {
//       setLoading(true);
//       const res = await axios.put(`${API_URL}/updateDiff/${item._id}`, { diff });
//       if (res.data.success) {
//         await fetchItems();
//         setQuickProfitLoss((p) => ({ ...p, [item._id]: undefined }));
//         alert("Profit/Loss updated");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Update failed");
//     } finally {
//       setLoading(false);
//     }
//   };



  
//   const filteredItems = items.filter((item) => {
//     const t = search.toLowerCase();
//     const matchText =
//       (item.name || "").toLowerCase().includes(t) ||
//       (item.category?.name || "").toLowerCase().includes(t) ||
//       (item.subcategory?.name || "").toLowerCase().includes(t);

//     const matchCategory = !filterCategory || item.category?._id === filterCategory;
//     const matchSub = !filterSubcategory || item.subcategory?._id === filterSubcategory;

//     return matchText && matchCategory && matchSub;
//   });

//   const indexOfLast = currentPage * itemsPerPage;
//   const currentItems = filteredItems.slice(indexOfLast - itemsPerPage, indexOfLast);
//   const totalPages = Math.max(1, Math.ceil(filteredItems.length / itemsPerPage));

//   return (
//     <div className="container" style={styles.container}>
//       <div style={styles.header}>
//         <h1 style={styles.title}>Product Management</h1>
//       </div>

//       <div style={{ marginBottom: 12, display: "flex", gap: 12, flexWrap: "wrap" }}>
//         <input
//           type="text"
//           placeholder="Search product, category or subcategory..."
//           value={search}
//           onChange={(e) => {
//             setSearch(e.target.value);
//             setCurrentPage(1);
//           }}
//           style={styles.searchInput}
//         />

//         <button
//           style={styles.addButton}
//           onClick={() => {
//             setShowForm(!showForm);
//             setEditId(null);
//           }}
//         >
//           {showForm ? "✖ Close" : "➕ Add Product"}
//         </button>
//       </div>
// <button
//   style={styles.addButton}
//   onClick={() => window.open(`${API_URL}/export`, "_blank")}
// >
//   ⬇ Export CSV
// </button>

// <label style={{ cursor: "pointer" }}>
//   <input
//     type="file"
//     accept=".csv"
//     style={{ display: "none" }}
//     onChange={async (e) => {
//       try {
//         const fd = new FormData();
//         fd.append("file", e.target.files[0]);
//         await axios.post(`${API_URL}/import`, fd);
//         alert("Imported successfully");
//         fetchItems();
//       } catch (err) {
//         alert("Import failed");
//       }
//     }}
//   />
//   <span style={styles.addButton}>📤 Import CSV</span>
// </label>

//       <div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
//         <select
//           value={filterCategory}
//           onChange={(e) => setFilterCategory(e.target.value)}
//           style={styles.select}
//         >
//           <option value="">Filter by Category</option>
//           {categories.map((c) => (
//             <option key={c._id} value={c._id}>
//               {c.name}
//             </option>
//           ))}
//         </select>

//         <select
//           value={filterSubcategory}
//           onChange={(e) => setFilterSubcategory(e.target.value)}
//           disabled={!filterSubs.length}
//           style={styles.select}
//         >
//           <option value="">Filter by Subcategory</option>
//           {filterSubs.map((s) => (
//             <option key={s._id} value={s._id}>
//               {s.name}
//             </option>
//           ))}
//         </select>
//       </div>

//       {selectedItems.length > 0 && (
//         <div style={styles.bulkBar}>
//           {!bulkMode ? (
//             <div style={{ display: "flex", gap: 8 }}>
//               <button style={styles.btnDelete} onClick={handleBulkDelete}>
//                 🗑 Bulk Delete
//               </button>
//               <button style={styles.btnPrimary} onClick={() => setBulkMode(true)}>
//                 ✏ Bulk Edit
//               </button>
//             </div>
//           ) : (
//             <div style={styles.bulkPanel}>
//               <h3 style={styles.bulkPanelTitle}>✏ Bulk Edit Selected Items</h3>

//               {items
//                 .filter((item) => selectedItems.includes(item._id))
//                 .map((item) => (
//                   <div key={item._id} style={styles.bulkItemBox}>
//                     <h4 style={styles.bulkItemTitle}>{item.name}</h4>

//                     <div style={styles.formGrid}>
//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Base Price</label>
//                         <input
//                           type="number"
//                           value={item.basePrice}
//                           onChange={(e) => updateLocalItemField(item._id, "basePrice", Number(e.target.value))}
//                           style={styles.input}
//                         />
//                       </div>

//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Profit/Loss</label>
//                         <input
//                           type="number"
//                           value={item.profitLoss}
//                           onChange={(e) => updateLocalItemField(item._id, "profitLoss", Number(e.target.value))}
//                           style={styles.input}
//                         />
//                       </div>

//                       <div style={styles.formGroup}>
//                         <label style={styles.label}>Status</label>
//                         <select
//                           value={item.status}
//                           onChange={(e) => updateLocalItemField(item._id, "status", e.target.value)}
//                           style={styles.select}
//                         >
//                           <option value="active">active</option>
//                           <option value="inactive">inactive</option>
//                         </select>
//                       </div>
//                     </div>
//                   </div>
//                 ))}

//               {/* <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
//                 <button style={styles.btnPrimary} onClick={handleBulkSave}>
//                   ✔ Save All
//                 </button>
//                 <button style={styles.btnCancel} onClick={() => setBulkMode(false)}>
//                   ✖ Cancel
//                 </button>
//               </div> */}
//               <div style={{ display: "flex", gap: 10, marginTop: 12, flexWrap: 'wrap' }}>

//   <button style={styles.btnPrimary} onClick={handleBulkSave}>
//     ✔ Save All
//   </button>

//   <button
//     style={styles.btnPrimary}
//     onClick={async () => {
//       if (!selectedItems.length) return alert("No items selected");

//       for (let id of selectedItems) await axios.post(`${API_URL}/copy/${id}`);

//       alert("Selected copied");
//       fetchItems();
//     }}
//   >
//     📄 Copy Selected
//   </button>

//   <button
//     style={styles.btnPrimary}
//     onClick={async () => {
//       if (!selectedItems.length) return alert("No items selected");

//       const res = await axios.post(
//         `${API_URL}/export-selected`,
//         { ids: selectedItems },
//         { responseType: "blob" }
//       );

//       const url = window.URL.createObjectURL(new Blob([res.data]));
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = "selected.csv";
//       a.click();
//     }}
//   >
//     ⬇ Export Selected
//   </button>

//   <button style={styles.btnCancel} onClick={() => setBulkMode(false)}>
//     ✖ Cancel
//   </button>
// </div>

//             </div>
//           )}
//         </div>
//       )}

//       {showForm && (
//         <div style={styles.formCard}>
//           <h2 style={styles.formTitle}>➕ Add / Edit Product</h2>

//           <form onSubmit={handleSubmit}>
//             <div style={styles.formGrid}>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Product Name *</label>
//                 <input required name="name" value={form.name} onChange={handleChange} style={styles.input} />
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Category *</label>
//                 <select required name="category" value={form.category} onChange={handleChange} style={styles.select}>
//                   <option value="">Select Category</option>
//                   {categories.map((c) => (
//                     <option value={c._id} key={c._id}>
//                       {c.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Subcategory</label>
//                 <select
//                   name="subcategory"
//                   value={form.subcategory}
//                   onChange={handleChange}
//                   disabled={!subcategories.length}
//                   style={styles.select}
//                 >
//                   <option value="">Select Subcategory</option>
//                   {subcategories.map((s) => (
//                     // <option value={s._id} key={s._id}>
//                     //   {s.name}
//                     // </option>
//                     <option value={s._id}>{s.name}</option>

//                   ))}
//                 </select>
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Base Price *</label>
//                 <input
//                   type="number"
//                   required
//                   name="basePrice"
//                   value={form.basePrice}
//                   onChange={handleChange}
//                   style={styles.input}
//                 />
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Profit/Loss</label>
//                 <input
//                   type="number"
//                   name="profitLoss"
//                   value={form.profitLoss}
//                   onChange={handleChange}
//                   style={styles.input}
//                 />
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Valid Till</label>
//                 <input type="date" name="validTill" value={form.validTill} onChange={handleChange} style={styles.input} />
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Image</label>
//                 <input type="file" accept="image/*" onChange={handleChange} style={styles.fileInput} />
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Status</label>
//                 <select name="status" value={form.status} onChange={handleChange} style={styles.select}>
//                   <option value="active">Active</option>
//                   <option value="inactive">Inactive</option>
//                 </select>
//               </div>
//             </div>

//             <div style={styles.formGroup}>
//               <label style={styles.label}>Description</label>
//               <textarea name="description" value={form.description} onChange={handleChange} style={styles.textarea}></textarea>
//             </div>

//             <div style={styles.formActions}>
//               <button style={styles.btnPrimary} disabled={loading}>
//                 {loading ? "Saving..." : editId ? "Update Product" : "Add Product"}
//               </button>

//               <button type="button" style={styles.btnCancel} onClick={resetForm}>
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}
  
//       <div style={styles.tableCard}>
//         <div style={styles.tableHeader}>
//           <h2 style={styles.tableTitle}>Items</h2>
//           <span style={styles.totalCount}>Total: {filteredItems.length}</span>
//         </div>

//         <div style={styles.tableWrapper}>
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={styles.th}>
//                   <input
//                     type="checkbox"
//                     checked={selectedItems.length === filteredItems.length && filteredItems.length > 0}
//                     onChange={() => {
//                       if (selectedItems.length === filteredItems.length) setSelectedItems([]);
//                       else setSelectedItems(filteredItems.map((x) => x._id));
//                     }}
//                   />
//                 </th>
//                 <th style={styles.th}>Sr</th>
//                 <th style={styles.th}>Image</th>
//                 <th style={styles.th}>Name</th>
//                 <th style={styles.th}>Category</th>
//                 <th style={styles.th}>Subcategory</th>
//                 <th style={styles.th}>Base Price</th>
//                 <th style={styles.th}>Profit/Loss</th>
//                 <th style={styles.th}>Sale Price</th>
//                 <th style={styles.th}>Price Lock</th>
//                 <th style={styles.th}>Teji/Maddi</th>
//                 <th style={styles.th}>Status</th>
//                 <th style={styles.th}>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {currentItems.map((item, i) => (
//                 <tr key={item._id} style={styles.tr}>
//                   <td style={styles.td}>
//                     <input
//                       type="checkbox"
//                       checked={selectedItems.includes(item._id)}
//                       onChange={() =>
//                         setSelectedItems((prev) =>
//                           prev.includes(item._id) ? prev.filter((x) => x !== item._id) : [...prev, item._id]
//                         )
//                       }
//                     />
//                   </td>

//                   <td style={styles.td}>{(currentPage - 1) * itemsPerPage + (i + 1)}</td>

//                   <td style={styles.td}>
//                     {item.image ? <img src={item.image} style={styles.tableImg} alt="" /> : "No Img"}
//                   </td>

//                   <td style={styles.td}>{item.name}</td>
//                   <td style={styles.td}>{item.category?.name || "-"}</td>
//                   {/* <td style={styles.td}>{item.subcategory?.name || "-"}</td> */}
//                   <td>{item.subcategory?.name || "-"}</td>


//                   {/* BASE PRICE - Editable */}
//                   <td style={styles.td}>
//                     <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//                       <input
//                         type="number"
//                         value={quickBasePrices[item._id] !== undefined ? quickBasePrices[item._id] : item.basePrice}
//                         onChange={(e) => setQuickBasePrices((p) => ({ ...p, [item._id]: e.target.value }))}
//                         style={{ ...styles.input, padding: "6px 8px", width: 80 }}
//                       />
//                       <button style={styles.btnSmall} onClick={() => updateBasePrice(item)}>
//                         ✔
//                       </button>
//                     </div>
//                     <small style={{ color: "#28a745", display: "block", marginTop: 4 }}>Saved: ₹{item.basePrice}</small>
//                   </td>

//                   {/* PROFIT/LOSS - Editable */}
//                   <td style={styles.td}>
//                     <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//                       <input
//                         type="number"
//                         placeholder="change"
//                         value={quickProfitLoss[item._id] ?? ""}
//                         onChange={(e) => setQuickProfitLoss((p) => ({ ...p, [item._id]: e.target.value }))}
//                         style={{ ...styles.input, padding: "6px 8px", width: 80 }}
//                       />
//                       <button style={styles.btnSmall} onClick={() => updateProfitLoss(item)}>
//                         ✔
//                       </button>
//                     </div>
//                     <small style={{ color: "#666", display: "block", marginTop: 4 }}>Current: {item.profitLoss}</small>
//                   </td>

//                   {/* SALE PRICE */}
//                   <td style={styles.td}>₹{item.salePrice}</td>
 
//                   {/* PRICE LOCK */}
//                   <td style={styles.td}>₹{item.lockedPrice}</td>

//                   {/* TEJI/MADDI */}
//                   {/* <td style={styles.td}>
//   {(() => {
//     const teji = item.salePrice - item.lockedPrice;
//     return (
//       <span
//         style={{
//           color: teji >= 0 ? "#28a745" : "#dc3545",
//           fontWeight: "600",
//         }}
//       >
//         {teji >= 0 ? "▲" : "▼"} {Math.abs(teji)}
//       </span>
//     );
//   })()}
// </td> */}
// <td style={styles.td}>
//   {item.lockedPrice === 0 ? (
//     <span style={{ color: "#6c757d", fontWeight: "600" }}>0</span>
//   ) : (
//     (() => {
//       const teji = item.salePrice - item.lockedPrice;
//       return (
//         <span
//           style={{
//             color: teji >= 0 ? "#28a745" : "#dc3545",
//             fontWeight: "600",
//           }}
//         >
//           {teji >= 0 ? "▲" : "▼"} {Math.abs(teji)}
//         </span>
//       );
//     })()
//   )}
// </td>


//                   {/* STATUS */}
//                   <td style={styles.td}>
//                     <button
//                       style={item.status === "active" ? styles.statusActive : styles.statusInactive}
//                       onClick={() => handleStatusToggle(item)}
//                     >
//                       {item.status === "active" ? "Active" : "Inactive"}
//                     </button>
//                   </td>

//                   {/* ACTIONS */}
//                   <td style={styles.td}>
//                     <div style={{ position: "relative" }}>
//                       <button
//                         style={styles.menuButton}
//                         onClick={() => setActiveMenu(activeMenu === item._id ? null : item._id)}
//                       >
//                         ⋮
//                       </button>

//                       {activeMenu === item._id && (
//                         <div style={styles.dropdown}>
//                           {/* <button style={styles.dropdownItem} onClick={() => handleEdit(item)}>
//                             ✏ Edit
//                           </button>
//                           <button style={styles.dropdownItemDelete} onClick={() => handleDelete(item._id)}>
//                             🗑 Delete
//                           </button> */}
//                           <button style={styles.dropdownItem} onClick={() => handleEdit(item)}>
//   ✏ Edit
// </button>

// <button
//   style={styles.dropdownItem}
//   onClick={async () => {
//     await axios.post(`${API_URL}/copy/${item._id}`);
//     alert("Copied successfully");
//     fetchItems();
//   }}
// >
//   📄 Copy
// </button>

// <button style={styles.dropdownItemDelete} onClick={() => handleDelete(item._id)}>
//   🗑 Delete
// </button>

//                         </div>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div style={styles.pagination}>
//           <button style={styles.paginationBtn} disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
//             Previous
//           </button>

//           {Array.from({ length: totalPages }, (_, i) => (
//             <button
//               key={i}
//               style={i + 1 === currentPage ? styles.paginationBtnActive : styles.paginationBtn}
//               onClick={() => setCurrentPage(i + 1)}
//             >
//               {i + 1}
//             </button>
//           ))}

//           <button
//             style={styles.paginationBtn}
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage((p) => p + 1)}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {showModal && (
//         <div style={styles.modalOverlay} onClick={() => setShowModal(false)}>
//           <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
//             <h2 style={styles.modalTitle}>✏ Edit Product</h2>

//             <form onSubmit={handleSubmit}>
//               <div style={styles.formGrid}>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Product Name *</label>
//                   <input required name="name" value={form.name} onChange={handleChange} style={styles.input} />
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Category *</label>
//                   <select required name="category" value={form.category} onChange={handleChange} style={styles.select}>
//                     <option value="">Select Category</option>
//                     {categories.map((c) => (
//                       <option value={c._id} key={c._id}>
//                         {c.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Subcategory</label>
//                   <select
//                     name="subcategory"
//                     value={form.subcategory}
//                     onChange={handleChange}
//                     disabled={!subcategories.length}
//                     style={styles.select}
//                   >
//                     <option value="">Select Subcategory</option>
//                     {subcategories.map((s) => (
//                       <option value={s._id} key={s._id}>
//                         {s.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Base Price *</label>
//                   <input
//                     type="number"
//                     required
//                     name="basePrice"
//                     value={form.basePrice}
//                     onChange={handleChange}
//                     style={styles.input}
//                   />
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Profit/Loss</label>
//                   <input
//                     type="number"
//                     name="profitLoss"
//                     value={form.profitLoss}
//                     onChange={handleChange}
//                     style={styles.input}
//                   />
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Valid Till</label>
//                   <input type="date" name="validTill" value={form.validTill} onChange={handleChange} style={styles.input} />
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Image</label>
//                   <input type="file" accept="image/*" onChange={handleChange} style={styles.fileInput} />
//                 </div>

//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Status</label>
//                   <select name="status" value={form.status} onChange={handleChange} style={styles.select}>
//                     <option value="active">Active</option>
//                     <option value="inactive">Inactive</option>
//                   </select>
//                 </div>
//               </div>

//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Description</label>
//                 <textarea name="description" value={form.description} onChange={handleChange} style={styles.textarea}></textarea>
//               </div>

//               <div style={styles.formActions}>
//                 <button style={styles.btnPrimary} disabled={loading}>
//                   {loading ? "Saving..." : "Update"}
//                 </button>

//                 <button type="button" style={styles.btnCancel} onClick={resetForm}>
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// const styles = {
//   container: { padding: 16, fontFamily: "Arial, sans-serif" },
//   header: { marginBottom: 8 },
//   title: {
//     fontSize: "24px",
//     fontWeight: "700",
//     color: "#0d3b66",
//     marginBottom: "8px",
//   },
//   searchInput: {
//     flex: "1",
//     minWidth: "250px",
//     padding: "10px 12px",
//     borderRadius: "10px",
//     border: "1px solid #ced4da",
//     background: "#f9fbfc",
//     fontSize: "14px",
//     outline: "none",
//   },
//   addButton: {
//     background: "#007bff",
//     color: "#fff",
//     border: "none",
//     borderRadius: "10px",
//     padding: "10px 16px",
//     fontSize: "14px",
//     cursor: "pointer",
//     fontWeight: "600",
//   },
//   select: {
//     padding: "8px 12px",
//     borderRadius: "8px",
//     border: "1px solid #cfd6e0",
//     background: "#f8fafc",
//     fontSize: "13px",
//     minWidth: "150px",
//   },
//   bulkBar: {
//     background: "#e9f2ff",
//     border: "1px solid #c4d9ff",
//     borderRadius: "10px",
//     padding: "12px",
//     marginBottom: "12px",
//   },
//   bulkPanel: {
//     width: "100%",
//     background: "#f7faff",
//     border: "1px solid #cfe2ff",
//     padding: "12px",
//     borderRadius: "10px",
//   },
//   bulkPanelTitle: {
//     textAlign: "center",
//     fontSize: "16px",
//     fontWeight: "700",
//     marginBottom: "10px",
//     color: "#0d3b66",
//   },
//   bulkItemBox: {
//     background: "#fff",
//     border: "1px solid #dbe5f5",
//     padding: "12px",
//     borderRadius: "8px",
//     marginBottom: "10px",
//   },
//   bulkItemTitle: {
//     fontSize: "14px",
//     fontWeight: "600",
//     marginBottom: "8px",
//     color: "#233142",
//   },
//   formCard: {
//     borderRadius: "12px",
//     padding: "20px",
//     marginBottom: "18px",
//     background: "#ffffff",
//     border: "1px solid #eef2f7",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   },
//   formTitle: { 
//     fontSize: "18px", 
//     fontWeight: "700", 
//     marginBottom: 16,
//     color: "#0d3b66",
//   },
//   formGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
//     gap: "12px",
//   },
//   formGroup: { 
//     display: "flex", 
//     flexDirection: "column", 
//     gap: "6px" 
//   },
//   label: { 
//     fontWeight: "600", 
//     fontSize: "13px", 
//     color: "#233142" 
//   },
//   input: {
//     padding: "10px",
//     borderRadius: "8px",
//     border: "1px solid #cfd6e0",
//     background: "#f8fafc",
//     fontSize: "13px",
//     outline: "none",
//   },
//   textarea: {
//     padding: "10px",
//     borderRadius: "8px",
//     border: "1px solid #cfd6e0",
//     background: "#f8fafc",
//     minHeight: 80,
//     fontSize: "13px",
//     outline: "none",
//     resize: "vertical",
//   },
//   fileInput: { 
//     padding: "6px",
//     fontSize: "13px",
//   },
//   formActions: { 
//     marginTop: 16, 
//     display: "flex", 
//     gap: 10 
//   },
//   btnPrimary: {
//     background: "#007bff",
//     color: "#fff",
//     border: "none",
//     borderRadius: "8px",
//     padding: "10px 20px",
//     cursor: "pointer",
//     fontWeight: "600",
//     fontSize: "14px",
//   },
//   btnSmall: {
//     background: "#28a745",
//     color: "#fff",
//     border: "none",
//     borderRadius: "6px",
//     padding: "6px 12px",
//     cursor: "pointer",
//     fontSize: "12px",
//     fontWeight: "600",
//   },
//   btnDelete: {
//     background: "#dc3545",
//     color: "#fff",
//     border: "none",
//     borderRadius: "8px",
//     padding: "8px 14px",
//     cursor: "pointer",
//     fontWeight: "600",
//     fontSize: "14px",
//   },
//   btnCancel: {
//     background: "#6c757d",
//     color: "#fff",
//     border: "none",
//     borderRadius: "8px",
//     padding: "10px 20px",
//     cursor: "pointer",
//     fontWeight: "600",
//     fontSize: "14px",
//   },
//   tableCard: { 
//     marginTop: 16,
//     background: "#fff",
//     borderRadius: "12px",
//     padding: "16px",
//     border: "1px solid #eef2f7",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   },
//   tableHeader: { 
//     display: "flex", 
//     justifyContent: "space-between", 
//     marginBottom: 12,
//     alignItems: "center",
//   },
//   tableTitle: { 
//     fontSize: "18px", 
//     fontWeight: "700",
//     color: "#0d3b66",
//   },
//   totalCount: { 
//     fontSize: "14px", 
//     color: "#6c757d", 
//     fontWeight: "600" 
//   },
//   tableWrapper: { 
//     overflowX: "auto",
//     border: "1px solid #e9ecef",
//     borderRadius: "8px",
//   },
//   table: { 
//     width: "100%", 
//     borderCollapse: "collapse", 
//     fontSize: "13px" 
//   },
//   th: { 
//     background: "#f8f9fa", 
//     padding: "12px 10px", 
//     fontWeight: "700", 
//     color: "#0d3b66", 
//     textAlign: "left",
//     borderBottom: "2px solid #dee2e6",
//     whiteSpace: "nowrap",
//   },
//   tr: { 
//     borderBottom: "1px solid #edf2f7",
//     transition: "background 0.2s",
//   },
//   td: { 
//     padding: "12px 10px", 
//     whiteSpace: "nowrap", 
//     verticalAlign: "middle" 
//   },
//   tableImg: { 
//     width: "50px", 
//     height: "50px", 
//     borderRadius: "6px", 
//     objectFit: "cover" 
//   },
//   statusActive: { 
//     background: "#d4edda", 
//     padding: "6px 12px", 
//     borderRadius: "6px", 
//     color: "#155724", 
//     fontWeight: "600", 
//     border: "1px solid #c3e6cb", 
//     cursor: "pointer",
//     fontSize: "12px",
//   },
//   statusInactive: { 
//     background: "#f8d7da", 
//     padding: "6px 12px", 
//     borderRadius: "6px", 
//     color: "#721c24", 
//     fontWeight: "600", 
//     border: "1px solid #f5c6cb", 
//     cursor: "pointer",
//     fontSize: "12px",
//   },
//   menuButton: { 
//     background: "#f0f0f0", 
//     border: "1px solid #ddd", 
//     borderRadius: "6px", 
//     padding: "6px 10px", 
//     fontSize: "16px", 
//     cursor: "pointer",
//     fontWeight: "700",
//   },
//   dropdown: { 
//     position: "absolute", 
//     right: 0, 
//     top: 36, 
//     background: "#fff", 
//     border: "1px solid #ddd", 
//     borderRadius: 8, 
//     zIndex: 100, 
//     minWidth: 140,
//     boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//   },
//   dropdownItem: { 
//     display: "block", 
//     width: "100%", 
//     padding: "10px 14px", 
//     background: "transparent", 
//     border: "none", 
//     textAlign: "left", 
//     cursor: "pointer", 
//     fontSize: 13, 
//     fontWeight: 500,
//     transition: "background 0.2s",
//   },
//   dropdownItemDelete: { 
//     display: "block", 
//     width: "100%", 
//     padding: "10px 14px", 
//     background: "transparent", 
//     border: "none", 
//     textAlign: "left", 
//     cursor: "pointer", 
//     fontSize: 13, 
//     fontWeight: 500, 
//     color: "#dc3545",
//     transition: "background 0.2s",
//   },
//   pagination: { 
//     marginTop: 16, 
//     display: "flex", 
//     justifyContent: "center", 
//     gap: 8,
//     flexWrap: "wrap",
//   },
//   paginationBtn: { 
//     padding: "8px 12px", 
//     borderRadius: 6, 
//     background: "#fff", 
//     border: "1px solid #dee2e6", 
//     cursor: "pointer",
//     fontSize: "13px",
//     fontWeight: "500",
//   },
//   paginationBtnActive: { 
//     padding: "8px 12px", 
//     borderRadius: 6, 
//     background: "#007bff", 
//     color: "white", 
//     border: "1px solid #007bff", 
//     cursor: "pointer",
//     fontSize: "13px",
//     fontWeight: "600",
//   },
//   modalOverlay: { 
//     position: "fixed", 
//     top: 0, 
//     left: 0, 
//     right: 0, 
//     bottom: 0, 
//     background: "rgba(0,0,0,0.5)", 
//     display: "flex", 
//     justifyContent: "center", 
//     alignItems: "center", 
//     zIndex: 1000, 
//     padding: 20 
//   },
//   modal: { 
//     background: "#fff", 
//     borderRadius: 12, 
//     padding: 24, 
//     maxWidth: 700, 
//     width: "100%", 
//     maxHeight: "90vh", 
//     overflowY: "auto",
//     boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//   },
//   modalTitle: { 
//     fontSize: 20, 
//     fontWeight: "700", 
//     color: "#0d3b66", 
//     marginBottom: 16, 
//     textAlign: "center" 
//   },
// }

// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const API_URL = "https://grocerrybackend.vercel.app/api/prices";
// const CATEGORY_URL = "https://grocerrybackend.vercel.app/api/categories";

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// // import { API_URL, CATEGORY_URL } from "../config";

// export default function PriceList() {
//   const [items, setItems] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [activeMenu, setActiveMenu] = useState(null);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [bulkMode, setBulkMode] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [filterCategory, setFilterCategory] = useState("");
//   const [filterSubcategory, setFilterSubcategory] = useState("");
//   const [filterSubs, setFilterSubs] = useState([]);
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [newCategoryName, setNewCategoryName] = useState("");
//   const [categoryLoading, setCategoryLoading] = useState(false);
//   const [sortOrder, setSortOrder] = useState("");
//   const [quickBasePrices, setQuickBasePrices] = useState({});
//   const [quickProfitLoss, setQuickProfitLoss] = useState({});
//   const [alertBox, setAlertBox] = useState({
//     show: false,
//     message: "",
//     type: "success",
//   });
//   const [expandedRows, setExpandedRows] = useState({}); // New state for expanded rows

//   const itemsPerPage = 20;

//   const [form, setForm] = useState({
//     name: "",
//     category: "",
//     subcategory: "",
//     description: "",
//     basePrice: "",
//     profitLoss: "",
//     validTill: "",
//     file: null,
//     status: "inactive",
//   });

//   // Alert timeout
//   useEffect(() => {
//     if (alertBox.show) {
//       const timer = setTimeout(() => {
//         setAlertBox((prev) => ({ ...prev, show: false }));
//       }, 2500);
//       return () => clearTimeout(timer);
//     }
//   }, [alertBox.show]);

//   // Initial fetch
//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     if (categories.length > 0) fetchItems();
//   }, [categories]);

//   // Filter subcategories
//   useEffect(() => {
//     if (!filterCategory) {
//       setFilterSubs([]);
//       setFilterSubcategory("");
//       return;
//     }
//     const cat = categories.find((c) => c._id === filterCategory);
//     setFilterSubs(cat?.subcategories || []);
//     setFilterSubcategory("");
//   }, [filterCategory, categories]);

//   // Form subcategories
//   const formSubcategories = form.category
//     ? categories.find((c) => c._id === form.category)?.subcategories || []
//     : [];

//   // Fetch categories
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(CATEGORY_URL);
//       if (res.data?.success) setCategories(res.data.categories || []);
//     } catch (err) {
//       console.error("Fetch categories error", err);
//       showAlert("❌ Could not fetch categories", "error");
//     }
//   };

//   // Fetch items
//   const fetchItems = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(API_URL);
//       if (res.data?.success) {
//         const raw = res.data.data || [];
//         const enriched = raw.map((item) => {
//           const catObj = categories.find((c) => c._id === (item.category?._id || item.category));
//           let subObj = null;

//           if (catObj?.subcategories && item.subcategory) {
//             const subId = item.subcategory?.id || item.subcategory?._id || item.subcategory;
//             subObj = catObj.subcategories.find((s) => s._id === subId) || null;
//           }

//           return {
//             ...item,
//             basePrice: Number(item.basePrice || 0),
//             profitLoss: Number(item.profitLoss || 0),
//             salePrice: Number(item.salePrice || 0),
//             lockedPrice: Number(item.lockedPrice || 0),
//             category: catObj ? { _id: catObj._id, name: catObj.name } : (item.category || null),
//             subcategory: subObj
//               ? { _id: subObj._id, name: subObj.name }
//               : item.subcategory?.id
//               ? { _id: item.subcategory.id, name: item.subcategory.name }
//               : item.subcategory || null,
//           };
//         });

//         setItems(enriched.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
//       }
//     } catch (err) {
//       console.error("Fetch items error", err);
//       showAlert("❌ Could not fetch items", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Helper to show alerts
//   const showAlert = (message, type) => {
//     setAlertBox({ show: true, message, type });
//   };

//   // Toggle row expansion
//   const toggleRowExpand = (id) => {
//     setExpandedRows(prev => ({
//       ...prev,
//       [id]: !prev[id]
//     }));
//   };

//   // Handle form changes
//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files?.length) {
//       setForm((p) => ({ ...p, file: files[0] }));
//     } else {
//       setForm((p) => ({ ...p, [name]: value }));
//     }
//   };

//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Duplicate check
//     const nameExists = items.some(
//       (p) =>
//         p.name.trim().toLowerCase() === form.name.trim().toLowerCase() &&
//         p._id !== editId
//     );

//     if (nameExists) {
//       showAlert("❌ Product name already exists!", "error");
//       setLoading(false);
//       return;
//     }

//     if (!form.name || !form.category || !form.basePrice) {
//       showAlert("❌ Name, category & base price are required", "error");
//       setLoading(false);
//       return;
//     }

//     try {
//       const fd = new FormData();
//       fd.append("name", form.name.trim());
//       fd.append("category", form.category);

//       if (form.subcategory) {
//         const sub = formSubcategories.find((s) => s._id === form.subcategory);
//         if (sub) {
//           fd.append(
//             "subcategory",
//             JSON.stringify({
//               id: sub._id,
//               name: sub.name,
//               image: sub.image || ""
//             })
//           );
//         }
//       } else {
//         fd.append("subcategory", JSON.stringify(null));
//       }

//       fd.append("basePrice", form.basePrice);
//       fd.append("profitLoss", form.profitLoss || 0);
//       if (form.description) fd.append("description", form.description);
//       if (form.validTill) fd.append("validTill", form.validTill);
//       fd.append("status", form.status);
//       if (form.file) fd.append("file", form.file);

//       if (editId) {
//         await axios.put(`${API_URL}/${editId}`, fd);
//         showAlert("✅ Product updated successfully", "success");
//       } else {
//         await axios.post(API_URL, fd);
//         showAlert("✅ Product added successfully", "success");
//       }

//       await fetchItems();
//       resetForm();
//     } catch (err) {
//       console.error("Save error", err);
//       showAlert("❌ Save failed!", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Reset form
//   const resetForm = () => {
//     setForm({
//       name: "",
//       category: "",
//       subcategory: "",
//       description: "",
//       basePrice: "",
//       profitLoss: "",
//       validTill: "",
//       file: null,
//       status: "inactive",
//     });
//     setEditId(null);
//     setShowForm(false);
//   };

//   // Add category
//   const handleAddCategory = async () => {
//     if (!newCategoryName.trim()) {
//       showAlert("❌ Category name is required", "error");
//       return;
//     }

//     try {
//       setCategoryLoading(true);
//       const res = await axios.post(CATEGORY_URL, {
//         name: newCategoryName.trim(),
//       });

//       if (res.data?.success) {
//         showAlert("✅ Category added successfully", "success");
//         setNewCategoryName("");
//         setShowCategoryModal(false);
//         await fetchCategories();
//       } else {
//         showAlert("❌ Category add failed", "error");
//       }
//     } catch (err) {
//       console.error("Add category error", err);
//       showAlert("❌ Error while adding category", "error");
//     } finally {
//       setCategoryLoading(false);
//     }
//   };

//   // Edit item
//   const handleEdit = (item) => {
//     setForm({
//       name: item.name || "",
//       category: item.category?._id?.toString() || "",
//       subcategory: item.subcategory?._id || "",
//       description: item.description || "",
//       basePrice: item.basePrice || "",
//       profitLoss: item.profitLoss || 0,
//       validTill: item.validTill ? item.validTill.split("T")[0] : "",
//       file: null,
//       status: item.status || "inactive",
//     });

//     setEditId(item._id);
//     setShowForm(true);
//     setActiveMenu(null);
//   };

//   // Delete item
//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this item?")) return;
//     try {
//       await axios.delete(`${API_URL}/${id}`);
//       setItems((prev) => prev.filter((x) => x._id !== id));
//       setSelectedItems((prev) => prev.filter((x) => x !== id));
//       setActiveMenu(null);
//       showAlert("✅ Item deleted successfully", "success");
//     } catch (err) {
//       console.error("Delete error", err);
//       showAlert("❌ Delete failed", "error");
//     }
//   };

//   // Toggle status
//   const handleStatusToggle = async (item) => {
//     try {
//       const newStatus = item.status === "active" ? "inactive" : "active";
//       await axios.put(`${API_URL}/status/${item._id}`, { status: newStatus });
//       setItems((prev) => prev.map((x) => (x._id === item._id ? { ...x, status: newStatus } : x)));
//     } catch (err) {
//       console.error("Status toggle error", err);
//       showAlert("❌ Status update failed", "error");
//     }
//   };

//   // Handle bulk item data change
//   const handleBulkItemChange = (id, field, value) => {
//     setItems(prevItems => prevItems.map(item => {
//       if (item._id === id) {
//         const newItem = { ...item, [field]: value };
//         // Recalculate sale price for display
//         if (field === 'basePrice' || field === 'profitLoss') {
//           const base = Number(newItem.basePrice || 0);
//           const profit = Number(newItem.profitLoss || 0);
//           newItem.salePrice = base + profit;
//         }
//         return newItem;
//       }
//       return item;
//     }));
//   };

//   // Bulk save
//   const handleBulkSave = async () => {
//     if (!selectedItems.length) {
//       showAlert("❌ No items selected", "error");
//       return;
//     }

//     const updates = items
//       .filter((x) => selectedItems.includes(x._id))
//       .map((x) => ({
//         id: x._id,
//         basePrice: Number(x.basePrice),
//         profitLoss: Number(x.profitLoss),
//         status: x.status,
//       }));

//     try {
//       await axios.post(`${API_URL}/bulk-update`, { products: updates });
//       showAlert("✅ Bulk save successful", "success");
//       setBulkMode(false);
//       setSelectedItems([]);
//       fetchItems();
//     } catch (err) {
//       console.error("Bulk save error", err);
//       showAlert("❌ Bulk save failed", "error");
//     }
//   };

//   // Bulk delete
//   const handleBulkDelete = async () => {
//     if (!selectedItems.length) {
//       showAlert("❌ No items selected", "error");
//       return;
//     }
//     if (!window.confirm("Delete selected items?")) return;

//     try {
//       await Promise.all(selectedItems.map((id) => axios.delete(`${API_URL}/${id}`)));
//       setSelectedItems([]);
//       fetchItems();
//       setBulkMode(false);
//       showAlert("✅ Bulk delete successful", "success");
//     } catch (err) {
//       console.error("Bulk delete error", err);
//       showAlert("❌ Bulk delete failed", "error");
//     }
//   };

//   // Update Base Price inline
//   const updateBasePrice = async (item) => {
//     const newBase = Number(quickBasePrices[item._id] ?? item.basePrice);
//     if (isNaN(newBase)) {
//       showAlert("❌ Invalid Base Price", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const fd = new FormData();
//       fd.append("name", item.name);
//       fd.append("category", item.category?._id);
//       if (item.subcategory?.id) fd.append("subcategory", item.subcategory.id);
//       fd.append("description", item.description || "");
//       fd.append("basePrice", newBase);
//       fd.append("profitLoss", item.profitLoss);
//       fd.append("status", item.status);

//       const res = await axios.put(`${API_URL}/${item._id}`, fd);
//       if (res.data.success) {
//         await fetchItems();
//         setQuickBasePrices((p) => ({ ...p, [item._id]: undefined }));
//         showAlert("✅ Base price updated", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       showAlert("❌ Update failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update Profit/Loss inline
//   const updateProfitLoss = async (item) => {
//     const diff = Number(quickProfitLoss[item._id] ?? 0);
//     if (isNaN(diff)) {
//       showAlert("❌ Invalid Profit/Loss", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await axios.put(`${API_URL}/updateDiff/${item._id}`, { diff });
//       if (res.data.success) {
//         await fetchItems();
//         setQuickProfitLoss((p) => ({ ...p, [item._id]: undefined }));
//         showAlert("✅ Profit/Loss updated", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       showAlert("❌ Update failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Filter items
//   const filteredItems = items.filter((item) => {
//     const t = search.toLowerCase();
//     const matchText =
//       (item.name || "").toLowerCase().includes(t) ||
//       (item.category?.name || "").toLowerCase().includes(t) ||
//       (item.subcategory?.name || "").toLowerCase().includes(t);

//     const matchCategory = !filterCategory || item.category?._id === filterCategory;
//     const matchSub = !filterSubcategory || item.subcategory?._id === filterSubcategory;

//     return matchText && matchCategory && matchSub;
//   });

//   // Sorting
//   let sortedItems = [...filteredItems];
//   if (sortOrder === "low") {
//     sortedItems.sort((a, b) => (Number(a.salePrice) || 0) - (Number(b.salePrice) || 0));
//   } else if (sortOrder === "high") {
//     sortedItems.sort((a, b) => (Number(b.salePrice) || 0) - (Number(a.salePrice) || 0));
//   }

//   // Pagination
//   const indexOfLast = currentPage * itemsPerPage;
//   const currentItems = sortedItems.slice(indexOfLast - itemsPerPage, indexOfLast);
//   const totalPages = Math.max(1, Math.ceil(sortedItems.length / itemsPerPage));

//   // Truncate text
//   const truncate = (text, maxLength = 20) => {
//     if (!text) return "";
//     if (text.length <= maxLength) return text;
//     return text.substring(0, maxLength) + '...';
//   };

//   // Get Teji/Maddi
//   const getTejiMaddi = (item) => {
//     if (item.lockedPrice === 0) return { value: 0, type: "neutral" };
//     const teji = item.salePrice - item.lockedPrice;
//     return {
//       value: Math.abs(teji),
//       type: teji >= 0 ? "positive" : "negative"
//     };
//   };

//   // Get status color
//   const getStatusColor = (status) => {
//     return status === "active" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric'
//     });
//   };

//   return (
//     <>
//       {/* Header */}
//       <div className="mb-2">
//         <h1 className="text-xl font-bold text-gray-800">Product Management</h1>
//         <p className="text-gray-600 text-sm">Total: {filteredItems.length} items</p>
//       </div>

//       {/* Top Controls */}
//       <div className="bg-white rounded-lg shadow p-2 mb-2">
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-1.5 mb-2">
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               setCurrentPage(1);
//             }}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm col-span-2 md:col-span-1"
//           />

//           <select
//             value={filterCategory}
//             onChange={(e) => setFilterCategory(e.target.value)}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm"
//           >
//             <option value="">All Categories</option>
//             {categories.map((c) => (
//               <option key={c._id} value={c._id}>{c.name}</option>
//             ))}
//           </select>

//           <select
//             value={filterSubcategory}
//             onChange={(e) => setFilterSubcategory(e.target.value)}
//             disabled={!filterSubs.length}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm disabled:opacity-50"
//           >
//             <option value="">All Subcategories</option>
//             {filterSubs.map((s) => (
//               <option key={s._id} value={s._id}>{s.name}</option>
//             ))}
//           </select>

//           <select
//             value={sortOrder}
//             onChange={(e) => setSortOrder(e.target.value)}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm"
//           >
//             <option value="">Default Sort</option>
//             <option value="low">Price: Low → High</option>
//             <option value="high">Price: High → Low</option>
//           </select>

//           <button
//             onClick={() => {
//               setShowForm(!showForm);
//               if (showForm) resetForm();
//             }}
//             className="px-1.5 py-1 bg-blue-600 text-white rounded text-xs md:text-sm font-medium hover:bg-blue-700"
//           >
//             {showForm ? "Cancel Add" : "Add Product"}
//           </button>
//         </div>

//         {/* Action Buttons */}
//         <div className="flex flex-wrap gap-1.5">
//           <button
//             onClick={() => window.open(`${API_URL}/export`, "_blank")}
//             className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50"
//           >
//             Export CSV
//           </button>

//           <label className="cursor-pointer">
//             <input
//               type="file"
//               accept=".csv"
//               className="hidden"
//               onChange={async (e) => {
//                 try {
//                   const fd = new FormData();
//                   fd.append("file", e.target.files[0]);
//                   await axios.post(`${API_URL}/import`, fd);
//                   showAlert("✅ Imported successfully", "success");
//                   fetchItems();
//                 } catch (err) {
//                   showAlert("❌ Import failed", "error");
//                 }
//               }}
//             />
//             <span className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50">
//               Import CSV
//             </span>
//           </label>

//           <button
//             onClick={() => setShowCategoryModal(true)}
//             className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//           >
//             Add Category
//           </button>
//         </div>
//       </div>

//       {/* Bulk Actions */}
//       {selectedItems.length > 0 && (
//         <div className="bg-yellow-50 border border-yellow-200 rounded p-1.5 mb-2">
//           <div className="flex items-center justify-between">
//             <span className="font-medium text-xs md:text-sm">{selectedItems.length} selected</span>
//             <div className="flex gap-1.5">
//               <button
//                 onClick={handleBulkDelete}
//                 className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
//               >
//                 Bulk Delete
//               </button>
//               <button
//                 onClick={() => setBulkMode(!bulkMode)}
//                 className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
//               >
//                 {bulkMode ? "Cancel Edit" : "Bulk Edit"}
//               </button>
//               {bulkMode && (
//                 <button
//                   onClick={handleBulkSave}
//                   className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//                 >
//                   Save All
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Bulk Edit Panel */}
//           {bulkMode && (
//             <div className="mt-2 pt-2 border-t border-yellow-200">
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
//                 {items
//                   .filter((item) => selectedItems.includes(item._id))
//                   .map((item) => (
//                     <div key={item._id} className="bg-white rounded p-2 border">
//                       <h4 className="font-semibold text-xs mb-1 truncate">{truncate(item.name, 15)}</h4>
//                       <div className="space-y-1">
//                         <div>
//                           <label className="block text-[10px] text-gray-600 mb-0.5">Base Price</label>
//                           <input
//                             type="number"
//                             value={item.basePrice}
//                             onChange={(e) => handleBulkItemChange(item._id, 'basePrice', e.target.value)}
//                             className="w-full px-1 py-0.5 border rounded text-xs"
//                           />
//                         </div>
//                         <div>
//                           <label className="block text-[10px] text-gray-600 mb-0.5">Profit/Loss</label>
//                           <input
//                             type="number"
//                             value={item.profitLoss}
//                             onChange={(e) => handleBulkItemChange(item._id, 'profitLoss', e.target.value)}
//                             className="w-full px-1 py-0.5 border rounded text-xs"
//                           />
//                         </div>
//                         <div>
//                           <label className="block text-[10px] text-gray-600 mb-0.5">Status</label>
//                           <select
//                             value={item.status}
//                             onChange={(e) => handleBulkItemChange(item._id, 'status', e.target.value)}
//                             className="w-full px-1 py-0.5 border rounded text-xs"
//                           >
//                             <option value="active">Active</option>
//                             <option value="inactive">Inactive</option>
//                           </select>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Add/Edit Form */}
//       {showForm && (
//         <div className="bg-white rounded-lg shadow p-2 mb-2">
//           <h3 className="font-bold mb-1.5 text-sm">{editId ? "Edit Product" : "Add New Product"}</h3>
//           <form onSubmit={handleSubmit}>
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 mb-2">
//               <input
//                 required
//                 name="name"
//                 placeholder="Product Name"
//                 value={form.name}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <div className="flex gap-1">
//                 <select
//                   required
//                   name="category"
//                   value={form.category}
//                   onChange={handleChange}
//                   className="flex-1 px-1.5 py-1 border rounded text-xs"
//                 >
//                   <option value="">Select Category</option>
//                   {categories.map((c) => (
//                     <option key={c._id} value={c._id}>{c.name}</option>
//                   ))}
//                 </select>
//                 <button
//                   type="button"
//                   onClick={() => setShowCategoryModal(true)}
//                   className="px-1.5 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//                 >
//                   +
//                 </button>
//               </div>

//               <select
//                 name="subcategory"
//                 value={form.subcategory}
//                 onChange={handleChange}
//                 disabled={!formSubcategories.length}
//                 className="px-1.5 py-1 border rounded text-xs disabled:opacity-50"
//               >
//                 <option value="">Select Subcategory</option>
//                 {formSubcategories.map((s) => (
//                   <option key={s._id} value={s._id}>{s.name}</option>
//                 ))}
//               </select>

//               <input
//                 type="number"
//                 required
//                 name="basePrice"
//                 placeholder="Base Price"
//                 value={form.basePrice}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <input
//                 type="number"
//                 name="profitLoss"
//                 placeholder="Profit/Loss"
//                 value={form.profitLoss}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <input
//                 type="date"
//                 name="validTill"
//                 value={form.validTill}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <select
//                 name="status"
//                 value={form.status}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               >
//                 <option value="active">Active</option>
//                 <option value="inactive">Inactive</option>
//               </select>

//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs text-[10px]"
//               />
//             </div>

//             <div className="mb-2">
//               <textarea
//                 name="description"
//                 placeholder="Description (optional)"
//                 value={form.description}
//                 onChange={handleChange}
//                 rows="2"
//                 className="w-full px-1.5 py-1 border rounded text-xs"
//               />
//             </div>

//             <div className="flex gap-1.5">
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="flex-1 px-1.5 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 disabled:opacity-50"
//               >
//                 {loading ? "Saving..." : (editId ? "Update" : "Save")}
//               </button>
//               <button
//                 type="button"
//                 onClick={resetForm}
//                 className="px-1.5 py-1 border rounded text-xs hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Products Table */}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         {loading ? (
//           <div className="p-4 text-center">
//             <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
//             <p className="mt-2 text-xs text-gray-600">Loading...</p>
//           </div>
//         ) : filteredItems.length === 0 ? (
//           <div className="p-4 text-center text-gray-500 text-sm">
//             No products found
//           </div>
//         ) : (
//           <>
//             <div className="overflow-x-auto">
//               <table className="min-w-full text-xs">
//                 <thead className="bg-gray-100">
//                   <tr>
//                     <th className="px-1 py-1 text-left w-6">
//                       <input
//                         type="checkbox"
//                         checked={selectedItems.length === filteredItems.length && filteredItems.length > 0}
//                         onChange={() => {
//                           if (selectedItems.length === filteredItems.length) setSelectedItems([]);
//                           else setSelectedItems(filteredItems.map((x) => x._id));
//                         }}
//                         className="rounded w-3 h-3"
//                       />
//                     </th>
//                     <th className="px-1.5 py-1 text-left font-medium w-6">#</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-10">Img</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/4">Product</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/5">Category</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Base Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">P/L</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Sale Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Lock Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Teji/Maddi</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Status</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/12">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-200">
//                   {currentItems.map((item, i) => {
//                     const tejiMaddi = getTejiMaddi(item);
//                     const isExpanded = expandedRows[item._id];
                    
//                     return (
//                       <React.Fragment key={item._id}>
//                         <tr className="hover:bg-gray-50 align-top">
//                           <td className="px-1 py-1.5">
//                             <input
//                               type="checkbox"
//                               checked={selectedItems.includes(item._id)}
//                               onChange={() =>
//                                 setSelectedItems((prev) =>
//                                   prev.includes(item._id)
//                                     ? prev.filter((x) => x !== item._id)
//                                     : [...prev, item._id]
//                                 )
//                               }
//                               className="rounded w-3 h-3"
//                             />
//                           </td>
//                           <td className="px-1.5 py-1.5 text-xs text-gray-500">
//                             {(currentPage - 1) * itemsPerPage + (i + 1)}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             {item.image ? (
//                               <img src={item.image} alt={item.name} className="w-8 h-8 rounded object-cover" />
//                             ) : (
//                               <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center">
//                                 <span className="text-[8px] text-gray-400">No Img</span>
//                               </div>
//                             )}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="font-medium text-xs" title={item.name}>
//                               {truncate(item.name, 15)}
//                             </div>
//                             <div className="text-[10px] text-gray-500">
//                               {truncate(item.subcategory?.name || "No sub", 12)}
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <span className="text-[10px] px-1 py-0.5 bg-gray-100 rounded">
//                               {truncate(item.category?.name || "-", 10)}
//                             </span>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex items-center gap-1">
//                               <input
//                                 type="number"
//                                 value={quickBasePrices[item._id] !== undefined ? quickBasePrices[item._id] : item.basePrice}
//                                 onChange={(e) => setQuickBasePrices((p) => ({ ...p, [item._id]: e.target.value }))}
//                                 className="w-16 px-1 py-0.5 border rounded text-xs h-6"
//                               />
//                               <button
//                                 onClick={() => updateBasePrice(item)}
//                                 className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
//                               >
//                                 ✔
//                               </button>
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex items-center gap-1">
//                               <input
//                                 type="number"
//                                 placeholder="change"
//                                 value={quickProfitLoss[item._id] ?? ""}
//                                 onChange={(e) => setQuickProfitLoss((p) => ({ ...p, [item._id]: e.target.value }))}
//                                 className="w-16 px-1 py-0.5 border rounded text-xs h-6"
//                               />
//                               <button
//                                 onClick={() => updateProfitLoss(item)}
//                                 className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
//                               >
//                                 ✔
//                               </button>
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5 font-bold text-xs">
//                             ₹{item.salePrice.toFixed(2)}
//                           </td>
//                           <td className="px-1.5 py-1.5 text-xs">
//                             ₹{item.lockedPrice.toFixed(2)}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <span className={`text-xs font-medium ${
//                               tejiMaddi.type === 'positive' ? 'text-green-600' :
//                               tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                             }`}>
//                               {tejiMaddi.type === 'positive' ? '▲' : tejiMaddi.type === 'negative' ? '▼' : ''}
//                               ₹{tejiMaddi.value.toFixed(2)}
//                             </span>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <button
//                               onClick={() => handleStatusToggle(item)}
//                               className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}
//                             >
//                               {item.status === "active" ? "Active" : "Inactive"}
//                             </button>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex gap-1">
//                               <button
//                                 onClick={() => toggleRowExpand(item._id)}
//                                 className={`w-6 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50 ${
//                                   isExpanded ? 'bg-blue-50 text-blue-600' : ''
//                                 }`}
//                                 title={isExpanded ? "Collapse Details" : "Expand Details"}
//                               >
//                                 {isExpanded ? '−' : '+'}
//                               </button>
//                               <div className="relative">
//                                 <button
//                                   onClick={() => setActiveMenu(activeMenu === item._id ? null : item._id)}
//                                   className="w-5 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50"
//                                 >
//                                   ⋮
//                                 </button>
//                                 {activeMenu === item._id && (
//                                   <div className="absolute right-0 mt-1 w-24 bg-white border rounded shadow-lg z-10">
//                                     <button
//                                       onClick={() => handleEdit(item)}
//                                       className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
//                                     >
//                                       ✏ Edit
//                                     </button>
//                                     <button
//                                       onClick={async () => {
//                                         await axios.post(`${API_URL}/copy/${item._id}`);
//                                         showAlert("✅ Copied successfully", "success");
//                                         fetchItems();
//                                       }}
//                                       className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
//                                     >
//                                       📄 Copy
//                                     </button>
//                                     <button
//                                       onClick={() => handleDelete(item._id)}
//                                       className="block w-full px-2 py-1 text-left text-[10px] text-red-600 hover:bg-red-50"
//                                     >
//                                       🗑 Delete
//                                     </button>
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                           </td>
//                         </tr>
                        
//                         {/* Expanded Details Row */}
//                         {isExpanded && (
//                           <tr className="bg-blue-50 border-t border-blue-100">
//                             <td colSpan="12" className="px-2 py-3">
//                               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Product Details</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Name:</div>
//                                     <div className="font-medium">{item.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Category:</div>
//                                     <div className="font-medium">{item.category?.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Subcategory:</div>
//                                     <div className="font-medium">{item.subcategory?.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Description:</div>
//                                     <div className="font-medium col-span-1">{item.description || "N/A"}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Price Details</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Base Price:</div>
//                                     <div className="font-medium">₹{item.basePrice?.toFixed(2) || "0.00"}</div>
                                    
//                                     <div className="text-gray-600">Profit/Loss:</div>
//                                     <div className={`font-medium ${item.profitLoss >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                       {item.profitLoss >= 0 ? '+' : ''}₹{item.profitLoss?.toFixed(2) || "0.00"}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Sale Price:</div>
//                                     <div className="font-bold">₹{item.salePrice?.toFixed(2) || "0.00"}</div>
                                    
//                                     <div className="text-gray-600">Locked Price:</div>
//                                     <div className="font-medium">₹{item.lockedPrice?.toFixed(2) || "0.00"}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Status & Timing</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Status:</div>
//                                     <div>
//                                       <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}>
//                                         {item.status === "active" ? "Active" : "Inactive"}
//                                       </span>
//                                     </div>
                                    
//                                     <div className="text-gray-600">Valid Till:</div>
//                                     <div className="font-medium">{formatDate(item.validTill)}</div>
                                    
//                                     <div className="text-gray-600">Created:</div>
//                                     <div className="font-medium">{formatDate(item.createdAt)}</div>
                                    
//                                     <div className="text-gray-600">Updated:</div>
//                                     <div className="font-medium">{formatDate(item.updatedAt)}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Market Analysis</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Teji/Maddi:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       {tejiMaddi.type === 'positive' ? '▲ Teji' : 
//                                        tejiMaddi.type === 'negative' ? '▼ Maddi' : 'Neutral'}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Change Value:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       ₹{tejiMaddi.value.toFixed(2)}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Change %:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       {item.lockedPrice > 0 
//                                         ? ((tejiMaddi.value / item.lockedPrice) * 100).toFixed(2) + '%'
//                                         : '0.00%'}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Image:</div>
//                                     <div>
//                                       {item.image ? (
//                                         <a 
//                                           href={item.image} 
//                                           target="_blank" 
//                                           rel="noopener noreferrer"
//                                           className="text-blue-600 hover:underline text-[10px]"
//                                         >
//                                           View Image
//                                         </a>
//                                       ) : (
//                                         <span className="text-gray-400">No Image</span>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
                              
//                               <div className="mt-2 pt-2 border-t border-blue-200">
//                                 <button
//                                   onClick={() => toggleRowExpand(item._id)}
//                                   className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
//                                 >
//                                   <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7"></path>
//                                   </svg>
//                                   Collapse Details
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         )}
//                       </React.Fragment>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div className="px-2 py-1.5 border-t bg-gray-50">
//                 <div className="flex items-center justify-between">
//                   <div className="text-[10px] text-gray-600">
//                     Page {currentPage} of {totalPages}
//                   </div>
//                   <div className="flex gap-1">
//                     <button
//                       onClick={() => setCurrentPage((p) => p - 1)}
//                       disabled={currentPage === 1}
//                       className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center"
//                     >
//                       ←
//                     </button>
//                     {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                       let pageNum;
//                       if (totalPages <= 5) pageNum = i + 1;
//                       else if (currentPage <= 3) pageNum = i + 1;
//                       else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
//                       else pageNum = currentPage - 2 + i;
                      
//                       if (pageNum < 1 || pageNum > totalPages) return null;
                      
//                       return (
//                         <button
//                           key={i}
//                           onClick={() => setCurrentPage(pageNum)}
//                           className={`w-6 h-6 flex items-center justify-center rounded text-xs ${
//                             currentPage === pageNum
//                               ? "bg-blue-600 text-white"
//                               : "border hover:bg-gray-50"
//                           }`}
//                         >
//                           {pageNum}
//                         </button>
//                       );
//                     })}
//                     <button
//                       onClick={() => setCurrentPage((p) => p + 1)}
//                       disabled={currentPage === totalPages}
//                       className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center"
//                     >
//                       →
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {/* Category Modal */}
//       {showCategoryModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50">
//           <div className="bg-white rounded-lg p-3 max-w-xs w-full">
//             <h3 className="font-bold mb-2 text-sm">Add Category</h3>
//             <input
//               type="text"
//               value={newCategoryName}
//               onChange={(e) => setNewCategoryName(e.target.value)}
//               placeholder="Category Name"
//               className="w-full px-1.5 py-1 border rounded mb-2 text-sm"
//               autoFocus
//             />
//             <div className="flex gap-1.5">
//               <button
//                 onClick={handleAddCategory}
//                 disabled={categoryLoading}
//                 className="flex-1 px-1.5 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700 disabled:opacity-50"
//               >
//                 {categoryLoading ? "Saving..." : "Save"}
//               </button>
//               <button
//                 onClick={() => setShowCategoryModal(false)}
//                 className="px-1.5 py-1 border rounded text-sm hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Alert */}
//       {alertBox.show && (
//         <div className="fixed bottom-3 right-3 z-50">
//           <div className={`px-3 py-2 rounded-lg shadow-lg text-xs ${
//             alertBox.type === 'success' ? 'bg-green-100 text-green-800 border border-green-200' :
//             alertBox.type === 'error' ? 'bg-red-100 text-red-800 border border-red-200' :
//             'bg-yellow-100 text-yellow-800 border border-yellow-200'
//           }`}>
//             {alertBox.message}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// // import { API_URL, CATEGORY_URL } from "../config";

// export default function PriceList() {
//   const [items, setItems] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [activeMenu, setActiveMenu] = useState(null);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [bulkMode, setBulkMode] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [filterCategory, setFilterCategory] = useState("");
//   const [filterSubcategory, setFilterSubcategory] = useState("");
//   const [filterSubs, setFilterSubs] = useState([]);
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [newCategoryName, setNewCategoryName] = useState("");
//   const [categoryLoading, setCategoryLoading] = useState(false);
//   const [sortOrder, setSortOrder] = useState("");
//   const [quickBasePrices, setQuickBasePrices] = useState({});
//   const [quickProfitLoss, setQuickProfitLoss] = useState({});
//   const [alertBox, setAlertBox] = useState({
//     show: false,
//     message: "",
//     type: "success",
//   });
//   const [expandedRows, setExpandedRows] = useState({}); // New state for expanded rows

//   const itemsPerPage = 20;

//   const [form, setForm] = useState({
//     name: "",
//     category: "",
//     subcategory: "",
//     description: "",
//     basePrice: "",
//     profitLoss: "",
//     validTill: "",
//     file: null,
//     status: "inactive",
//   });

//   // Alert timeout
//   useEffect(() => {
//     if (alertBox.show) {
//       const timer = setTimeout(() => {
//         setAlertBox((prev) => ({ ...prev, show: false }));
//       }, 2500);
//       return () => clearTimeout(timer);
//     }
//   }, [alertBox.show]);

//   // Initial fetch
//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     if (categories.length > 0) fetchItems();
//   }, [categories]);

//   // Filter subcategories
//   useEffect(() => {
//     if (!filterCategory) {
//       setFilterSubs([]);
//       setFilterSubcategory("");
//       return;
//     }
//     const cat = categories.find((c) => c._id === filterCategory);
//     setFilterSubs(cat?.subcategories || []);
//     setFilterSubcategory("");
//   }, [filterCategory, categories]);

//   // Form subcategories
//   const formSubcategories = form.category
//     ? categories.find((c) => c._id === form.category)?.subcategories || []
//     : [];

//   // Fetch categories
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(CATEGORY_URL);
//       if (res.data?.success) setCategories(res.data.categories || []);
//     } catch (err) {
//       console.error("Fetch categories error", err);
//       showAlert("❌ Could not fetch categories", "error");
//     }
//   };

//   // Fetch items
//   const fetchItems = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(API_URL);
//       if (res.data?.success) {
//         const raw = res.data.data || [];
//         const enriched = raw.map((item) => {
//           const catObj = categories.find((c) => c._id === (item.category?._id || item.category));
//           let subObj = null;

//           if (catObj?.subcategories && item.subcategory) {
//             const subId = item.subcategory?.id || item.subcategory?._id || item.subcategory;
//             subObj = catObj.subcategories.find((s) => s._id === subId) || null;
//           }

//           return {
//             ...item,
//             basePrice: Number(item.basePrice || 0),
//             profitLoss: Number(item.profitLoss || 0),
//             salePrice: Number(item.salePrice || 0),
//             lockedPrice: Number(item.lockedPrice || 0),
//             category: catObj ? { _id: catObj._id, name: catObj.name } : (item.category || null),
//             subcategory: subObj
//               ? { _id: subObj._id, name: subObj.name }
//               : item.subcategory?.id
//               ? { _id: item.subcategory.id, name: item.subcategory.name }
//               : item.subcategory || null,
//           };
//         });

//         setItems(enriched.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
//       }
//     } catch (err) {
//       console.error("Fetch items error", err);
//       showAlert("❌ Could not fetch items", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Helper to show alerts
//   const showAlert = (message, type) => {
//     setAlertBox({ show: true, message, type });
//   };

//   // Toggle row expansion
//   const toggleRowExpand = (id) => {
//     setExpandedRows(prev => ({
//       ...prev,
//       [id]: !prev[id]
//     }));
//   };

//   // Handle form changes
//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files?.length) {
//       setForm((p) => ({ ...p, file: files[0] }));
//     } else {
//       setForm((p) => ({ ...p, [name]: value }));
//     }
//   };

//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Duplicate check
//     const nameExists = items.some(
//       (p) =>
//         p.name.trim().toLowerCase() === form.name.trim().toLowerCase() &&
//         p._id !== editId
//     );

//     if (nameExists) {
//       showAlert("❌ Product name already exists!", "error");
//       setLoading(false);
//       return;
//     }

//     if (!form.name || !form.category || !form.basePrice) {
//       showAlert("❌ Name, category & base price are required", "error");
//       setLoading(false);
//       return;
//     }

//     try {
//       const fd = new FormData();
//       fd.append("name", form.name.trim());
//       fd.append("category", form.category);

//       if (form.subcategory) {
//         const sub = formSubcategories.find((s) => s._id === form.subcategory);
//         if (sub) {
//           fd.append(
//             "subcategory",
//             JSON.stringify({
//               id: sub._id,
//               name: sub.name,
//               image: sub.image || ""
//             })
//           );
//         }
//       } else {
//         fd.append("subcategory", JSON.stringify(null));
//       }

//       fd.append("basePrice", form.basePrice);
//       fd.append("profitLoss", form.profitLoss || 0);
//       if (form.description) fd.append("description", form.description);
//       if (form.validTill) fd.append("validTill", form.validTill);
//       fd.append("status", form.status);
//       if (form.file) fd.append("file", form.file);

//       if (editId) {
//         await axios.put(`${API_URL}/${editId}`, fd);
//         showAlert("✅ Product updated successfully", "success");
//       } else {
//         await axios.post(API_URL, fd);
//         showAlert("✅ Product added successfully", "success");
//       }

//       await fetchItems();
//       resetForm();
//     } catch (err) {
//       console.error("Save error", err);
//       showAlert("❌ Save failed!", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Reset form
//   const resetForm = () => {
//     setForm({
//       name: "",
//       category: "",
//       subcategory: "",
//       description: "",
//       basePrice: "",
//       profitLoss: "",
//       validTill: "",
//       file: null,
//       status: "inactive",
//     });
//     setEditId(null);
//     setShowForm(false);
//   };

//   // Add category
//   const handleAddCategory = async () => {
//     if (!newCategoryName.trim()) {
//       showAlert("❌ Category name is required", "error");
//       return;
//     }

//     try {
//       setCategoryLoading(true);
//       const res = await axios.post(CATEGORY_URL, {
//         name: newCategoryName.trim(),
//       });

//       if (res.data?.success) {
//         showAlert("✅ Category added successfully", "success");
//         setNewCategoryName("");
//         setShowCategoryModal(false);
//         await fetchCategories();
//       } else {
//         showAlert("❌ Category add failed", "error");
//       }
//     } catch (err) {
//       console.error("Add category error", err);
//       showAlert("❌ Error while adding category", "error");
//     } finally {
//       setCategoryLoading(false);
//     }
//   };

//   // Edit item
//   const handleEdit = (item) => {
//     setForm({
//       name: item.name || "",
//       category: item.category?._id?.toString() || "",
//       subcategory: item.subcategory?._id || "",
//       description: item.description || "",
//       basePrice: item.basePrice || "",
//       profitLoss: item.profitLoss || 0,
//       validTill: item.validTill ? item.validTill.split("T")[0] : "",
//       file: null,
//       status: item.status || "inactive",
//     });

//     setEditId(item._id);
//     setShowForm(true);
//     setActiveMenu(null);
//   };

//   // Delete item
//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this item?")) return;
//     try {
//       await axios.delete(`${API_URL}/${id}`);
//       setItems((prev) => prev.filter((x) => x._id !== id));
//       setSelectedItems((prev) => prev.filter((x) => x !== id));
//       setActiveMenu(null);
//       showAlert("✅ Item deleted successfully", "success");
//     } catch (err) {
//       console.error("Delete error", err);
//       showAlert("❌ Delete failed", "error");
//     }
//   };

//   // Toggle status
//   const handleStatusToggle = async (item) => {
//     try {
//       const newStatus = item.status === "active" ? "inactive" : "active";
//       await axios.put(`${API_URL}/status/${item._id}`, { status: newStatus });
//       setItems((prev) => prev.map((x) => (x._id === item._id ? { ...x, status: newStatus } : x)));
//     } catch (err) {
//       console.error("Status toggle error", err);
//       showAlert("❌ Status update failed", "error");
//     }
//   };

//   // Handle bulk item data change
//   const handleBulkItemChange = (id, field, value) => {
//     setItems(prevItems => prevItems.map(item => {
//       if (item._id === id) {
//         const newItem = { ...item, [field]: value };
//         // Recalculate sale price for display
//         if (field === 'basePrice' || field === 'profitLoss') {
//           const base = Number(newItem.basePrice || 0);
//           const profit = Number(newItem.profitLoss || 0);
//           newItem.salePrice = base + profit;
//         }
//         return newItem;
//       }
//       return item;
//     }));
//   };

//   // Bulk save
//   const handleBulkSave = async () => {
//     if (!selectedItems.length) {
//       showAlert("❌ No items selected", "error");
//       return;
//     }

//     const updates = items
//       .filter((x) => selectedItems.includes(x._id))
//       .map((x) => ({
//         id: x._id,
//         basePrice: Number(x.basePrice),
//         profitLoss: Number(x.profitLoss),
//         status: x.status,
//       }));

//     try {
//       await axios.post(`${API_URL}/bulk-update`, { products: updates });
//       showAlert("✅ Bulk save successful", "success");
//       setBulkMode(false);
//       setSelectedItems([]);
//       fetchItems();
//     } catch (err) {
//       console.error("Bulk save error", err);
//       showAlert("❌ Bulk save failed", "error");
//     }
//   };

//   // Bulk delete
//   const handleBulkDelete = async () => {
//     if (!selectedItems.length) {
//       showAlert("❌ No items selected", "error");
//       return;
//     }
//     if (!window.confirm("Delete selected items?")) return;

//     try {
//       await Promise.all(selectedItems.map((id) => axios.delete(`${API_URL}/${id}`)));
//       setSelectedItems([]);
//       fetchItems();
//       setBulkMode(false);
//       showAlert("✅ Bulk delete successful", "success");
//     } catch (err) {
//       console.error("Bulk delete error", err);
//       showAlert("❌ Bulk delete failed", "error");
//     }
//   };

//   // Update Base Price inline
//   const updateBasePrice = async (item) => {
//     const newBase = Number(quickBasePrices[item._id] ?? item.basePrice);
//     if (isNaN(newBase)) {
//       showAlert("❌ Invalid Base Price", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const fd = new FormData();
//       fd.append("name", item.name);
//       fd.append("category", item.category?._id);
//       if (item.subcategory?.id) fd.append("subcategory", item.subcategory.id);
//       fd.append("description", item.description || "");
//       fd.append("basePrice", newBase);
//       fd.append("profitLoss", item.profitLoss);
//       fd.append("status", item.status);

//       const res = await axios.put(`${API_URL}/${item._id}`, fd);
//       if (res.data.success) {
//         await fetchItems();
//         setQuickBasePrices((p) => ({ ...p, [item._id]: undefined }));
//         showAlert("✅ Base price updated", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       showAlert("❌ Update failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update Profit/Loss inline with current value calculation
//   const updateProfitLoss = async (item) => {
//     const currentValue = Number(quickProfitLoss[item._id] ?? 0);
//     if (isNaN(currentValue)) {
//       showAlert("❌ Invalid Current value", "error");
//       return;
//     }

//     // Calculate new profit/loss: current value is (sale price - base price)
//     const newProfitLoss = currentValue;
//     const newSalePrice = item.basePrice + newProfitLoss;

//     try {
//       setLoading(true);
//       const fd = new FormData();
//       fd.append("name", item.name);
//       fd.append("category", item.category?._id);
//       if (item.subcategory?.id) fd.append("subcategory", item.subcategory.id);
//       fd.append("description", item.description || "");
//       fd.append("basePrice", item.basePrice);
//       fd.append("profitLoss", newProfitLoss);
//       fd.append("status", item.status);

//       const res = await axios.put(`${API_URL}/${item._id}`, fd);
//       if (res.data.success) {
//         await fetchItems();
//         setQuickProfitLoss((p) => ({ ...p, [item._id]: undefined }));
//         showAlert("✅ Profit/Loss updated", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       showAlert("❌ Update failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Filter items
//   const filteredItems = items.filter((item) => {
//     const t = search.toLowerCase();
//     const matchText =
//       (item.name || "").toLowerCase().includes(t) ||
//       (item.category?.name || "").toLowerCase().includes(t) ||
//       (item.subcategory?.name || "").toLowerCase().includes(t);

//     const matchCategory = !filterCategory || item.category?._id === filterCategory;
//     const matchSub = !filterSubcategory || item.subcategory?._id === filterSubcategory;

//     return matchText && matchCategory && matchSub;
//   });

//   // Sorting
//   let sortedItems = [...filteredItems];
//   if (sortOrder === "low") {
//     sortedItems.sort((a, b) => (Number(a.salePrice) || 0) - (Number(b.salePrice) || 0));
//   } else if (sortOrder === "high") {
//     sortedItems.sort((a, b) => (Number(b.salePrice) || 0) - (Number(a.salePrice) || 0));
//   }

//   // Pagination
//   const indexOfLast = currentPage * itemsPerPage;
//   const currentItems = sortedItems.slice(indexOfLast - itemsPerPage, indexOfLast);
//   const totalPages = Math.max(1, Math.ceil(sortedItems.length / itemsPerPage));

//   // Truncate text
//   const truncate = (text, maxLength = 20) => {
//     if (!text) return "";
//     if (text.length <= maxLength) return text;
//     return text.substring(0, maxLength) + '...';
//   };

//   // Get Teji/Maddi
//   const getTejiMaddi = (item) => {
//     if (item.lockedPrice === 0) return { value: 0, type: "neutral" };
//     const teji = item.salePrice - item.lockedPrice;
//     return {
//       value: Math.abs(teji),
//       type: teji >= 0 ? "positive" : "negative"
//     };
//   };

//   // Get status color
//   const getStatusColor = (status) => {
//     return status === "active" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric'
//     });
//   };

//   // Calculate current value (Sale Price - Base Price)
//   const calculateCurrentValue = (item) => {
//     return item.salePrice - item.basePrice;
//   };

//   // Handle quick profit/loss input change
//   const handleQuickProfitLossChange = (id, value) => {
//     setQuickProfitLoss((p) => ({ ...p, [id]: value }));
    
//     // Update the item's sale price in local state for immediate feedback
//     setItems(prevItems => prevItems.map(item => {
//       if (item._id === id) {
//         const currentValue = Number(value) || 0;
//         const newSalePrice = item.basePrice + currentValue;
//         return { ...item, salePrice: newSalePrice };
//       }
//       return item;
//     }));
//   };

//   return (
//     <>
//       {/* Header */}
//       <div className="mb-2">
//         <h1 className="text-xl font-bold text-gray-800">Product Management</h1>
//         <p className="text-gray-600 text-sm">Total: {filteredItems.length} items</p>
//       </div>

//       {/* Top Controls */}
//       <div className="bg-white rounded-lg shadow p-2 mb-2">
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-1.5 mb-2">
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               setCurrentPage(1);
//             }}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm col-span-2 md:col-span-1"
//           />

//           <select
//             value={filterCategory}
//             onChange={(e) => setFilterCategory(e.target.value)}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm"
//           >
//             <option value="">All Categories</option>
//             {categories.map((c) => (
//               <option key={c._id} value={c._id}>{c.name}</option>
//             ))}
//           </select>

//           <select
//             value={filterSubcategory}
//             onChange={(e) => setFilterSubcategory(e.target.value)}
//             disabled={!filterSubs.length}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm disabled:opacity-50"
//           >
//             <option value="">All Subcategories</option>
//             {filterSubs.map((s) => (
//               <option key={s._id} value={s._id}>{s.name}</option>
//             ))}
//           </select>

//           <select
//             value={sortOrder}
//             onChange={(e) => setSortOrder(e.target.value)}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm"
//           >
//             <option value="">Default Sort</option>
//             <option value="low">Price: Low → High</option>
//             <option value="high">Price: High → Low</option>
//           </select>

//           <button
//             onClick={() => {
//               setShowForm(!showForm);
//               if (showForm) resetForm();
//             }}
//             className="px-1.5 py-1 bg-blue-600 text-white rounded text-xs md:text-sm font-medium hover:bg-blue-700"
//           >
//             {showForm ? "Cancel Add" : "Add Product"}
//           </button>
//         </div>

//         {/* Action Buttons */}
//         <div className="flex flex-wrap gap-1.5">
//           <button
//             onClick={() => window.open(`${API_URL}/export`, "_blank")}
//             className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50"
//           >
//             Export CSV
//           </button>

//           <label className="cursor-pointer">
//             <input
//               type="file"
//               accept=".csv"
//               className="hidden"
//               onChange={async (e) => {
//                 try {
//                   const fd = new FormData();
//                   fd.append("file", e.target.files[0]);
//                   await axios.post(`${API_URL}/import`, fd);
//                   showAlert("✅ Imported successfully", "success");
//                   fetchItems();
//                 } catch (err) {
//                   showAlert("❌ Import failed", "error");
//                 }
//               }}
//             />
//             <span className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50">
//               Import CSV
//             </span>
//           </label>

//           <button
//             onClick={() => setShowCategoryModal(true)}
//             className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//           >
//             Add Category
//           </button>
//         </div>
//       </div>

//       {/* Bulk Actions */}
//       {selectedItems.length > 0 && (
//         <div className="bg-yellow-50 border border-yellow-200 rounded p-1.5 mb-2">
//           <div className="flex items-center justify-between">
//             <span className="font-medium text-xs md:text-sm">{selectedItems.length} selected</span>
//             <div className="flex gap-1.5">
//               <button
//                 onClick={handleBulkDelete}
//                 className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
//               >
//                 Bulk Delete
//               </button>
//               <button
//                 onClick={() => setBulkMode(!bulkMode)}
//                 className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
//               >
//                 {bulkMode ? "Cancel Edit" : "Bulk Edit"}
//               </button>
//               {bulkMode && (
//                 <button
//                   onClick={handleBulkSave}
//                   className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//                 >
//                   Save All
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Bulk Edit Panel */}
//           {bulkMode && (
//             <div className="mt-2 pt-2 border-t border-yellow-200">
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
//                 {items
//                   .filter((item) => selectedItems.includes(item._id))
//                   .map((item) => (
//                     <div key={item._id} className="bg-white rounded p-2 border">
//                       <h4 className="font-semibold text-xs mb-1 truncate">{truncate(item.name, 15)}</h4>
//                       <div className="space-y-1">
//                         <div>
//                           <label className="block text-[10px] text-gray-600 mb-0.5">Base Price</label>
//                           <input
//                             type="number"
//                             value={item.basePrice}
//                             onChange={(e) => handleBulkItemChange(item._id, 'basePrice', e.target.value)}
//                             className="w-full px-1 py-0.5 border rounded text-xs"
//                           />
//                         </div>
//                         <div>
//                           <label className="block text-[10px] text-gray-600 mb-0.5">Profit/Loss</label>
//                           <input
//                             type="number"
//                             value={item.profitLoss}
//                             onChange={(e) => handleBulkItemChange(item._id, 'profitLoss', e.target.value)}
//                             className="w-full px-1 py-0.5 border rounded text-xs"
//                           />
//                         </div>
//                         <div>
//                           <label className="block text-[10px] text-gray-600 mb-0.5">Status</label>
//                           <select
//                             value={item.status}
//                             onChange={(e) => handleBulkItemChange(item._id, 'status', e.target.value)}
//                             className="w-full px-1 py-0.5 border rounded text-xs"
//                           >
//                             <option value="active">Active</option>
//                             <option value="inactive">Inactive</option>
//                           </select>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Add/Edit Form */}
//       {showForm && (
//         <div className="bg-white rounded-lg shadow p-2 mb-2">
//           <h3 className="font-bold mb-1.5 text-sm">{editId ? "Edit Product" : "Add New Product"}</h3>
//           <form onSubmit={handleSubmit}>
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 mb-2">
//               <input
//                 required
//                 name="name"
//                 placeholder="Product Name"
//                 value={form.name}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <div className="flex gap-1">
//                 <select
//                   required
//                   name="category"
//                   value={form.category}
//                   onChange={handleChange}
//                   className="flex-1 px-1.5 py-1 border rounded text-xs"
//                 >
//                   <option value="">Select Category</option>
//                   {categories.map((c) => (
//                     <option key={c._id} value={c._id}>{c.name}</option>
//                   ))}
//                 </select>
//                 <button
//                   type="button"
//                   onClick={() => setShowCategoryModal(true)}
//                   className="px-1.5 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//                 >
//                   +
//                 </button>
//               </div>

//               <select
//                 name="subcategory"
//                 value={form.subcategory}
//                 onChange={handleChange}
//                 disabled={!formSubcategories.length}
//                 className="px-1.5 py-1 border rounded text-xs disabled:opacity-50"
//               >
//                 <option value="">Select Subcategory</option>
//                 {formSubcategories.map((s) => (
//                   <option key={s._id} value={s._id}>{s.name}</option>
//                 ))}
//               </select>

//               <input
//                 type="number"
//                 required
//                 name="basePrice"
//                 placeholder="Base Price"
//                 value={form.basePrice}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <input
//                 type="number"
//                 name="profitLoss"
//                 placeholder="Profit/Loss"
//                 value={form.profitLoss}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <input
//                 type="date"
//                 name="validTill"
//                 value={form.validTill}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <select
//                 name="status"
//                 value={form.status}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               >
//                 <option value="active">Active</option>
//                 <option value="inactive">Inactive</option>
//               </select>

//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs text-[10px]"
//               />
//             </div>

//             <div className="mb-2">
//               <textarea
//                 name="description"
//                 placeholder="Description (optional)"
//                 value={form.description}
//                 onChange={handleChange}
//                 rows="2"
//                 className="w-full px-1.5 py-1 border rounded text-xs"
//               />
//             </div>

//             <div className="flex gap-1.5">
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="flex-1 px-1.5 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 disabled:opacity-50"
//               >
//                 {loading ? "Saving..." : (editId ? "Update" : "Save")}
//               </button>
//               <button
//                 type="button"
//                 onClick={resetForm}
//                 className="px-1.5 py-1 border rounded text-xs hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Products Table */}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         {loading ? (
//           <div className="p-4 text-center">
//             <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
//             <p className="mt-2 text-xs text-gray-600">Loading...</p>
//           </div>
//         ) : filteredItems.length === 0 ? (
//           <div className="p-4 text-center text-gray-500 text-sm">
//             No products found
//           </div>
//         ) : (
//           <>
//             <div className="overflow-x-auto">
//               <table className="min-w-full text-xs">
//                 <thead className="bg-gray-100">
//                   <tr>
//                     <th className="px-1 py-1 text-left w-6">
//                       <input
//                         type="checkbox"
//                         checked={selectedItems.length === filteredItems.length && filteredItems.length > 0}
//                         onChange={() => {
//                           if (selectedItems.length === filteredItems.length) setSelectedItems([]);
//                           else setSelectedItems(filteredItems.map((x) => x._id));
//                         }}
//                         className="rounded w-3 h-3"
//                       />
//                     </th>
//                     <th className="px-1.5 py-1 text-left font-medium w-6">#</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-10">Img</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/4">Product</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/5">Category</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Base Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">P/L</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Sale Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Lock Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Teji/Maddi</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Status</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/12">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-200">
//                   {currentItems.map((item, i) => {
//                     const tejiMaddi = getTejiMaddi(item);
//                     const isExpanded = expandedRows[item._id];
//                     const currentValue = calculateCurrentValue(item);
//                     const displayProfitLoss = item.profitLoss || 0;
                    
//                     return (
//                       <React.Fragment key={item._id}>
//                         <tr className="hover:bg-gray-50 align-top">
//                           <td className="px-1 py-1.5">
//                             <input
//                               type="checkbox"
//                               checked={selectedItems.includes(item._id)}
//                               onChange={() =>
//                                 setSelectedItems((prev) =>
//                                   prev.includes(item._id)
//                                     ? prev.filter((x) => x !== item._id)
//                                     : [...prev, item._id]
//                                 )
//                               }
//                               className="rounded w-3 h-3"
//                             />
//                           </td>
//                           <td className="px-1.5 py-1.5 text-xs text-gray-500">
//                             {(currentPage - 1) * itemsPerPage + (i + 1)}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             {item.image ? (
//                               <img src={item.image} alt={item.name} className="w-8 h-8 rounded object-cover" />
//                             ) : (
//                               <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center">
//                                 <span className="text-[8px] text-gray-400">No Img</span>
//                               </div>
//                             )}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="font-medium text-xs" title={item.name}>
//                               {truncate(item.name, 15)}
//                             </div>
//                             <div className="text-[10px] text-gray-500">
//                               {truncate(item.subcategory?.name || "No sub", 12)}
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <span className="text-[10px] px-1 py-0.5 bg-gray-100 rounded">
//                               {truncate(item.category?.name || "-", 10)}
//                             </span>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex items-center gap-1">
//                               <input
//                                 type="number"
//                                 value={quickBasePrices[item._id] !== undefined ? quickBasePrices[item._id] : item.basePrice}
//                                 onChange={(e) => setQuickBasePrices((p) => ({ ...p, [item._id]: e.target.value }))}
//                                 className="w-16 px-1 py-0.5 border rounded text-xs h-6"
//                               />
//                               <button
//                                 onClick={() => updateBasePrice(item)}
//                                 className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
//                               >
//                                 ✔
//                               </button>
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex flex-col">
//                               {/* Current profit/loss display */}
//                               <div className="text-[10px] text-gray-600 mb-0.5">
//                                 {displayProfitLoss >= 0 ? '+' : ''}{displayProfitLoss.toFixed(2)}
//                               </div>
//                               {/* Current value input */}
//                               <div className="flex items-center gap-1">
//                                 <input
//                                   type="number"
//                                   placeholder="Change"
//                                   value={quickProfitLoss[item._id] !== undefined ? quickProfitLoss[item._id] : ''}
//                                   onChange={(e) => handleQuickProfitLossChange(item._id, e.target.value)}
//                                   className="w-16 px-1 py-0.5 border rounded text-xs h-6"
//                                 />
//                                 <button
//                                   onClick={() => updateProfitLoss(item)}
//                                   className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
//                                 >
//                                   ✔
//                                 </button>
//                               </div>
//                               {/* Current value display */}
//                               <div className="text-[9px] text-gray-500 mt-0.5">
//                                 Current: {currentValue >= 0 ? '+' : ''}{currentValue.toFixed(2)}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5 font-bold text-xs">
//                             ₹{item.salePrice.toFixed(2)}
//                           </td>
//                           <td className="px-1.5 py-1.5 text-xs">
//                             ₹{item.lockedPrice.toFixed(2)}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <span className={`text-xs font-medium ${
//                               tejiMaddi.type === 'positive' ? 'text-green-600' :
//                               tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                             }`}>
//                               {tejiMaddi.type === 'positive' ? '▲' : tejiMaddi.type === 'negative' ? '▼' : ''}
//                               ₹{tejiMaddi.value.toFixed(2)}
//                             </span>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <button
//                               onClick={() => handleStatusToggle(item)}
//                               className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}
//                             >
//                               {item.status === "active" ? "Active" : "Inactive"}
//                             </button>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex gap-1">
//                               <button
//                                 onClick={() => toggleRowExpand(item._id)}
//                                 className={`w-6 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50 ${
//                                   isExpanded ? 'bg-blue-50 text-blue-600' : ''
//                                 }`}
//                                 title={isExpanded ? "Collapse Details" : "Expand Details"}
//                               >
//                                 {isExpanded ? '−' : '+'}
//                               </button>
//                               <div className="relative">
//                                 <button
//                                   onClick={() => setActiveMenu(activeMenu === item._id ? null : item._id)}
//                                   className="w-5 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50"
//                                 >
//                                   ⋮
//                                 </button>
//                                 {activeMenu === item._id && (
//                                   <div className="absolute right-0 mt-1 w-24 bg-white border rounded shadow-lg z-10">
//                                     <button
//                                       onClick={() => handleEdit(item)}
//                                       className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
//                                     >
//                                       ✏ Edit
//                                     </button>
//                                     <button
//                                       onClick={async () => {
//                                         await axios.post(`${API_URL}/copy/${item._id}`);
//                                         showAlert("✅ Copied successfully", "success");
//                                         fetchItems();
//                                       }}
//                                       className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
//                                     >
//                                       📄 Copy
//                                     </button>
//                                     <button
//                                       onClick={() => handleDelete(item._id)}
//                                       className="block w-full px-2 py-1 text-left text-[10px] text-red-600 hover:bg-red-50"
//                                     >
//                                       🗑 Delete
//                                     </button>
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                           </td>
//                         </tr>
                        
//                         {/* Expanded Details Row */}
//                         {isExpanded && (
//                           <tr className="bg-blue-50 border-t border-blue-100">
//                             <td colSpan="12" className="px-2 py-3">
//                               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Product Details</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Name:</div>
//                                     <div className="font-medium">{item.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Category:</div>
//                                     <div className="font-medium">{item.category?.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Subcategory:</div>
//                                     <div className="font-medium">{item.subcategory?.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Description:</div>
//                                     <div className="font-medium col-span-1">{item.description || "N/A"}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Price Details</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Base Price:</div>
//                                     <div className="font-medium">₹{item.basePrice?.toFixed(2) || "0.00"}</div>
                                    
//                                     <div className="text-gray-600">Profit/Loss:</div>
//                                     <div className={`font-medium ${item.profitLoss >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                       {item.profitLoss >= 0 ? '+' : ''}₹{item.profitLoss?.toFixed(2) || "0.00"}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Current (Sale - Base):</div>
//                                     <div className={`font-medium ${currentValue >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                       {currentValue >= 0 ? '+' : ''}₹{currentValue?.toFixed(2) || "0.00"}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Sale Price:</div>
//                                     <div className="font-bold">₹{item.salePrice?.toFixed(2) || "0.00"}</div>
                                    
//                                     <div className="text-gray-600">Locked Price:</div>
//                                     <div className="font-medium">₹{item.lockedPrice?.toFixed(2) || "0.00"}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Status & Timing</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Status:</div>
//                                     <div>
//                                       <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}>
//                                         {item.status === "active" ? "Active" : "Inactive"}
//                                       </span>
//                                     </div>
                                    
//                                     <div className="text-gray-600">Valid Till:</div>
//                                     <div className="font-medium">{formatDate(item.validTill)}</div>
                                    
//                                     <div className="text-gray-600">Created:</div>
//                                     <div className="font-medium">{formatDate(item.createdAt)}</div>
                                    
//                                     <div className="text-gray-600">Updated:</div>
//                                     <div className="font-medium">{formatDate(item.updatedAt)}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Market Analysis</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Teji/Maddi:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       {tejiMaddi.type === 'positive' ? '▲ Teji' : 
//                                        tejiMaddi.type === 'negative' ? '▼ Maddi' : 'Neutral'}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Change Value:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       ₹{tejiMaddi.value.toFixed(2)}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Change %:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       {item.lockedPrice > 0 
//                                         ? ((tejiMaddi.value / item.lockedPrice) * 100).toFixed(2) + '%'
//                                         : '0.00%'}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Image:</div>
//                                     <div>
//                                       {item.image ? (
//                                         <a 
//                                           href={item.image} 
//                                           target="_blank" 
//                                           rel="noopener noreferrer"
//                                           className="text-blue-600 hover:underline text-[10px]"
//                                         >
//                                           View Image
//                                         </a>
//                                       ) : (
//                                         <span className="text-gray-400">No Image</span>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
                              
//                               <div className="mt-2 pt-2 border-t border-blue-200">
//                                 <button
//                                   onClick={() => toggleRowExpand(item._id)}
//                                   className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
//                                 >
//                                   <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7"></path>
//                                   </svg>
//                                   Collapse Details
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         )}
//                       </React.Fragment>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div className="px-2 py-1.5 border-t bg-gray-50">
//                 <div className="flex items-center justify-between">
//                   <div className="text-[10px] text-gray-600">
//                     Page {currentPage} of {totalPages}
//                   </div>
//                   <div className="flex gap-1">
//                     <button
//                       onClick={() => setCurrentPage((p) => p - 1)}
//                       disabled={currentPage === 1}
//                       className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center"
//                     >
//                       ←
//                     </button>
//                     {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                       let pageNum;
//                       if (totalPages <= 5) pageNum = i + 1;
//                       else if (currentPage <= 3) pageNum = i + 1;
//                       else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
//                       else pageNum = currentPage - 2 + i;
                      
//                       if (pageNum < 1 || pageNum > totalPages) return null;
                      
//                       return (
//                         <button
//                           key={i}
//                           onClick={() => setCurrentPage(pageNum)}
//                           className={`w-6 h-6 flex items-center justify-center rounded text-xs ${
//                             currentPage === pageNum
//                               ? "bg-blue-600 text-white"
//                               : "border hover:bg-gray-50"
//                           }`}
//                         >
//                           {pageNum}
//                         </button>
//                       );
//                     })}
//                     <button
//                       onClick={() => setCurrentPage((p) => p + 1)}
//                       disabled={currentPage === totalPages}
//                       className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center"
//                     >
//                       →
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {/* Category Modal */}
//       {showCategoryModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50">
//           <div className="bg-white rounded-lg p-3 max-w-xs w-full">
//             <h3 className="font-bold mb-2 text-sm">Add Category</h3>
//             <input
//               type="text"
//               value={newCategoryName}
//               onChange={(e) => setNewCategoryName(e.target.value)}
//               placeholder="Category Name"
//               className="w-full px-1.5 py-1 border rounded mb-2 text-sm"
//               autoFocus
//             />
//             <div className="flex gap-1.5">
//               <button
//                 onClick={handleAddCategory}
//                 disabled={categoryLoading}
//                 className="flex-1 px-1.5 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700 disabled:opacity-50"
//               >
//                 {categoryLoading ? "Saving..." : "Save"}
//               </button>
//               <button
//                 onClick={() => setShowCategoryModal(false)}
//                 className="px-1.5 py-1 border rounded text-sm hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Alert */}
//       {alertBox.show && (
//         <div className="fixed bottom-3 right-3 z-50">
//           <div className={`px-3 py-2 rounded-lg shadow-lg text-xs ${
//             alertBox.type === 'success' ? 'bg-green-100 text-green-800 border border-green-200' :
//             alertBox.type === 'error' ? 'bg-red-100 text-red-800 border border-red-200' :
//             'bg-yellow-100 text-yellow-800 border border-yellow-200'
//           }`}>
//             {alertBox.message}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }





























// import React, { useState, useEffect } from "react";
// import axios from "axios";

// export default function PriceList() {
//   const [items, setItems] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [activeMenu, setActiveMenu] = useState(null);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [bulkMode, setBulkMode] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [filterCategory, setFilterCategory] = useState("");
//   const [filterSubcategory, setFilterSubcategory] = useState("");
//   const [filterSubs, setFilterSubs] = useState([]);
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [newCategoryName, setNewCategoryName] = useState("");
//   const [categoryLoading, setCategoryLoading] = useState(false);
//   const [sortOrder, setSortOrder] = useState("");
//   const [quickBasePrices, setQuickBasePrices] = useState({});
//   const [quickProfitLoss, setQuickProfitLoss] = useState({});
//   const [alertBox, setAlertBox] = useState({
//     show: false,
//     message: "",
//     type: "success",
//   });
//   const [expandedRows, setExpandedRows] = useState({});

//   const itemsPerPage = 20;

//   const [form, setForm] = useState({
//     name: "",
//     category: "",
//     subcategory: "",
//     description: "",
//     basePrice: "",
//     profitLoss: "",
//     validTill: "",
//     file: null,
//     status: "inactive",
//   });

//   // Alert timeout
//   useEffect(() => {
//     if (alertBox.show) {
//       const timer = setTimeout(() => {
//         setAlertBox((prev) => ({ ...prev, show: false }));
//       }, 2500);
//       return () => clearTimeout(timer);
//     }
//   }, [alertBox.show]);

//   // Initial fetch
//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     if (categories.length > 0) fetchItems();
//   }, [categories]);

//   // Filter subcategories
//   useEffect(() => {
//     if (!filterCategory) {
//       setFilterSubs([]);
//       setFilterSubcategory("");
//       return;
//     }
//     const cat = categories.find((c) => c._id === filterCategory);
//     setFilterSubs(cat?.subcategories || []);
//     setFilterSubcategory("");
//   }, [filterCategory, categories]);

//   // Form subcategories
//   const formSubcategories = form.category
//     ? categories.find((c) => c._id === form.category)?.subcategories || []
//     : [];

//   // Fetch categories
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(CATEGORY_URL);
//       if (res.data?.success) setCategories(res.data.categories || []);
//     } catch (err) {
//       console.error("Fetch categories error", err);
//       showAlert("❌ Could not fetch categories", "error");
//     }
//   };

//   // Fetch items
//   const fetchItems = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(API_URL);
//       if (res.data?.success) {
//         const raw = res.data.data || [];
//         const enriched = raw.map((item) => {
//           const catObj = categories.find((c) => c._id === (item.category?._id || item.category));
//           let subObj = null;

//           if (catObj?.subcategories && item.subcategory) {
//             const subId = item.subcategory?.id || item.subcategory?._id || item.subcategory;
//             subObj = catObj.subcategories.find((s) => s._id === subId) || null;
//           }

//           return {
//             ...item,
//             basePrice: Number(item.basePrice || 0),
//             profitLoss: Number(item.profitLoss || 0),
//             salePrice: Number(item.salePrice || 0),
//             lockedPrice: Number(item.lockedPrice || 0),
//             category: catObj ? { _id: catObj._id, name: catObj.name } : (item.category || null),
//             subcategory: subObj
//               ? { _id: subObj._id, name: subObj.name }
//               : item.subcategory?.id
//               ? { _id: item.subcategory.id, name: item.subcategory.name }
//               : item.subcategory || null,
//           };
//         });

//         setItems(enriched.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
//       }
//     } catch (err) {
//       console.error("Fetch items error", err);
//       showAlert("❌ Could not fetch items", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Helper to show alerts
//   const showAlert = (message, type) => {
//     setAlertBox({ show: true, message, type });
//   };

//   // Toggle row expansion
//   const toggleRowExpand = (id) => {
//     setExpandedRows(prev => ({
//       ...prev,
//       [id]: !prev[id]
//     }));
//   };

//   // Handle form changes
//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files?.length) {
//       setForm((p) => ({ ...p, file: files[0] }));
//     } else {
//       setForm((p) => ({ ...p, [name]: value }));
//     }
//   };

//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Duplicate check
//     const nameExists = items.some(
//       (p) =>
//         p.name.trim().toLowerCase() === form.name.trim().toLowerCase() &&
//         p._id !== editId
//     );

//     if (nameExists) {
//       showAlert("❌ Product name already exists!", "error");
//       setLoading(false);
//       return;
//     }

//     if (!form.name || !form.category || !form.basePrice) {
//       showAlert("❌ Name, category & base price are required", "error");
//       setLoading(false);
//       return;
//     }

//     try {
//       const fd = new FormData();
//       fd.append("name", form.name.trim());
//       fd.append("category", form.category);

//       if (form.subcategory) {
//         const sub = formSubcategories.find((s) => s._id === form.subcategory);
//         if (sub) {
//           fd.append(
//             "subcategory",
//             JSON.stringify({
//               id: sub._id,
//               name: sub.name,
//               image: sub.image || ""
//             })
//           );
//         }
//       } else {
//         fd.append("subcategory", JSON.stringify(null));
//       }

//       fd.append("basePrice", form.basePrice);
//       fd.append("profitLoss", form.profitLoss || 0);
//       if (form.description) fd.append("description", form.description);
//       if (form.validTill) fd.append("validTill", form.validTill);
//       fd.append("status", form.status);
//       if (form.file) fd.append("file", form.file);

//       if (editId) {
//         await axios.put(`${API_URL}/${editId}`, fd);
//         showAlert("✅ Product updated successfully", "success");
//       } else {
//         await axios.post(API_URL, fd);
//         showAlert("✅ Product added successfully", "success");
//       }

//       await fetchItems();
//       resetForm();
//     } catch (err) {
//       console.error("Save error", err);
//       showAlert("❌ Save failed!", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Reset form
//   const resetForm = () => {
//     setForm({
//       name: "",
//       category: "",
//       subcategory: "",
//       description: "",
//       basePrice: "",
//       profitLoss: "",
//       validTill: "",
//       file: null,
//       status: "inactive",
//     });
//     setEditId(null);
//     setShowForm(false);
//   };

//   // Add category
//   const handleAddCategory = async () => {
//     if (!newCategoryName.trim()) {
//       showAlert("❌ Category name is required", "error");
//       return;
//     }

//     try {
//       setCategoryLoading(true);
//       const res = await axios.post(CATEGORY_URL, {
//         name: newCategoryName.trim(),
//       });

//       if (res.data?.success) {
//         showAlert("✅ Category added successfully", "success");
//         setNewCategoryName("");
//         setShowCategoryModal(false);
//         await fetchCategories();
//       } else {
//         showAlert("❌ Category add failed", "error");
//       }
//     } catch (err) {
//       console.error("Add category error", err);
//       showAlert("❌ Error while adding category", "error");
//     } finally {
//       setCategoryLoading(false);
//     }
//   };

//   // Edit item
//   const handleEdit = (item) => {
//     setForm({
//       name: item.name || "",
//       category: item.category?._id?.toString() || "",
//       subcategory: item.subcategory?._id || "",
//       description: item.description || "",
//       basePrice: item.basePrice || "",
//       profitLoss: item.profitLoss || 0,
//       validTill: item.validTill ? item.validTill.split("T")[0] : "",
//       file: null,
//       status: item.status || "inactive",
//     });

//     setEditId(item._id);
//     setShowForm(true);
//     setActiveMenu(null);
//   };

//   // Delete item
//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this item?")) return;
//     try {
//       await axios.delete(`${API_URL}/${id}`);
//       setItems((prev) => prev.filter((x) => x._id !== id));
//       setSelectedItems((prev) => prev.filter((x) => x !== id));
//       setActiveMenu(null);
//       showAlert("✅ Item deleted successfully", "success");
//     } catch (err) {
//       console.error("Delete error", err);
//       showAlert("❌ Delete failed", "error");
//     }
//   };

//   // Toggle status
//   const handleStatusToggle = async (item) => {
//     try {
//       const newStatus = item.status === "active" ? "inactive" : "active";
//       await axios.put(`${API_URL}/status/${item._id}`, { status: newStatus });
//       setItems((prev) => prev.map((x) => (x._id === item._id ? { ...x, status: newStatus } : x)));
//     } catch (err) {
//       console.error("Status toggle error", err);
//       showAlert("❌ Status update failed", "error");
//     }
//   };

//   // Handle bulk item data change
//   const handleBulkItemChange = (id, field, value) => {
//     setItems(prevItems => prevItems.map(item => {
//       if (item._id === id) {
//         const newItem = { ...item, [field]: value };
        
//         // Handle category change - reset subcategory
//         if (field === 'category') {
//           newItem.subcategory = "";
//           // Find the category object
//           const catObj = categories.find(c => c._id === value);
//           if (catObj) {
//             newItem.category = { _id: catObj._id, name: catObj.name };
//           }
//         }
        
//         // Handle subcategory change
//         if (field === 'subcategory' && value) {
//           const catObj = categories.find(c => c._id === item.category?._id);
//           const subObj = catObj?.subcategories?.find(s => s._id === value);
//           if (subObj) {
//             newItem.subcategory = { _id: subObj._id, name: subObj.name };
//           }
//         }
        
//         // Recalculate sale price for display
//         if (field === 'basePrice' || field === 'profitLoss') {
//           const base = Number(newItem.basePrice || 0);
//           const profit = Number(newItem.profitLoss || 0);
//           newItem.salePrice = base + profit;
//         }
//         return newItem;
//       }
//       return item;
//     }));
//   };

//   // Get subcategories for a specific category
//   const getSubcategoriesForCategory = (categoryId) => {
//     if (!categoryId) return [];
//     const category = categories.find(c => c._id === categoryId);
//     return category?.subcategories || [];
//   };

//   // Bulk save
//   const handleBulkSave = async () => {
//     if (!selectedItems.length) {
//       showAlert("❌ No items selected", "error");
//       return;
//     }

//     // Prepare updates with all fields
//     const updates = items
//       .filter((x) => selectedItems.includes(x._id))
//       .map((x) => {
//         const updateData = {
//           id: x._id,
//           name: x.name,
//           basePrice: Number(x.basePrice),
//           profitLoss: Number(x.profitLoss),
//           status: x.status,
//         };

//         // Add category if changed
//         if (x.category?._id) {
//           updateData.category = x.category._id;
//         }

//         // Add subcategory if changed
//         if (x.subcategory?._id) {
//           updateData.subcategory = JSON.stringify({
//             id: x.subcategory._id,
//             name: x.subcategory.name
//           });
//         }

//         // Add description if changed
//         if (x.description !== undefined) {
//           updateData.description = x.description;
//         }

//         // Add validTill if changed
//         if (x.validTill !== undefined) {
//           updateData.validTill = x.validTill;
//         }

//         return updateData;
//       });

//     try {
//       setLoading(true);
//       await axios.post(`${API_URL}/bulk-update`, { products: updates });
//       showAlert("✅ Bulk save successful", "success");
//       setBulkMode(false);
//       setSelectedItems([]);
//       fetchItems();
//     } catch (err) {
//       console.error("Bulk save error", err);
//       showAlert("❌ Bulk save failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Bulk delete
//   const handleBulkDelete = async () => {
//     if (!selectedItems.length) {
//       showAlert("❌ No items selected", "error");
//       return;
//     }
//     if (!window.confirm("Delete selected items?")) return;

//     try {
//       await Promise.all(selectedItems.map((id) => axios.delete(`${API_URL}/${id}`)));
//       setSelectedItems([]);
//       fetchItems();
//       setBulkMode(false);
//       showAlert("✅ Bulk delete successful", "success");
//     } catch (err) {
//       console.error("Bulk delete error", err);
//       showAlert("❌ Bulk delete failed", "error");
//     }
//   };

//   // Update Base Price inline
//   const updateBasePrice = async (item) => {
//     const newBase = Number(quickBasePrices[item._id] ?? item.basePrice);
//     if (isNaN(newBase)) {
//       showAlert("❌ Invalid Base Price", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const fd = new FormData();
//       fd.append("name", item.name);
//       fd.append("category", item.category?._id);
//       if (item.subcategory?.id) fd.append("subcategory", item.subcategory.id);
//       fd.append("description", item.description || "");
//       fd.append("basePrice", newBase);
//       fd.append("profitLoss", item.profitLoss);
//       fd.append("status", item.status);

//       const res = await axios.put(`${API_URL}/${item._id}`, fd);
//       if (res.data.success) {
//         await fetchItems();
//         setQuickBasePrices((p) => ({ ...p, [item._id]: undefined }));
//         showAlert("✅ Base price updated", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       showAlert("❌ Update failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update Profit/Loss inline with current value calculation
//   const updateProfitLoss = async (item) => {
//     const currentValue = Number(quickProfitLoss[item._id] ?? 0);
//     if (isNaN(currentValue)) {
//       showAlert("❌ Invalid Current value", "error");
//       return;
//     }

//     // Calculate new profit/loss: current value is (sale price - base price)
//     const newProfitLoss = currentValue;
//     const newSalePrice = item.basePrice + newProfitLoss;

//     try {
//       setLoading(true);
//       const fd = new FormData();
//       fd.append("name", item.name);
//       fd.append("category", item.category?._id);
//       if (item.subcategory?.id) fd.append("subcategory", item.subcategory.id);
//       fd.append("description", item.description || "");
//       fd.append("basePrice", item.basePrice);
//       fd.append("profitLoss", newProfitLoss);
//       fd.append("status", item.status);

//       const res = await axios.put(`${API_URL}/${item._id}`, fd);
//       if (res.data.success) {
//         await fetchItems();
//         setQuickProfitLoss((p) => ({ ...p, [item._id]: undefined }));
//         showAlert("✅ Profit/Loss updated", "success");
//       }
//     } catch (err) {
//       console.error(err);
//       showAlert("❌ Update failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Filter items
//   const filteredItems = items.filter((item) => {
//     const t = search.toLowerCase();
//     const matchText =
//       (item.name || "").toLowerCase().includes(t) ||
//       (item.category?.name || "").toLowerCase().includes(t) ||
//       (item.subcategory?.name || "").toLowerCase().includes(t);

//     const matchCategory = !filterCategory || item.category?._id === filterCategory;
//     const matchSub = !filterSubcategory || item.subcategory?._id === filterSubcategory;

//     return matchText && matchCategory && matchSub;
//   });

//   // Sorting
//   let sortedItems = [...filteredItems];
//   if (sortOrder === "low") {
//     sortedItems.sort((a, b) => (Number(a.salePrice) || 0) - (Number(b.salePrice) || 0));
//   } else if (sortOrder === "high") {
//     sortedItems.sort((a, b) => (Number(b.salePrice) || 0) - (Number(a.salePrice) || 0));
//   }

//   // Pagination
//   const indexOfLast = currentPage * itemsPerPage;
//   const currentItems = sortedItems.slice(indexOfLast - itemsPerPage, indexOfLast);
//   const totalPages = Math.max(1, Math.ceil(sortedItems.length / itemsPerPage));

//   // Truncate text
//   const truncate = (text, maxLength = 20) => {
//     if (!text) return "";
//     if (text.length <= maxLength) return text;
//     return text.substring(0, maxLength) + '...';
//   };

//   // Get Teji/Maddi
//   const getTejiMaddi = (item) => {
//     if (item.lockedPrice === 0) return { value: 0, type: "neutral" };
//     const teji = item.salePrice - item.lockedPrice;
//     return {
//       value: Math.abs(teji),
//       type: teji >= 0 ? "positive" : "negative"
//     };
//   };

//   // Get status color
//   const getStatusColor = (status) => {
//     return status === "active" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric'
//     });
//   };

//   // Calculate current value (Sale Price - Base Price)
//   const calculateCurrentValue = (item) => {
//     return item.salePrice - item.basePrice;
//   };

//   // Handle quick profit/loss input change
//   const handleQuickProfitLossChange = (id, value) => {
//     setQuickProfitLoss((p) => ({ ...p, [id]: value }));
    
//     // Update the item's sale price in local state for immediate feedback
//     setItems(prevItems => prevItems.map(item => {
//       if (item._id === id) {
//         const currentValue = Number(value) || 0;
//         const newSalePrice = item.basePrice + currentValue;
//         return { ...item, salePrice: newSalePrice };
//       }
//       return item;
//     }));
//   };

//   return (
//     <>
//       {/* Header */}
//       <div className="mb-2">
//         <h1 className="text-xl font-bold text-gray-800">Product Management</h1>
//         <p className="text-gray-600 text-sm">Total: {filteredItems.length} items</p>
//       </div>

//       {/* Top Controls */}
//       <div className="bg-white rounded-lg shadow p-2 mb-2">
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-1.5 mb-2">
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               setCurrentPage(1);
//             }}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm col-span-2 md:col-span-1"
//           />

//           <select
//             value={filterCategory}
//             onChange={(e) => setFilterCategory(e.target.value)}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm"
//           >
//             <option value="">All Categories</option>
//             {categories.map((c) => (
//               <option key={c._id} value={c._id}>{c.name}</option>
//             ))}
//           </select>

//           <select
//             value={filterSubcategory}
//             onChange={(e) => setFilterSubcategory(e.target.value)}
//             disabled={!filterSubs.length}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm disabled:opacity-50"
//           >
//             <option value="">All Subcategories</option>
//             {filterSubs.map((s) => (
//               <option key={s._id} value={s._id}>{s.name}</option>
//             ))}
//           </select>

//           <select
//             value={sortOrder}
//             onChange={(e) => setSortOrder(e.target.value)}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm"
//           >
//             <option value="">Default Sort</option>
//             <option value="low">Price: Low → High</option>
//             <option value="high">Price: High → Low</option>
//           </select>

//           <button
//             onClick={() => {
//               setShowForm(!showForm);
//               if (showForm) resetForm();
//             }}
//             className="px-1.5 py-1 bg-blue-600 text-white rounded text-xs md:text-sm font-medium hover:bg-blue-700"
//           >
//             {showForm ? "Cancel Add" : "Add Product"}
//           </button>
//         </div>

//         {/* Action Buttons */}
//         <div className="flex flex-wrap gap-1.5">
//           <button
//             onClick={() => window.open(`${API_URL}/export`, "_blank")}
//             className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50"
//           >
//             Export CSV
//           </button>

//           <label className="cursor-pointer">
//             <input
//               type="file"
//               accept=".csv"
//               className="hidden"
//               onChange={async (e) => {
//                 try {
//                   const fd = new FormData();
//                   fd.append("file", e.target.files[0]);
//                   await axios.post(`${API_URL}/import`, fd);
//                   showAlert("✅ Imported successfully", "success");
//                   fetchItems();
//                 } catch (err) {
//                   showAlert("❌ Import failed", "error");
//                 }
//               }}
//             />
//             <span className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50">
//               Import CSV
//             </span>
//           </label>

//           <button
//             onClick={() => setShowCategoryModal(true)}
//             className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//           >
//             Add Category
//           </button>
//         </div>
//       </div>

//       {/* Bulk Actions */}
//       {selectedItems.length > 0 && (
//         <div className="bg-yellow-50 border border-yellow-200 rounded p-1.5 mb-2">
//           <div className="flex items-center justify-between">
//             <span className="font-medium text-xs md:text-sm">{selectedItems.length} selected</span>
//             <div className="flex gap-1.5">
//               <button
//                 onClick={handleBulkDelete}
//                 className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
//               >
//                 Bulk Delete
//               </button>
//               <button
//                 onClick={() => setBulkMode(!bulkMode)}
//                 className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
//               >
//                 {bulkMode ? "Cancel Edit" : "Bulk Edit"}
//               </button>
//               {bulkMode && (
//                 <button
//                   onClick={handleBulkSave}
//                   className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//                 >
//                   Save All
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Bulk Edit Panel */}
//           {bulkMode && (
//             <div className="mt-2 pt-2 border-t border-yellow-200">
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
//                 {items
//                   .filter((item) => selectedItems.includes(item._id))
//                   .map((item) => {
//                     const itemSubcategories = getSubcategoriesForCategory(item.category?._id);
                    
//                     return (
//                       <div key={item._id} className="bg-white rounded p-2 border">
//                         <h4 className="font-semibold text-xs mb-1 truncate">{truncate(item.name, 15)}</h4>
//                         <div className="space-y-1">
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Product Name</label>
//                             <input
//                               type="text"
//                               value={item.name || ""}
//                               onChange={(e) => handleBulkItemChange(item._id, 'name', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                               placeholder="Product name"
//                             />
//                           </div>
                          
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Category</label>
//                             <select
//                               value={item.category?._id || ""}
//                               onChange={(e) => handleBulkItemChange(item._id, 'category', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                             >
//                               <option value="">Select Category</option>
//                               {categories.map((c) => (
//                                 <option key={c._id} value={c._id}>{c.name}</option>
//                               ))}
//                             </select>
//                           </div>
                          
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Subcategory</label>
//                             <select
//                               value={item.subcategory?._id || ""}
//                               onChange={(e) => handleBulkItemChange(item._id, 'subcategory', e.target.value)}
//                               disabled={!item.category?._id}
//                               className="w-full px-1 py-0.5 border rounded text-xs disabled:opacity-50"
//                             >
//                               <option value="">Select Subcategory</option>
//                               {itemSubcategories.map((s) => (
//                                 <option key={s._id} value={s._id}>{s.name}</option>
//                               ))}
//                             </select>
//                           </div>
                          
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Description</label>
//                             <textarea
//                               value={item.description || ""}
//                               onChange={(e) => handleBulkItemChange(item._id, 'description', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                               rows="2"
//                               placeholder="Description"
//                             />
//                           </div>
                          
//                           <div className="grid grid-cols-2 gap-1">
//                             <div>
//                               <label className="block text-[10px] text-gray-600 mb-0.5">Base Price</label>
//                               <input
//                                 type="number"
//                                 value={item.basePrice || ""}
//                                 onChange={(e) => handleBulkItemChange(item._id, 'basePrice', e.target.value)}
//                                 className="w-full px-1 py-0.5 border rounded text-xs"
//                               />
//                             </div>
                            
//                             <div>
//                               <label className="block text-[10px] text-gray-600 mb-0.5">Profit/Loss</label>
//                               <input
//                                 type="number"
//                                 value={item.profitLoss || ""}
//                                 onChange={(e) => handleBulkItemChange(item._id, 'profitLoss', e.target.value)}
//                                 className="w-full px-1 py-0.5 border rounded text-xs"
//                               />
//                             </div>
//                           </div>
                          
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Valid Till</label>
//                             <input
//                               type="date"
//                               value={item.validTill ? item.validTill.split('T')[0] : ""}
//                               onChange={(e) => handleBulkItemChange(item._id, 'validTill', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                             />
//                           </div>
                          
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Status</label>
//                             <select
//                               value={item.status || "inactive"}
//                               onChange={(e) => handleBulkItemChange(item._id, 'status', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                             >
//                               <option value="active">Active</option>
//                               <option value="inactive">Inactive</option>
//                             </select>
//                           </div>
                          
//                           <div className="pt-1">
//                             <div className="text-[10px] text-gray-500">
//                               Sale Price: ₹{(Number(item.basePrice || 0) + Number(item.profitLoss || 0)).toFixed(2)}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//               </div>
              
//               {/* Bulk common actions */}
//               <div className="mt-3 pt-3 border-t border-gray-200">
//                 <div className="text-xs font-medium text-gray-700 mb-2">Common Actions (Apply to all selected):</div>
//                 <div className="flex flex-wrap gap-1.5">
//                   <button
//                     onClick={() => {
//                       const newStatus = prompt("Set status for all selected items (active/inactive):", "active");
//                       if (newStatus === "active" || newStatus === "inactive") {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             return { ...item, status: newStatus };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Status updated for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs hover:bg-purple-200"
//                   >
//                     Set Common Status
//                   </button>
                  
//                   <button
//                     onClick={() => {
//                       const commonCategory = prompt("Enter category ID to apply to all selected items:");
//                       if (commonCategory) {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             const catObj = categories.find(c => c._id === commonCategory);
//                             return { 
//                               ...item, 
//                               category: catObj ? { _id: catObj._id, name: catObj.name } : null,
//                               subcategory: "" // Reset subcategory when changing category
//                             };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Category updated for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-indigo-100 text-indigo-700 rounded text-xs hover:bg-indigo-200"
//                   >
//                     Set Common Category
//                   </button>
                  
//                   <button
//                     onClick={() => {
//                       const priceAdjustment = prompt("Enter amount to add/subtract from base price (use - for subtraction):", "0");
//                       const adjustment = parseFloat(priceAdjustment);
//                       if (!isNaN(adjustment)) {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             const newBasePrice = Number(item.basePrice || 0) + adjustment;
//                             const newSalePrice = newBasePrice + Number(item.profitLoss || 0);
//                             return { 
//                               ...item, 
//                               basePrice: newBasePrice,
//                               salePrice: newSalePrice
//                             };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Base prices adjusted for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-amber-100 text-amber-700 rounded text-xs hover:bg-amber-200"
//                   >
//                     Adjust Base Prices
//                   </button>
                  
//                   <button
//                     onClick={() => {
//                       const profitAdjustment = prompt("Enter amount to add/subtract from profit/loss (use - for subtraction):", "0");
//                       const adjustment = parseFloat(profitAdjustment);
//                       if (!isNaN(adjustment)) {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             const newProfitLoss = Number(item.profitLoss || 0) + adjustment;
//                             const newSalePrice = Number(item.basePrice || 0) + newProfitLoss;
//                             return { 
//                               ...item, 
//                               profitLoss: newProfitLoss,
//                               salePrice: newSalePrice
//                             };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Profit/Loss adjusted for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-teal-100 text-teal-700 rounded text-xs hover:bg-teal-200"
//                   >
//                     Adjust Profit/Loss
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Add/Edit Form */}
//       {showForm && (
//         <div className="bg-white rounded-lg shadow p-2 mb-2">
//           <h3 className="font-bold mb-1.5 text-sm">{editId ? "Edit Product" : "Add New Product"}</h3>
//           <form onSubmit={handleSubmit}>
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 mb-2">
//               <input
//                 required
//                 name="name"
//                 placeholder="Product Name"
//                 value={form.name}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <div className="flex gap-1">
//                 <select
//                   required
//                   name="category"
//                   value={form.category}
//                   onChange={handleChange}
//                   className="flex-1 px-1.5 py-1 border rounded text-xs"
//                 >
//                   <option value="">Select Category</option>
//                   {categories.map((c) => (
//                     <option key={c._id} value={c._id}>{c.name}</option>
//                   ))}
//                 </select>
//                 <button
//                   type="button"
//                   onClick={() => setShowCategoryModal(true)}
//                   className="px-1.5 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//                 >
//                   +
//                 </button>
//               </div>

//               <select
//                 name="subcategory"
//                 value={form.subcategory}
//                 onChange={handleChange}
//                 disabled={!formSubcategories.length}
//                 className="px-1.5 py-1 border rounded text-xs disabled:opacity-50"
//               >
//                 <option value="">Select Subcategory</option>
//                 {formSubcategories.map((s) => (
//                   <option key={s._id} value={s._id}>{s.name}</option>
//                 ))}
//               </select>

//               <input
//                 type="number"
//                 required
//                 name="basePrice"
//                 placeholder="Base Price"
//                 value={form.basePrice}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <input
//                 type="number"
//                 name="profitLoss"
//                 placeholder="Profit/Loss"
//                 value={form.profitLoss}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <input
//                 type="date"
//                 name="validTill"
//                 value={form.validTill}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <select
//                 name="status"
//                 value={form.status}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               >
//                 <option value="active">Active</option>
//                 <option value="inactive">Inactive</option>
//               </select>

//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs text-[10px]"
//               />
//             </div>

//             <div className="mb-2">
//               <textarea
//                 name="description"
//                 placeholder="Description (optional)"
//                 value={form.description}
//                 onChange={handleChange}
//                 rows="2"
//                 className="w-full px-1.5 py-1 border rounded text-xs"
//               />
//             </div>

//             <div className="flex gap-1.5">
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="flex-1 px-1.5 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 disabled:opacity-50"
//               >
//                 {loading ? "Saving..." : (editId ? "Update" : "Save")}
//               </button>
//               <button
//                 type="button"
//                 onClick={resetForm}
//                 className="px-1.5 py-1 border rounded text-xs hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Products Table */}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         {loading ? (
//           <div className="p-4 text-center">
//             <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
//             <p className="mt-2 text-xs text-gray-600">Loading...</p>
//           </div>
//         ) : filteredItems.length === 0 ? (
//           <div className="p-4 text-center text-gray-500 text-sm">
//             No products found
//           </div>
//         ) : (
//           <>
//             <div className="overflow-x-auto">
//               <table className="min-w-full text-xs">
//                 <thead className="bg-gray-100">
//                   <tr>
//                     <th className="px-1 py-1 text-left w-6">
//                       <input
//                         type="checkbox"
//                         checked={selectedItems.length === filteredItems.length && filteredItems.length > 0}
//                         onChange={() => {
//                           if (selectedItems.length === filteredItems.length) setSelectedItems([]);
//                           else setSelectedItems(filteredItems.map((x) => x._id));
//                         }}
//                         className="rounded w-3 h-3"
//                       />
//                     </th>
//                     <th className="px-1.5 py-1 text-left font-medium w-6">#</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-10">Img</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/4">Product</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/5">Category</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Base Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">P/L</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Sale Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Lock Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Teji/Maddi</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Status</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/12">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-200">
//                   {currentItems.map((item, i) => {
//                     const tejiMaddi = getTejiMaddi(item);
//                     const isExpanded = expandedRows[item._id];
//                     const currentValue = calculateCurrentValue(item);
//                     const displayProfitLoss = item.profitLoss || 0;
                    
//                     return (
//                       <React.Fragment key={item._id}>
//                         <tr className="hover:bg-gray-50 align-top">
//                           <td className="px-1 py-1.5">
//                             <input
//                               type="checkbox"
//                               checked={selectedItems.includes(item._id)}
//                               onChange={() =>
//                                 setSelectedItems((prev) =>
//                                   prev.includes(item._id)
//                                     ? prev.filter((x) => x !== item._id)
//                                     : [...prev, item._id]
//                                 )
//                               }
//                               className="rounded w-3 h-3"
//                             />
//                           </td>
//                           <td className="px-1.5 py-1.5 text-xs text-gray-500">
//                             {(currentPage - 1) * itemsPerPage + (i + 1)}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             {item.image ? (
//                               <img src={item.image} alt={item.name} className="w-8 h-8 rounded object-cover" />
//                             ) : (
//                               <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center">
//                                 <span className="text-[8px] text-gray-400">No Img</span>
//                               </div>
//                             )}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="font-medium text-xs" title={item.name}>
//                               {truncate(item.name, 15)}
//                             </div>
//                             <div className="text-[10px] text-gray-500">
//                               {truncate(item.subcategory?.name || "No sub", 12)}
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <span className="text-[10px] px-1 py-0.5 bg-gray-100 rounded">
//                               {truncate(item.category?.name || "-", 10)}
//                             </span>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex items-center gap-1">
//                               <input
//                                 type="number"
//                                 value={quickBasePrices[item._id] !== undefined ? quickBasePrices[item._id] : item.basePrice}
//                                 onChange={(e) => setQuickBasePrices((p) => ({ ...p, [item._id]: e.target.value }))}
//                                 className="w-16 px-1 py-0.5 border rounded text-xs h-6"
//                               />
//                               <button
//                                 onClick={() => updateBasePrice(item)}
//                                 className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
//                               >
//                                 ✔
//                               </button>
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex flex-col">
//                               {/* Current profit/loss display */}
//                               <div className="text-[10px] text-gray-600 mb-0.5">
//                                 {displayProfitLoss >= 0 ? '+' : ''}{displayProfitLoss.toFixed(2)}
//                               </div>
//                               {/* Current value input */}
//                               <div className="flex items-center gap-1">
//                                 <input
//                                   type="number"
//                                   placeholder="Change"
//                                   value={quickProfitLoss[item._id] !== undefined ? quickProfitLoss[item._id] : ''}
//                                   onChange={(e) => handleQuickProfitLossChange(item._id, e.target.value)}
//                                   className="w-16 px-1 py-0.5 border rounded text-xs h-6"
//                                 />
//                                 <button
//                                   onClick={() => updateProfitLoss(item)}
//                                   className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
//                                 >
//                                   ✔
//                                 </button>
//                               </div>
//                               {/* Current value display */}
//                               <div className="text-[9px] text-gray-500 mt-0.5">
//                                 Current: {currentValue >= 0 ? '+' : ''}{currentValue.toFixed(2)}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5 font-bold text-xs">
//                             ₹{item.salePrice.toFixed(2)}
//                           </td>
//                           <td className="px-1.5 py-1.5 text-xs">
//                             ₹{item.lockedPrice.toFixed(2)}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <span className={`text-xs font-medium ${
//                               tejiMaddi.type === 'positive' ? 'text-green-600' :
//                               tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                             }`}>
//                               {tejiMaddi.type === 'positive' ? '▲' : tejiMaddi.type === 'negative' ? '▼' : ''}
//                               ₹{tejiMaddi.value.toFixed(2)}
//                             </span>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <button
//                               onClick={() => handleStatusToggle(item)}
//                               className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}
//                             >
//                               {item.status === "active" ? "Active" : "Inactive"}
//                             </button>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex gap-1">
//                               <button
//                                 onClick={() => toggleRowExpand(item._id)}
//                                 className={`w-6 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50 ${
//                                   isExpanded ? 'bg-blue-50 text-blue-600' : ''
//                                 }`}
//                                 title={isExpanded ? "Collapse Details" : "Expand Details"}
//                               >
//                                 {isExpanded ? '−' : '+'}
//                               </button>
//                               <div className="relative">
//                                 <button
//                                   onClick={() => setActiveMenu(activeMenu === item._id ? null : item._id)}
//                                   className="w-5 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50"
//                                 >
//                                   ⋮
//                                 </button>
//                                 {activeMenu === item._id && (
//                                   <div className="absolute right-0 mt-1 w-24 bg-white border rounded shadow-lg z-10">
//                                     <button
//                                       onClick={() => handleEdit(item)}
//                                       className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
//                                     >
//                                       ✏ Edit
//                                     </button>
//                                     <button
//                                       onClick={async () => {
//                                         await axios.post(`${API_URL}/copy/${item._id}`);
//                                         showAlert("✅ Copied successfully", "success");
//                                         fetchItems();
//                                       }}
//                                       className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
//                                     >
//                                       📄 Copy
//                                     </button>
//                                     <button
//                                       onClick={() => handleDelete(item._id)}
//                                       className="block w-full px-2 py-1 text-left text-[10px] text-red-600 hover:bg-red-50"
//                                     >
//                                       🗑 Delete
//                                     </button>
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                           </td>
//                         </tr>
                        
//                         {/* Expanded Details Row */}
//                         {isExpanded && (
//                           <tr className="bg-blue-50 border-t border-blue-100">
//                             <td colSpan="12" className="px-2 py-3">
//                               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Product Details</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Name:</div>
//                                     <div className="font-medium">{item.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Category:</div>
//                                     <div className="font-medium">{item.category?.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Subcategory:</div>
//                                     <div className="font-medium">{item.subcategory?.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Description:</div>
//                                     <div className="font-medium col-span-1">{item.description || "N/A"}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Price Details</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Base Price:</div>
//                                     <div className="font-medium">₹{item.basePrice?.toFixed(2) || "0.00"}</div>
                                    
//                                     <div className="text-gray-600">Profit/Loss:</div>
//                                     <div className={`font-medium ${item.profitLoss >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                       {item.profitLoss >= 0 ? '+' : ''}₹{item.profitLoss?.toFixed(2) || "0.00"}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Current (Sale - Base):</div>
//                                     <div className={`font-medium ${currentValue >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                       {currentValue >= 0 ? '+' : ''}₹{currentValue?.toFixed(2) || "0.00"}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Sale Price:</div>
//                                     <div className="font-bold">₹{item.salePrice?.toFixed(2) || "0.00"}</div>
                                    
//                                     <div className="text-gray-600">Locked Price:</div>
//                                     <div className="font-medium">₹{item.lockedPrice?.toFixed(2) || "0.00"}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Status & Timing</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Status:</div>
//                                     <div>
//                                       <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}>
//                                         {item.status === "active" ? "Active" : "Inactive"}
//                                       </span>
//                                     </div>
                                    
//                                     <div className="text-gray-600">Valid Till:</div>
//                                     <div className="font-medium">{formatDate(item.validTill)}</div>
                                    
//                                     <div className="text-gray-600">Created:</div>
//                                     <div className="font-medium">{formatDate(item.createdAt)}</div>
                                    
//                                     <div className="text-gray-600">Updated:</div>
//                                     <div className="font-medium">{formatDate(item.updatedAt)}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Market Analysis</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Teji/Maddi:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       {tejiMaddi.type === 'positive' ? '▲ Teji' : 
//                                        tejiMaddi.type === 'negative' ? '▼ Maddi' : 'Neutral'}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Change Value:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       ₹{tejiMaddi.value.toFixed(2)}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Change %:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       {item.lockedPrice > 0 
//                                         ? ((tejiMaddi.value / item.lockedPrice) * 100).toFixed(2) + '%'
//                                         : '0.00%'}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Image:</div>
//                                     <div>
//                                       {item.image ? (
//                                         <a 
//                                           href={item.image} 
//                                           target="_blank" 
//                                           rel="noopener noreferrer"
//                                           className="text-blue-600 hover:underline text-[10px]"
//                                         >
//                                           View Image
//                                         </a>
//                                       ) : (
//                                         <span className="text-gray-400">No Image</span>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
                              
//                               <div className="mt-2 pt-2 border-t border-blue-200">
//                                 <button
//                                   onClick={() => toggleRowExpand(item._id)}
//                                   className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
//                                 >
//                                   <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7"></path>
//                                   </svg>
//                                   Collapse Details
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         )}
//                       </React.Fragment>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div className="px-2 py-1.5 border-t bg-gray-50">
//                 <div className="flex items-center justify-between">
//                   <div className="text-[10px] text-gray-600">
//                     Page {currentPage} of {totalPages}
//                   </div>
//                   <div className="flex gap-1">
//                     <button
//                       onClick={() => setCurrentPage((p) => p - 1)}
//                       disabled={currentPage === 1}
//                       className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center"
//                     >
//                       ←
//                     </button>
//                     {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                       let pageNum;
//                       if (totalPages <= 5) pageNum = i + 1;
//                       else if (currentPage <= 3) pageNum = i + 1;
//                       else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
//                       else pageNum = currentPage - 2 + i;
                      
//                       if (pageNum < 1 || pageNum > totalPages) return null;
                      
//                       return (
//                         <button
//                           key={i}
//                           onClick={() => setCurrentPage(pageNum)}
//                           className={`w-6 h-6 flex items-center justify-center rounded text-xs ${
//                             currentPage === pageNum
//                               ? "bg-blue-600 text-white"
//                               : "border hover:bg-gray-50"
//                           }`}
//                         >
//                           {pageNum}
//                         </button>
//                       );
//                     })}
//                     <button
//                       onClick={() => setCurrentPage((p) => p + 1)}
//                       disabled={currentPage === totalPages}
//                       className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center"
//                     >
//                       →
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {/* Category Modal */}
//       {showCategoryModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50">
//           <div className="bg-white rounded-lg p-3 max-w-xs w-full">
//             <h3 className="font-bold mb-2 text-sm">Add Category</h3>
//             <input
//               type="text"
//               value={newCategoryName}
//               onChange={(e) => setNewCategoryName(e.target.value)}
//               placeholder="Category Name"
//               className="w-full px-1.5 py-1 border rounded mb-2 text-sm"
//               autoFocus
//             />
//             <div className="flex gap-1.5">
//               <button
//                 onClick={handleAddCategory}
//                 disabled={categoryLoading}
//                 className="flex-1 px-1.5 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700 disabled:opacity-50"
//               >
//                 {categoryLoading ? "Saving..." : "Save"}
//               </button>
//               <button
//                 onClick={() => setShowCategoryModal(false)}
//                 className="px-1.5 py-1 border rounded text-sm hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Alert */}
//       {alertBox.show && (
//         <div className="fixed bottom-3 right-3 z-50">
//           <div className={`px-3 py-2 rounded-lg shadow-lg text-xs ${
//             alertBox.type === 'success' ? 'bg-green-100 text-green-800 border border-green-200' :
//             alertBox.type === 'error' ? 'bg-red-100 text-red-800 border border-red-200' :
//             'bg-yellow-100 text-yellow-800 border border-yellow-200'
//           }`}>
//             {alertBox.message}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }








// import React, { useState, useEffect } from "react";
// import axios from "axios";

// export default function PriceList() {
//   const [items, setItems] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [activeMenu, setActiveMenu] = useState(null);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const [bulkMode, setBulkMode] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [filterCategory, setFilterCategory] = useState("");
//   const [filterSubcategory, setFilterSubcategory] = useState("");
//   const [filterSubs, setFilterSubs] = useState([]);
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [newCategoryName, setNewCategoryName] = useState("");
//   const [categoryLoading, setCategoryLoading] = useState(false);
//   const [sortOrder, setSortOrder] = useState("");
//   const [quickBasePrices, setQuickBasePrices] = useState({});
//   const [quickProfitLoss, setQuickProfitLoss] = useState({});
//   const [alertBox, setAlertBox] = useState({
//     show: false,
//     message: "",
//     type: "success",
//   });
//   const [expandedRows, setExpandedRows] = useState({});

//   // API URLs - Replace with your actual URLs
//   const API_URL = "https://grocerrybackend.vercel.app/api/prices";
//   const CATEGORY_URL = "https://grocerrybackend.vercel.app/api/categories";

//   const itemsPerPage = 20;

//   const [form, setForm] = useState({
//     name: "",
//     category: "",
//     subcategory: "",
//     description: "",
//     basePrice: "",
//     profitLoss: "",
//     validTill: "",
//     file: null,
//     status: "inactive",
//   });

//   // Alert timeout
//   useEffect(() => {
//     if (alertBox.show) {
//       const timer = setTimeout(() => {
//         setAlertBox((prev) => ({ ...prev, show: false }));
//       }, 2500);
//       return () => clearTimeout(timer);
//     }
//   }, [alertBox.show]);

//   // Initial fetch
//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   useEffect(() => {
//     if (categories.length > 0) fetchItems();
//   }, [categories]);

//   // Filter subcategories
//   useEffect(() => {
//     if (!filterCategory) {
//       setFilterSubs([]);
//       setFilterSubcategory("");
//       return;
//     }
//     const cat = categories.find((c) => c._id === filterCategory);
//     setFilterSubs(cat?.subcategories || []);
//     setFilterSubcategory("");
//   }, [filterCategory, categories]);

//   // Form subcategories
//   const formSubcategories = form.category
//     ? categories.find((c) => c._id === form.category)?.subcategories || []
//     : [];

//   // Fetch categories
//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(CATEGORY_URL);
//       if (res.data?.success) setCategories(res.data.categories || []);
//     } catch (err) {
//       console.error("Fetch categories error", err);
//       showAlert("❌ Could not fetch categories", "error");
//     }
//   };

//   // Fetch items
//   const fetchItems = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(API_URL);
//       if (res.data?.success) {
//         const raw = res.data.data || [];
//         const enriched = raw.map((item) => {
//           const catObj = categories.find((c) => c._id === (item.category?._id || item.category));
//           let subObj = null;

//           if (catObj?.subcategories && item.subcategory) {
//             const subId = item.subcategory?.id || item.subcategory?._id || item.subcategory;
//             subObj = catObj.subcategories.find((s) => s._id === subId) || null;
//           }

//           return {
//             ...item,
//             basePrice: Number(item.basePrice || 0),
//             profitLoss: Number(item.profitLoss || 0),
//             salePrice: Number(item.salePrice || item.basePrice + (item.profitLoss || 0)),
//             lockedPrice: Number(item.lockedPrice || 0),
//             category: catObj ? { _id: catObj._id, name: catObj.name } : (item.category || null),
//             subcategory: subObj
//               ? { _id: subObj._id, name: subObj.name }
//               : item.subcategory?.id
//               ? { _id: item.subcategory.id, name: item.subcategory.name }
//               : item.subcategory || null,
//           };
//         });

//         setItems(enriched.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
//       }
//     } catch (err) {
//       console.error("Fetch items error", err);
//       showAlert("❌ Could not fetch items", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Helper to show alerts
//   const showAlert = (message, type) => {
//     setAlertBox({ show: true, message, type });
//   };

//   // Toggle row expansion
//   const toggleRowExpand = (id) => {
//     setExpandedRows(prev => ({
//       ...prev,
//       [id]: !prev[id]
//     }));
//   };

//   // Handle form changes
//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     if (files?.length) {
//       setForm((p) => ({ ...p, file: files[0] }));
//     } else {
//       setForm((p) => ({ ...p, [name]: value }));
//     }
//   };

//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Duplicate check
//     const nameExists = items.some(
//       (p) =>
//         p.name.trim().toLowerCase() === form.name.trim().toLowerCase() &&
//         p._id !== editId
//     );

//     if (nameExists) {
//       showAlert("❌ Product name already exists!", "error");
//       setLoading(false);
//       return;
//     }

//     if (!form.name || !form.category || !form.basePrice) {
//       showAlert("❌ Name, category & base price are required", "error");
//       setLoading(false);
//       return;
//     }

//     try {
//       const fd = new FormData();
//       fd.append("name", form.name.trim());
//       fd.append("category", form.category);

//       if (form.subcategory) {
//         const sub = formSubcategories.find((s) => s._id === form.subcategory);
//         if (sub) {
//           fd.append(
//             "subcategory",
//             JSON.stringify({
//               id: sub._id,
//               name: sub.name,
//               image: sub.image || ""
//             })
//           );
//         }
//       } else {
//         fd.append("subcategory", JSON.stringify(null));
//       }

//       fd.append("basePrice", form.basePrice);
//       fd.append("profitLoss", form.profitLoss || 0);
//       if (form.description) fd.append("description", form.description);
//       if (form.validTill) fd.append("validTill", form.validTill);
//       fd.append("status", form.status);
//       if (form.file) fd.append("file", form.file);

//       if (editId) {
//         await axios.put(`${API_URL}/${editId}`, fd);
//         showAlert("✅ Product updated successfully", "success");
//       } else {
//         await axios.post(API_URL, fd);
//         showAlert("✅ Product added successfully", "success");
//       }

//       await fetchItems();
//       resetForm();
//     } catch (err) {
//       console.error("Save error", err);
//       showAlert("❌ Save failed!", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Reset form
//   const resetForm = () => {
//     setForm({
//       name: "",
//       category: "",
//       subcategory: "",
//       description: "",
//       basePrice: "",
//       profitLoss: "",
//       validTill: "",
//       file: null,
//       status: "inactive",
//     });
//     setEditId(null);
//     setShowForm(false);
//   };

//   // Add category
//   const handleAddCategory = async () => {
//     if (!newCategoryName.trim()) {
//       showAlert("❌ Category name is required", "error");
//       return;
//     }

//     try {
//       setCategoryLoading(true);
//       const res = await axios.post(CATEGORY_URL, {
//         name: newCategoryName.trim(),
//       });

//       if (res.data?.success) {
//         showAlert("✅ Category added successfully", "success");
//         setNewCategoryName("");
//         setShowCategoryModal(false);
//         await fetchCategories();
//       } else {
//         showAlert("❌ Category add failed", "error");
//       }
//     } catch (err) {
//       console.error("Add category error", err);
//       showAlert("❌ Error while adding category", "error");
//     } finally {
//       setCategoryLoading(false);
//     }
//   };

//   // Edit item
//   const handleEdit = (item) => {
//     setForm({
//       name: item.name || "",
//       category: item.category?._id?.toString() || "",
//       subcategory: item.subcategory?._id || "",
//       description: item.description || "",
//       basePrice: item.basePrice || "",
//       profitLoss: item.profitLoss || 0,
//       validTill: item.validTill ? item.validTill.split("T")[0] : "",
//       file: null,
//       status: item.status || "inactive",
//     });

//     setEditId(item._id);
//     setShowForm(true);
//     setActiveMenu(null);
//   };

//   // Delete item
//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this item?")) return;
//     try {
//       await axios.delete(`${API_URL}/${id}`);
//       setItems((prev) => prev.filter((x) => x._id !== id));
//       setSelectedItems((prev) => prev.filter((x) => x !== id));
//       setActiveMenu(null);
//       showAlert("✅ Item deleted successfully", "success");
//     } catch (err) {
//       console.error("Delete error", err);
//       showAlert("❌ Delete failed", "error");
//     }
//   };

//   // Toggle status
//   const handleStatusToggle = async (item) => {
//     try {
//       const newStatus = item.status === "active" ? "inactive" : "active";
//       await axios.put(`${API_URL}/status/${item._id}`, { status: newStatus });
//       setItems((prev) => prev.map((x) => (x._id === item._id ? { ...x, status: newStatus } : x)));
//     } catch (err) {
//       console.error("Status toggle error", err);
//       showAlert("❌ Status update failed", "error");
//     }
//   };

//   // Handle bulk item data change - ONLY 4 FIELDS
//   const handleBulkItemChange = (id, field, value) => {
//     // Only allow these 4 fields
//     const allowedFields = ['name', 'basePrice', 'profitLoss', 'status'];
//     if (!allowedFields.includes(field)) return;

//     setItems(prevItems => prevItems.map(item => {
//       if (item._id === id) {
//         const updatedItem = { ...item };
        
//         if (field === 'name') {
//           updatedItem.name = value;
//         } else if (field === 'basePrice') {
//           const numValue = parseFloat(value) || 0;
//           updatedItem.basePrice = numValue;
//           updatedItem.salePrice = numValue + (updatedItem.profitLoss || 0);
//         } else if (field === 'profitLoss') {
//           const numValue = parseFloat(value) || 0;
//           updatedItem.profitLoss = numValue;
//           updatedItem.salePrice = (updatedItem.basePrice || 0) + numValue;
//         } else if (field === 'status') {
//           updatedItem.status = value;
//         }
        
//         return updatedItem;
//       }
//       return item;
//     }));
//   };

//   // Bulk save - ONLY 4 FIELDS
//   const handleBulkSave = async () => {
//     if (!selectedItems.length) {
//       showAlert("❌ No items selected", "error");
//       return;
//     }

//     try {
//       setLoading(true);
      
//       // Get items to update
//       const itemsToUpdate = items.filter(item => selectedItems.includes(item._id));
//       console.log("Updating items:", itemsToUpdate.length);

//       let successCount = 0;
//       let errorCount = 0;

//       // Update each item individually
//       for (const item of itemsToUpdate) {
//         try {
//           // Prepare update data - ONLY THE 4 FIELDS
//           const updateData = {
//             name: item.name,
//             basePrice: Number(item.basePrice || 0),
//             profitLoss: Number(item.profitLoss || 0),
//             status: item.status || 'inactive',
//           };

//           console.log(`Updating ${item.name}:`, updateData);

//           // Send update request
//           const response = await axios.put(`${API_URL}/${item._id}`, updateData, {
//             headers: {
//               'Content-Type': 'application/json'
//             }
//           });

//           if (response.data?.success) {
//             successCount++;
//           } else {
//             errorCount++;
//             console.error(`Failed to update ${item.name}:`, response.data);
//           }

//         } catch (err) {
//           errorCount++;
//           console.error(`Error updating ${item?.name || 'item'}:`, err.message);
//         }
//       }

//       // Show results
//       if (errorCount === 0) {
//         showAlert(`✅ All ${successCount} items updated successfully`, "success");
//       } else if (successCount > 0) {
//         showAlert(`✅ ${successCount} items updated, ${errorCount} failed`, "warning");
//       } else {
//         showAlert("❌ All updates failed", "error");
//       }

//       // Refresh data and reset
//       await fetchItems();
//       setBulkMode(false);
//       setSelectedItems([]);

//     } catch (err) {
//       console.error("Bulk save error:", err);
//       showAlert("❌ Bulk save failed: " + (err.message || "Unknown error"), "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Bulk delete
//   const handleBulkDelete = async () => {
//     if (!selectedItems.length) {
//       showAlert("❌ No items selected", "error");
//       return;
//     }
//     if (!window.confirm(`Delete ${selectedItems.length} selected items?`)) return;

//     try {
//       setLoading(true);
//       await Promise.all(
//         selectedItems.map((id) => axios.delete(`${API_URL}/${id}`))
//       );
//       setSelectedItems([]);
//       await fetchItems();
//       setBulkMode(false);
//       showAlert("✅ Bulk delete successful", "success");
//     } catch (err) {
//       console.error("Bulk delete error", err);
//       showAlert("❌ Bulk delete failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update Base Price inline
//   const updateBasePrice = async (item) => {
//     const newBase = Number(quickBasePrices[item._id] ?? item.basePrice);
//     if (isNaN(newBase) || newBase < 0) {
//       showAlert("❌ Invalid Base Price", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await axios.put(`${API_URL}/${item._id}`, {
//         basePrice: newBase,
//         profitLoss: item.profitLoss || 0,
//         name: item.name,
//         category: item.category?._id,
//         subcategory: item.subcategory ? JSON.stringify({
//           id: item.subcategory._id,
//           name: item.subcategory.name
//         }) : JSON.stringify(null),
//         description: item.description || "",
//         status: item.status
//       });

//       if (res.data.success) {
//         await fetchItems();
//         setQuickBasePrices((p) => ({ ...p, [item._id]: undefined }));
//         showAlert("✅ Base price updated", "success");
//       }
//     } catch (err) {
//       console.error("Update base price error:", err);
//       showAlert("❌ Update failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update Profit/Loss inline
//   const updateProfitLoss = async (item) => {
//     const currentValue = Number(quickProfitLoss[item._id] ?? 0);
//     if (isNaN(currentValue)) {
//       showAlert("❌ Invalid Profit/Loss value", "error");
//       return;
//     }

//     try {
//       setLoading(true);
//       const res = await axios.put(`${API_URL}/${item._id}`, {
//         basePrice: item.basePrice || 0,
//         profitLoss: currentValue,
//         name: item.name,
//         category: item.category?._id,
//         subcategory: item.subcategory ? JSON.stringify({
//           id: item.subcategory._id,
//           name: item.subcategory.name
//         }) : JSON.stringify(null),
//         description: item.description || "",
//         status: item.status
//       });

//       if (res.data.success) {
//         await fetchItems();
//         setQuickProfitLoss((p) => ({ ...p, [item._id]: undefined }));
//         showAlert("✅ Profit/Loss updated", "success");
//       }
//     } catch (err) {
//       console.error("Update profit loss error:", err);
//       showAlert("❌ Update failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle CSV import
//   const handleCSVImport = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     // Check file type
//     if (!file.name.endsWith('.csv')) {
//       showAlert("❌ Please select a CSV file", "error");
//       e.target.value = '';
//       return;
//     }

//     try {
//       setLoading(true);
//       const formData = new FormData();
//       formData.append('file', file);

//       const response = await axios.post(`${API_URL}/import`, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       if (response.data?.success) {
//         showAlert("✅ CSV imported successfully", "success");
//         await fetchItems();
//       } else {
//         showAlert("❌ Import failed: " + (response.data?.message || "Unknown error"), "error");
//       }
//     } catch (err) {
//       console.error("CSV import error:", err);
//       showAlert("❌ Import failed: " + (err.response?.data?.message || err.message), "error");
//     } finally {
//       setLoading(false);
//       e.target.value = '';
//     }
//   };

//   // Filter items
//   const filteredItems = items.filter((item) => {
//     const t = search.toLowerCase();
//     const matchText =
//       (item.name || "").toLowerCase().includes(t) ||
//       (item.category?.name || "").toLowerCase().includes(t) ||
//       (item.subcategory?.name || "").toLowerCase().includes(t);

//     const matchCategory = !filterCategory || item.category?._id === filterCategory;
//     const matchSub = !filterSubcategory || item.subcategory?._id === filterSubcategory;

//     return matchText && matchCategory && matchSub;
//   });

//   // Sorting
//   let sortedItems = [...filteredItems];
//   if (sortOrder === "low") {
//     sortedItems.sort((a, b) => (Number(a.salePrice) || 0) - (Number(b.salePrice) || 0));
//   } else if (sortOrder === "high") {
//     sortedItems.sort((a, b) => (Number(b.salePrice) || 0) - (Number(a.salePrice) || 0));
//   }

//   // Pagination
//   const indexOfLast = currentPage * itemsPerPage;
//   const indexOfFirst = indexOfLast - itemsPerPage;
//   const currentItems = sortedItems.slice(indexOfFirst, indexOfLast);
//   const totalPages = Math.max(1, Math.ceil(sortedItems.length / itemsPerPage));

//   // Truncate text
//   const truncate = (text, maxLength = 20) => {
//     if (!text) return "";
//     if (text.length <= maxLength) return text;
//     return text.substring(0, maxLength) + '...';
//   };

//   // Get Teji/Maddi
//   const getTejiMaddi = (item) => {
//     if (item.lockedPrice === 0) return { value: 0, type: "neutral" };
//     const teji = item.salePrice - item.lockedPrice;
//     return {
//       value: Math.abs(teji),
//       type: teji >= 0 ? "positive" : "negative"
//     };
//   };

//   // Get status color
//   const getStatusColor = (status) => {
//     return status === "active" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric'
//     });
//   };

//   // Calculate current value (Sale Price - Base Price)
//   const calculateCurrentValue = (item) => {
//     return (item.salePrice || 0) - (item.basePrice || 0);
//   };

//   // Handle quick profit/loss input change
//   const handleQuickProfitLossChange = (id, value) => {
//     setQuickProfitLoss((p) => ({ ...p, [id]: value }));
//   };

//   // Handle row selection for bulk edit
//   const handleSelectAll = () => {
//     if (selectedItems.length === filteredItems.length) {
//       setSelectedItems([]);
//     } else {
//       setSelectedItems(filteredItems.map(item => item._id));
//     }
//   };

//   return (
//     <>
//       {/* Header */}
//       <div className="mb-0">
//         <h1 className="text-md font-bold text-gray-800">Product Management</h1>
//         <p className="text-gray-600 text-sm">Total: {filteredItems.length} items</p>
//       </div>

//       {/* Top Controls */}
//       <div className="bg-white rounded-lg shadow p-2 md:p-6 mb-2">
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-1.5 mb-2">
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => {
//               setSearch(e.target.value);
//               setCurrentPage(1);
//             }}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm col-span-2 md:col-span-1"
//           />

//           <select
//             value={filterCategory}
//             onChange={(e) => setFilterCategory(e.target.value)}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm"
//           >
//             <option value="">All Categories</option>
//             {categories.map((c) => (
//               <option key={c._id} value={c._id}>{c.name}</option>
//             ))}
//           </select>

//           <select
//             value={filterSubcategory}
//             onChange={(e) => setFilterSubcategory(e.target.value)}
//             disabled={!filterSubs.length}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm disabled:opacity-50"
//           >
//             <option value="">All Subcategories</option>
//             {filterSubs.map((s) => (
//               <option key={s._id} value={s._id}>{s.name}</option>
//             ))}
//           </select>

//           <select
//             value={sortOrder}
//             onChange={(e) => setSortOrder(e.target.value)}
//             className="px-1.5 py-1 border rounded text-xs md:text-sm"
//           >
//             <option value="">Default Sort</option>
//             <option value="low">Price: Low → High</option>
//             <option value="high">Price: High → Low</option>
//           </select>

//           <button
//             onClick={() => {
//               setShowForm(!showForm);
//               if (showForm) resetForm();
//             }}
//             className="px-1.5 py-1 bg-blue-600 text-white rounded text-xs md:text-sm font-medium hover:bg-blue-700"
//           >
//             {showForm ? "Cancel Add" : "Add Product"}
//           </button>
//         </div>

//         {/* Action Buttons */}
//         <div className="flex flex-wrap gap-1.5">
//           <button
//             onClick={() => window.open(`${API_URL}/export`, "_blank")}
//             className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50"
//           >
//             Export CSV
//           </button>

//           <label className="cursor-pointer">
//             <span className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50">
//               Import CSV
//             </span>
//             <input
//               type="file"
//               accept=".csv"
//               className="hidden"
//               onChange={handleCSVImport}
//             />
//           </label>

//           <button
//             onClick={() => setShowCategoryModal(true)}
//             className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//           >
//             Add Category
//           </button>
//         </div>
//       </div>

//       {/* Bulk Actions */}
//       {selectedItems.length > 0 && (
//         <div className="bg-yellow-50 border border-yellow-200 rounded p-2 md:p-6 mb-2">
//           <div className="flex items-center justify-between">
//             <span className="font-medium text-xs md:text-sm">{selectedItems.length} selected</span>
//             <div className="flex gap-1.5">
//               <button
//                 onClick={handleBulkDelete}
//                 className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
//               >
//                 Bulk Delete
//               </button>
//               <button
//                 onClick={() => setBulkMode(!bulkMode)}
//                 className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
//               >
//                 {bulkMode ? "Cancel Edit" : "Bulk Edit"}
//               </button>
//               {bulkMode && (
//                 <button
//                   onClick={handleBulkSave}
//                   disabled={loading}
//                   className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700 disabled:opacity-50"
//                 >
//                   {loading ? "Saving..." : "Save All"}
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Bulk Edit Panel - ONLY 4 FIELDS */}
//           {bulkMode && (
//             <div className="mt-2 pt-2 border-t border-yellow-200">
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
//                 {items
//                   .filter((item) => selectedItems.includes(item._id))
//                   .map((item) => {
//                     return (
//                       <div key={item._id} className="bg-white rounded p-2 border">
//                         <h4 className="font-semibold text-xs mb-1 truncate">{truncate(item.name, 15)}</h4>
//                         <div className="space-y-1">
//                           {/* Product Name */}
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Product Name</label>
//                             <input
//                               type="text"
//                               value={item.name || ""}
//                               onChange={(e) => handleBulkItemChange(item._id, 'name', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                               placeholder="Product name"
//                             />
//                           </div>
                          
//                           {/* Base Price */}
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Base Price</label>
//                             <input
//                               type="number"
//                               step="0.01"
//                               value={item.basePrice || ""}
//                               onChange={(e) => handleBulkItemChange(item._id, 'basePrice', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                             />
//                           </div>
                          
//                           {/* Profit/Loss */}
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Profit/Loss</label>
//                             <input
//                               type="number"
//                               step="0.01"
//                               value={item.profitLoss || ""}
//                               onChange={(e) => handleBulkItemChange(item._id, 'profitLoss', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                             />
//                           </div>
                          
//                           {/* Status */}
//                           <div>
//                             <label className="block text-[10px] text-gray-600 mb-0.5">Status</label>
//                             <select
//                               value={item.status || "inactive"}
//                               onChange={(e) => handleBulkItemChange(item._id, 'status', e.target.value)}
//                               className="w-full px-1 py-0.5 border rounded text-xs"
//                             >
//                               <option value="active">Active</option>
//                               <option value="inactive">Inactive</option>
//                             </select>
//                           </div>
                          
//                           {/* Sale Price Display (Read-only) */}
//                           <div className="pt-1">
//                             <div className="text-[10px] text-gray-500">
//                               Sale Price: ₹{((Number(item.basePrice || 0) + Number(item.profitLoss || 0))).toFixed(2)}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//               </div>
              
//               {/* Bulk common actions - UPDATED for only 4 fields */}
//               <div className="mt-3 pt-3 border-t border-gray-200">
//                 <div className="text-xs font-medium text-gray-700 mb-2">Common Actions (Apply to all selected):</div>
//                 <div className="flex flex-wrap gap-1.5">
//                   {/* Set Common Status */}
//                   <button
//                     onClick={() => {
//                       const newStatus = prompt("Set status for all selected items (active/inactive):", "active");
//                       if (newStatus === "active" || newStatus === "inactive") {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             return { ...item, status: newStatus };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Status updated for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs hover:bg-purple-200"
//                   >
//                     Set Common Status
//                   </button>
                  
//                   {/* Adjust Base Prices */}
//                   <button
//                     onClick={() => {
//                       const priceAdjustment = prompt("Enter amount to add/subtract from base price (use - for subtraction):", "0");
//                       const adjustment = parseFloat(priceAdjustment);
//                       if (!isNaN(adjustment)) {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             const newBasePrice = Number(item.basePrice || 0) + adjustment;
//                             return { 
//                               ...item, 
//                               basePrice: newBasePrice,
//                               salePrice: newBasePrice + Number(item.profitLoss || 0)
//                             };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Base prices adjusted for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-amber-100 text-amber-700 rounded text-xs hover:bg-amber-200"
//                   >
//                     Adjust Base Prices
//                   </button>
                  
//                   {/* Adjust Profit/Loss */}
//                   <button
//                     onClick={() => {
//                       const profitAdjustment = prompt("Enter amount to add/subtract from profit/loss (use - for subtraction):", "0");
//                       const adjustment = parseFloat(profitAdjustment);
//                       if (!isNaN(adjustment)) {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             const newProfitLoss = Number(item.profitLoss || 0) + adjustment;
//                             return { 
//                               ...item, 
//                               profitLoss: newProfitLoss,
//                               salePrice: Number(item.basePrice || 0) + newProfitLoss
//                             };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Profit/Loss adjusted for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-teal-100 text-teal-700 rounded text-xs hover:bg-teal-200"
//                   >
//                     Adjust Profit/Loss
//                   </button>
                  
//                   {/* Set Common Name Prefix/Suffix */}
//                   <button
//                     onClick={() => {
//                       const action = prompt("Add prefix or suffix? (type 'prefix' or 'suffix'):", "prefix").toLowerCase();
//                       const text = prompt("Enter text to add:");
//                       if (text && (action === 'prefix' || action === 'suffix')) {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             const newName = action === 'prefix' 
//                               ? `${text} ${item.name || ''}`
//                               : `${item.name || ''} ${text}`;
//                             return { ...item, name: newName.trim() };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Names updated for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
//                   >
//                     Modify Names
//                   </button>
                  
//                   {/* Reset Profit/Loss to Zero */}
//                   <button
//                     onClick={() => {
//                       if (window.confirm("Reset profit/loss to 0 for all selected items?")) {
//                         setItems(prevItems => prevItems.map(item => {
//                           if (selectedItems.includes(item._id)) {
//                             return { 
//                               ...item, 
//                               profitLoss: 0,
//                               salePrice: Number(item.basePrice || 0)
//                             };
//                           }
//                           return item;
//                         }));
//                         showAlert("✅ Profit/Loss reset to 0 for all selected items", "success");
//                       }
//                     }}
//                     className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
//                   >
//                     Reset Profit/Loss to 0
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Add/Edit Form */}
//       {showForm && (
//         <div className="bg-white rounded-lg shadow p-2 md:p-6 mb-2">
//           <h3 className="font-bold mb-1.5 text-sm">{editId ? "Edit Product" : "Add New Product"}</h3>
//           <form onSubmit={handleSubmit}>
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 mb-2">
//               <input
//                 required
//                 name="name"
//                 placeholder="Product Name"
//                 value={form.name}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <div className="flex gap-1">
//                 <select
//                   required
//                   name="category"
//                   value={form.category}
//                   onChange={handleChange}
//                   className="flex-1 px-1.5 py-1 border rounded text-xs"
//                 >
//                   <option value="">Select Category</option>
//                   {categories.map((c) => (
//                     <option key={c._id} value={c._id}>{c.name}</option>
//                   ))}
//                 </select>
//                 <button
//                   type="button"
//                   onClick={() => setShowCategoryModal(true)}
//                   className="px-1.5 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
//                 >
//                   +
//                 </button>
//               </div>

//               <select
//                 name="subcategory"
//                 value={form.subcategory}
//                 onChange={handleChange}
//                 disabled={!formSubcategories.length}
//                 className="px-1.5 py-1 border rounded text-xs disabled:opacity-50"
//               >
//                 <option value="">Select Subcategory</option>
//                 {formSubcategories.map((s) => (
//                   <option key={s._id} value={s._id}>{s.name}</option>
//                 ))}
//               </select>

//               <input
//                 type="number"
//                 step="0.01"
//                 required
//                 name="basePrice"
//                 placeholder="Base Price"
//                 value={form.basePrice}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <input
//                 type="number"
//                 step="0.01"
//                 name="profitLoss"
//                 placeholder="Profit/Loss"
//                 value={form.profitLoss}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <input
//                 type="date"
//                 name="validTill"
//                 value={form.validTill}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               />

//               <select
//                 name="status"
//                 value={form.status}
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs"
//               >
//                 <option value="active">Active</option>
//                 <option value="inactive">Inactive</option>
//               </select>

//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleChange}
//                 className="px-1.5 py-1 border rounded text-xs text-[10px]"
//               />
//             </div>

//             <div className="mb-2">
//               <textarea
//                 name="description"
//                 placeholder="Description (optional)"
//                 value={form.description}
//                 onChange={handleChange}
//                 rows="2"
//                 className="w-full px-1.5 py-1 border rounded text-xs"
//               />
//             </div>

//             <div className="flex gap-1.5">
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="flex-1 px-1.5 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 disabled:opacity-50"
//               >
//                 {loading ? "Saving..." : (editId ? "Update" : "Save")}
//               </button>
//               <button
//                 type="button"
//                 onClick={resetForm}
//                 className="px-1.5 py-1 border rounded text-xs hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* Products Table */}
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         {loading ? (
//           <div className="p-4 text-center">
//             <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
//             <p className="mt-2 text-xs text-gray-600">Loading...</p>
//           </div>
//         ) : filteredItems.length === 0 ? (
//           <div className="p-4 text-center text-gray-500 text-sm">
//             No products found
//           </div>
//         ) : (
//           <>
//             <div className="overflow-x-auto">
//               <table className="min-w-full text-xs">
//                 <thead className="bg-gray-100">
//                   <tr>
//                     <th className="px-1 py-1 text-left w-6">
//                       <input
//                         type="checkbox"
//                         checked={selectedItems.length === filteredItems.length && filteredItems.length > 0}
//                         onChange={handleSelectAll}
//                         className="rounded w-3 h-3"
//                       />
//                     </th>
//                     <th className="px-1.5 py-1 text-left font-medium w-6">#</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-10">Img</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/4">Product</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/5">Category</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Base Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">P/L</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Sale Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Lock Price</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Teji/Maddi</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/6">Status</th>
//                     <th className="px-1.5 py-1 text-left font-medium w-1/12">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-200">
//                   {currentItems.map((item, i) => {
//                     const tejiMaddi = getTejiMaddi(item);
//                     const isExpanded = expandedRows[item._id];
//                     const currentValue = calculateCurrentValue(item);
//                     // FIXED: Ensure displayProfitLoss is a number before calling toFixed
//                     const displayProfitLoss = Number(item.profitLoss || 0);
                    
//                     return (
//                       <React.Fragment key={item._id}>
//                         <tr className="hover:bg-gray-50 align-top">
//                           <td className="px-1 py-1.5">
//                             <input
//                               type="checkbox"
//                               checked={selectedItems.includes(item._id)}
//                               onChange={() =>
//                                 setSelectedItems((prev) =>
//                                   prev.includes(item._id)
//                                     ? prev.filter((x) => x !== item._id)
//                                     : [...prev, item._id]
//                                 )
//                               }
//                               className="rounded w-3 h-3"
//                             />
//                           </td>
//                           <td className="px-1.5 py-1.5 text-xs text-gray-500">
//                             {indexOfFirst + i + 1}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             {item.image ? (
//                               <img src={item.image} alt={item.name} className="w-8 h-8 rounded object-cover" />
//                             ) : (
//                               <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center">
//                                 <span className="text-[8px] text-gray-400">No Img</span>
//                               </div>
//                             )}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="font-medium text-xs" title={item.name}>
//                               {truncate(item.name, 15)}
//                             </div>
//                             <div className="text-[10px] text-gray-500">
//                               {truncate(item.subcategory?.name || "No sub", 12)}
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <span className="text-[10px] px-1 py-0.5 bg-gray-100 rounded">
//                               {truncate(item.category?.name || "-", 10)}
//                             </span>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex items-center gap-1">
//                               <input
//                                 type="number"
//                                 step="0.01"
//                                 value={quickBasePrices[item._id] !== undefined ? quickBasePrices[item._id] : item.basePrice}
//                                 onChange={(e) => setQuickBasePrices((p) => ({ ...p, [item._id]: e.target.value }))}
//                                 className="w-16 px-1 py-0.5 border rounded text-xs h-6"
//                               />
//                               <button
//                                 onClick={() => updateBasePrice(item)}
//                                 className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
//                               >
//                                 ✔
//                               </button>
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex flex-col">
//                               {/* Current profit/loss display - FIXED: Ensure it's a number */}
//                               <div className={`text-[10px] mb-0.5 ${displayProfitLoss >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                 {displayProfitLoss >= 0 ? '+' : ''}{displayProfitLoss.toFixed(2)}
//                               </div>
//                               {/* Current value input */}
//                               <div className="flex items-center gap-1">
//                                 <input
//                                   type="number"
//                                   step="0.01"
//                                   placeholder="Change"
//                                   value={quickProfitLoss[item._id] !== undefined ? quickProfitLoss[item._id] : ''}
//                                   onChange={(e) => handleQuickProfitLossChange(item._id, e.target.value)}
//                                   className="w-16 px-1 py-0.5 border rounded text-xs h-6"
//                                 />
//                                 <button
//                                   onClick={() => updateProfitLoss(item)}
//                                   className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
//                                 >
//                                   ✔
//                                 </button>
//                               </div>
//                               {/* Current value display */}
//                               <div className={`text-[9px] mt-0.5 ${currentValue >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                 Current: {currentValue >= 0 ? '+' : ''}{currentValue.toFixed(2)}
//                               </div>
//                             </div>
//                           </td>
//                           <td className="px-1.5 py-1.5 font-bold text-xs">
//                             ₹{(item.salePrice || 0).toFixed(2)}
//                           </td>
//                           <td className="px-1.5 py-1.5 text-xs">
//                             ₹{(item.lockedPrice || 0).toFixed(2)}
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <span className={`text-xs font-medium ${
//                               tejiMaddi.type === 'positive' ? 'text-green-600' :
//                               tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                             }`}>
//                               {tejiMaddi.type === 'positive' ? '▲' : tejiMaddi.type === 'negative' ? '▼' : ''}
//                               ₹{tejiMaddi.value.toFixed(2)}
//                             </span>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <button
//                               onClick={() => handleStatusToggle(item)}
//                               className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}
//                             >
//                               {item.status === "active" ? "Active" : "Inactive"}
//                             </button>
//                           </td>
//                           <td className="px-1.5 py-1.5">
//                             <div className="flex gap-1">
//                               <button
//                                 onClick={() => toggleRowExpand(item._id)}
//                                 className={`w-6 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50 ${
//                                   isExpanded ? 'bg-blue-50 text-blue-600' : ''
//                                 }`}
//                                 title={isExpanded ? "Collapse Details" : "Expand Details"}
//                               >
//                                 {isExpanded ? '−' : '+'}
//                               </button>
//                               <div className="relative">
//                                 <button
//                                   onClick={() => setActiveMenu(activeMenu === item._id ? null : item._id)}
//                                   className="w-5 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50"
//                                 >
//                                   ⋮
//                                 </button>
//                                 {activeMenu === item._id && (
//                                   <div className="absolute right-0 mt-1 w-24 bg-white border rounded shadow-lg z-10">
//                                     <button
//                                       onClick={() => handleEdit(item)}
//                                       className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
//                                     >
//                                       ✏ Edit
//                                     </button>
//                                     <button
//                                       onClick={async () => {
//                                         try {
//                                           await axios.post(`${API_URL}/copy/${item._id}`);
//                                           showAlert("✅ Copied successfully", "success");
//                                           fetchItems();
//                                         } catch (err) {
//                                           showAlert("❌ Copy failed", "error");
//                                         }
//                                       }}
//                                       className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
//                                     >
//                                       📄 Copy
//                                     </button>
//                                     <button
//                                       onClick={() => handleDelete(item._id)}
//                                       className="block w-full px-2 py-1 text-left text-[10px] text-red-600 hover:bg-red-50"
//                                     >
//                                       🗑 Delete
//                                     </button>
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                           </td>
//                         </tr>
                        
//                         {/* Expanded Details Row */}
//                         {isExpanded && (
//                           <tr className="bg-blue-50 border-t border-blue-100">
//                             <td colSpan="12" className="px-2 md:px-6 py-3 md:py-6">
//                               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Product Details</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Name:</div>
//                                     <div className="font-medium">{item.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Category:</div>
//                                     <div className="font-medium">{item.category?.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Subcategory:</div>
//                                     <div className="font-medium">{item.subcategory?.name || "N/A"}</div>
                                    
//                                     <div className="text-gray-600">Description:</div>
//                                     <div className="font-medium col-span-1">{item.description || "N/A"}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Price Details</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Base Price:</div>
//                                     <div className="font-medium">₹{(item.basePrice || 0).toFixed(2)}</div>
                                    
//                                     <div className="text-gray-600">Profit/Loss:</div>
//                                     <div className={`font-medium ${displayProfitLoss >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                       {displayProfitLoss >= 0 ? '+' : ''}₹{displayProfitLoss.toFixed(2)}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Current (Sale - Base):</div>
//                                     <div className={`font-medium ${currentValue >= 0 ? 'text-green-600' : 'text-red-600'}`}>
//                                       {currentValue >= 0 ? '+' : ''}₹{currentValue.toFixed(2)}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Sale Price:</div>
//                                     <div className="font-bold">₹{(item.salePrice || 0).toFixed(2)}</div>
                                    
//                                     <div className="text-gray-600">Locked Price:</div>
//                                     <div className="font-medium">₹{(item.lockedPrice || 0).toFixed(2)}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Status & Timing</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Status:</div>
//                                     <div>
//                                       <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}>
//                                         {item.status === "active" ? "Active" : "Inactive"}
//                                       </span>
//                                     </div>
                                    
//                                     <div className="text-gray-600">Valid Till:</div>
//                                     <div className="font-medium">{formatDate(item.validTill)}</div>
                                    
//                                     <div className="text-gray-600">Created:</div>
//                                     <div className="font-medium">{formatDate(item.createdAt)}</div>
                                    
//                                     <div className="text-gray-600">Updated:</div>
//                                     <div className="font-medium">{formatDate(item.updatedAt)}</div>
//                                   </div>
//                                 </div>
                                
//                                 <div className="space-y-1">
//                                   <h4 className="font-semibold text-xs text-blue-700 mb-1">Market Analysis</h4>
//                                   <div className="grid grid-cols-2 gap-1 text-[11px]">
//                                     <div className="text-gray-600">Teji/Maddi:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       {tejiMaddi.type === 'positive' ? '▲ Teji' : 
//                                        tejiMaddi.type === 'negative' ? '▼ Maddi' : 'Neutral'}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Change Value:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       ₹{tejiMaddi.value.toFixed(2)}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Change %:</div>
//                                     <div className={`font-medium ${
//                                       tejiMaddi.type === 'positive' ? 'text-green-600' :
//                                       tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
//                                     }`}>
//                                       {item.lockedPrice > 0 
//                                         ? ((tejiMaddi.value / item.lockedPrice) * 100).toFixed(2) + '%'
//                                         : '0.00%'}
//                                     </div>
                                    
//                                     <div className="text-gray-600">Image:</div>
//                                     <div>
//                                       {item.image ? (
//                                         <a 
//                                           href={item.image} 
//                                           target="_blank" 
//                                           rel="noopener noreferrer"
//                                           className="text-blue-600 hover:underline text-[10px]"
//                                         >
//                                           View Image
//                                         </a>
//                                       ) : (
//                                         <span className="text-gray-400">No Image</span>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
                              
//                               <div className="mt-2 pt-2 border-t border-blue-200">
//                                 <button
//                                   onClick={() => toggleRowExpand(item._id)}
//                                   className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
//                                 >
//                                   <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7"></path>
//                                   </svg>
//                                   Collapse Details
//                                 </button>
//                               </div>
//                             </td>
//                           </tr>
//                         )}
//                       </React.Fragment>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <div className="px-2 py-1.5 border-t bg-gray-50">
//                 <div className="flex items-center justify-between">
//                   <div className="text-[10px] text-gray-600">
//                     Page {currentPage} of {totalPages} (Showing {indexOfFirst + 1}-{Math.min(indexOfLast, sortedItems.length)} of {sortedItems.length})
//                   </div>
//                   <div className="flex gap-1">
//                     <button
//                       onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//                       disabled={currentPage === 1}
//                       className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center hover:bg-gray-100"
//                     >
//                       ←
//                     </button>
//                     {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                       let pageNum;
//                       if (totalPages <= 5) pageNum = i + 1;
//                       else if (currentPage <= 3) pageNum = i + 1;
//                       else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
//                       else pageNum = currentPage - 2 + i;
                      
//                       if (pageNum < 1 || pageNum > totalPages) return null;
                      
//                       return (
//                         <button
//                           key={i}
//                           onClick={() => setCurrentPage(pageNum)}
//                           className={`w-6 h-6 flex items-center justify-center rounded text-xs ${
//                             currentPage === pageNum
//                               ? "bg-blue-600 text-white"
//                               : "border hover:bg-gray-100"
//                           }`}
//                         >
//                           {pageNum}
//                         </button>
//                       );
//                     })}
//                     <button
//                       onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
//                       disabled={currentPage === totalPages}
//                       className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center hover:bg-gray-100"
//                     >
//                       →
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {/* Category Modal */}
//       {showCategoryModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-2 md:p-6 z-50">
//           <div className="bg-white rounded-lg p-2 md:p-6 max-w-xs w-full">
//             <h3 className="font-bold mb-2 text-sm">Add Category</h3>
//             <input
//               type="text"
//               value={newCategoryName}
//               onChange={(e) => setNewCategoryName(e.target.value)}
//               placeholder="Category Name"
//               className="w-full px-1.5 py-1 border rounded mb-2 text-sm"
//               autoFocus
//               onKeyPress={(e) => e.key === 'Enter' && handleAddCategory()}
//             />
//             <div className="flex gap-1.5">
//               <button
//                 onClick={handleAddCategory}
//                 disabled={categoryLoading}
//                 className="flex-1 px-1.5 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700 disabled:opacity-50"
//               >
//                 {categoryLoading ? "Saving..." : "Save"}
//               </button>
//               <button
//                 onClick={() => setShowCategoryModal(false)}
//                 className="px-1.5 py-1 border rounded text-sm hover:bg-gray-50"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Alert */}
//       {alertBox.show && (
//         <div className="fixed bottom-3 right-3 z-50">
//           <div className={`px-3 py-2 rounded-lg shadow-lg text-xs ${
//             alertBox.type === 'success' ? 'bg-green-100 text-green-800 border border-green-200' :
//             alertBox.type === 'error' ? 'bg-red-100 text-red-800 border border-red-200' :
//             'bg-yellow-100 text-yellow-800 border border-yellow-200'
//           }`}>
//             {alertBox.message}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }













import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

export default function PriceList() {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [bulkMode, setBulkMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterCategory, setFilterCategory] = useState("");
  const [filterSubcategory, setFilterSubcategory] = useState("");
  const [filterSubs, setFilterSubs] = useState([]);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("");
  const [quickBasePrices, setQuickBasePrices] = useState({});
  const [quickProfitLoss, setQuickProfitLoss] = useState({});
  const [alertBox, setAlertBox] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [expandedRows, setExpandedRows] = useState({});
  const [popupDetails, setPopupDetails] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const popupRef = useRef(null);

  // API URLs - Replace with your actual URLs
  const API_URL = "https://grocerrybackend.vercel.app/api/prices";
  const CATEGORY_URL = "https://grocerrybackend.vercel.app/api/categories";

  const itemsPerPage = 20;

  const [form, setForm] = useState({
    name: "",
    category: "",
    subcategory: "",
    description: "",
    basePrice: "",
    profitLoss: "",
    validTill: "",
    file: null,
    status: "inactive",
  });

  // Check mobile view on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setPopupDetails(null);
      }
    };

    if (popupDetails) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupDetails]);

  // Alert timeout
  useEffect(() => {
    if (alertBox.show) {
      const timer = setTimeout(() => {
        setAlertBox((prev) => ({ ...prev, show: false }));
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [alertBox.show]);

  // Initial fetch
  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (categories.length > 0) fetchItems();
  }, [categories]);

  // Filter subcategories
  useEffect(() => {
    if (!filterCategory) {
      setFilterSubs([]);
      setFilterSubcategory("");
      return;
    }
    const cat = categories.find((c) => c._id === filterCategory);
    setFilterSubs(cat?.subcategories || []);
    setFilterSubcategory("");
  }, [filterCategory, categories]);

  // Form subcategories
  const formSubcategories = form.category
    ? categories.find((c) => c._id === form.category)?.subcategories || []
    : [];

  // Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await axios.get(CATEGORY_URL);
      if (res.data?.success) setCategories(res.data.categories || []);
    } catch (err) {
      console.error("Fetch categories error", err);
      showAlert("❌ Could not fetch categories", "error");
    }
  };

  // Fetch items
  const fetchItems = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_URL);
      if (res.data?.success) {
        const raw = res.data.data || [];
        const enriched = raw.map((item) => {
          const catObj = categories.find((c) => c._id === (item.category?._id || item.category));
          let subObj = null;

          if (catObj?.subcategories && item.subcategory) {
            const subId = item.subcategory?.id || item.subcategory?._id || item.subcategory;
            subObj = catObj.subcategories.find((s) => s._id === subId) || null;
          }

          return {
            ...item,
            basePrice: Number(item.basePrice || 0),
            profitLoss: Number(item.profitLoss || 0),
            salePrice: Number(item.salePrice || item.basePrice + (item.profitLoss || 0)),
            lockedPrice: Number(item.lockedPrice || 0),
            category: catObj ? { _id: catObj._id, name: catObj.name } : (item.category || null),
            subcategory: subObj
              ? { _id: subObj._id, name: subObj.name }
              : item.subcategory?.id
              ? { _id: item.subcategory.id, name: item.subcategory.name }
              : item.subcategory || null,
          };
        });

        setItems(enriched.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
      }
    } catch (err) {
      console.error("Fetch items error", err);
      showAlert("❌ Could not fetch items", "error");
    } finally {
      setLoading(false);
    }
  };

  // Helper to show alerts
  const showAlert = (message, type) => {
    setAlertBox({ show: true, message, type });
  };

  // Toggle row expansion for desktop or show popup for mobile
  const handleDetailsClick = (item) => {
    if (isMobile) {
      setPopupDetails(item);
    } else {
      setExpandedRows(prev => ({
        ...prev,
        [item._id]: !prev[item._id]
      }));
    }
  };

  // Close popup
  const closePopup = () => {
    setPopupDetails(null);
  };

  // Handle form changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files?.length) {
      setForm((p) => ({ ...p, file: files[0] }));
    } else {
      setForm((p) => ({ ...p, [name]: value }));
    }
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Duplicate check
    const nameExists = items.some(
      (p) =>
        p.name.trim().toLowerCase() === form.name.trim().toLowerCase() &&
        p._id !== editId
    );

    if (nameExists) {
      showAlert("❌ Product name already exists!", "error");
      setLoading(false);
      return;
    }

    if (!form.name || !form.category || !form.basePrice) {
      showAlert("❌ Name, category & base price are required", "error");
      setLoading(false);
      return;
    }

    try {
      const fd = new FormData();
      fd.append("name", form.name.trim());
      fd.append("category", form.category);

      if (form.subcategory) {
        const sub = formSubcategories.find((s) => s._id === form.subcategory);
        if (sub) {
          fd.append(
            "subcategory",
            JSON.stringify({
              id: sub._id,
              name: sub.name,
              image: sub.image || ""
            })
          );
        }
      } else {
        fd.append("subcategory", JSON.stringify(null));
      }

      fd.append("basePrice", form.basePrice);
      fd.append("profitLoss", form.profitLoss || 0);
      if (form.description) fd.append("description", form.description);
      if (form.validTill) fd.append("validTill", form.validTill);
      fd.append("status", form.status);
      if (form.file) fd.append("file", form.file);

      if (editId) {
        await axios.put(`${API_URL}/${editId}`, fd);
        showAlert("✅ Product updated successfully", "success");
      } else {
        await axios.post(API_URL, fd);
        showAlert("✅ Product added successfully", "success");
      }

      await fetchItems();
      resetForm();
    } catch (err) {
      console.error("Save error", err);
      showAlert("❌ Save failed!", "error");
    } finally {
      setLoading(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setForm({
      name: "",
      category: "",
      subcategory: "",
      description: "",
      basePrice: "",
      profitLoss: "",
      validTill: "",
      file: null,
      status: "inactive",
    });
    setEditId(null);
    setShowForm(false);
  };

  // Add category
  const handleAddCategory = async () => {
    if (!newCategoryName.trim()) {
      showAlert("❌ Category name is required", "error");
      return;
    }

    try {
      setCategoryLoading(true);
      const res = await axios.post(CATEGORY_URL, {
        name: newCategoryName.trim(),
      });

      if (res.data?.success) {
        showAlert("✅ Category added successfully", "success");
        setNewCategoryName("");
        setShowCategoryModal(false);
        await fetchCategories();
      } else {
        showAlert("❌ Category add failed", "error");
      }
    } catch (err) {
      console.error("Add category error", err);
      showAlert("❌ Error while adding category", "error");
    } finally {
      setCategoryLoading(false);
    }
  };

  // Edit item
  const handleEdit = (item) => {
    setForm({
      name: item.name || "",
      category: item.category?._id?.toString() || "",
      subcategory: item.subcategory?._id || "",
      description: item.description || "",
      basePrice: item.basePrice || "",
      profitLoss: item.profitLoss || 0,
      validTill: item.validTill ? item.validTill.split("T")[0] : "",
      file: null,
      status: item.status || "inactive",
    });

    setEditId(item._id);
    setShowForm(true);
    setActiveMenu(null);
    setPopupDetails(null);
  };

  // Delete item
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;
    try {
      await axios.delete(`${API_URL}/${id}`);
      setItems((prev) => prev.filter((x) => x._id !== id));
      setSelectedItems((prev) => prev.filter((x) => x !== id));
      setActiveMenu(null);
      setPopupDetails(null);
      showAlert("✅ Item deleted successfully", "success");
    } catch (err) {
      console.error("Delete error", err);
      showAlert("❌ Delete failed", "error");
    }
  };

  // Toggle status
  const handleStatusToggle = async (item) => {
    try {
      const newStatus = item.status === "active" ? "inactive" : "active";
      await axios.put(`${API_URL}/status/${item._id}`, { status: newStatus });
      setItems((prev) => prev.map((x) => (x._id === item._id ? { ...x, status: newStatus } : x)));
    } catch (err) {
      console.error("Status toggle error", err);
      showAlert("❌ Status update failed", "error");
    }
  };

  // Handle bulk item data change - ONLY 4 FIELDS
  const handleBulkItemChange = (id, field, value) => {
    // Only allow these 4 fields
    const allowedFields = ['name', 'basePrice', 'profitLoss', 'status'];
    if (!allowedFields.includes(field)) return;

    setItems(prevItems => prevItems.map(item => {
      if (item._id === id) {
        const updatedItem = { ...item };
        
        if (field === 'name') {
          updatedItem.name = value;
        } else if (field === 'basePrice') {
          const numValue = parseFloat(value) || 0;
          updatedItem.basePrice = numValue;
          updatedItem.salePrice = numValue + (updatedItem.profitLoss || 0);
        } else if (field === 'profitLoss') {
          const numValue = parseFloat(value) || 0;
          updatedItem.profitLoss = numValue;
          updatedItem.salePrice = (updatedItem.basePrice || 0) + numValue;
        } else if (field === 'status') {
          updatedItem.status = value;
        }
        
        return updatedItem;
      }
      return item;
    }));
  };

  // Bulk save - ONLY 4 FIELDS
  const handleBulkSave = async () => {
    if (!selectedItems.length) {
      showAlert("❌ No items selected", "error");
      return;
    }

    try {
      setLoading(true);
      
      // Get items to update
      const itemsToUpdate = items.filter(item => selectedItems.includes(item._id));
      console.log("Updating items:", itemsToUpdate.length);

      let successCount = 0;
      let errorCount = 0;

      // Update each item individually
      for (const item of itemsToUpdate) {
        try {
          // Prepare update data - ONLY THE 4 FIELDS
          const updateData = {
            name: item.name,
            basePrice: Number(item.basePrice || 0),
            profitLoss: Number(item.profitLoss || 0),
            status: item.status || 'inactive',
          };

          console.log(`Updating ${item.name}:`, updateData);

          // Send update request
          const response = await axios.put(`${API_URL}/${item._id}`, updateData, {
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (response.data?.success) {
            successCount++;
          } else {
            errorCount++;
            console.error(`Failed to update ${item.name}:`, response.data);
          }

        } catch (err) {
          errorCount++;
          console.error(`Error updating ${item?.name || 'item'}:`, err.message);
        }
      }

      // Show results
      if (errorCount === 0) {
        showAlert(`✅ All ${successCount} items updated successfully`, "success");
      } else if (successCount > 0) {
        showAlert(`✅ ${successCount} items updated, ${errorCount} failed`, "warning");
      } else {
        showAlert("❌ All updates failed", "error");
      }

      // Refresh data and reset
      await fetchItems();
      setBulkMode(false);
      setSelectedItems([]);

    } catch (err) {
      console.error("Bulk save error:", err);
      showAlert("❌ Bulk save failed: " + (err.message || "Unknown error"), "error");
    } finally {
      setLoading(false);
    }
  };

  // Bulk delete
  const handleBulkDelete = async () => {
    if (!selectedItems.length) {
      showAlert("❌ No items selected", "error");
      return;
    }
    if (!window.confirm(`Delete ${selectedItems.length} selected items?`)) return;

    try {
      setLoading(true);
      await Promise.all(
        selectedItems.map((id) => axios.delete(`${API_URL}/${id}`))
      );
      setSelectedItems([]);
      await fetchItems();
      setBulkMode(false);
      showAlert("✅ Bulk delete successful", "success");
    } catch (err) {
      console.error("Bulk delete error", err);
      showAlert("❌ Bulk delete failed", "error");
    } finally {
      setLoading(false);
    }
  };

  // Update Base Price inline
  const updateBasePrice = async (item) => {
    const newBase = Number(quickBasePrices[item._id] ?? item.basePrice);
    if (isNaN(newBase) || newBase < 0) {
      showAlert("❌ Invalid Base Price", "error");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.put(`${API_URL}/${item._id}`, {
        basePrice: newBase,
        profitLoss: item.profitLoss || 0,
        name: item.name,
        category: item.category?._id,
        subcategory: item.subcategory ? JSON.stringify({
          id: item.subcategory._id,
          name: item.subcategory.name
        }) : JSON.stringify(null),
        description: item.description || "",
        status: item.status
      });

      if (res.data.success) {
        await fetchItems();
        setQuickBasePrices((p) => ({ ...p, [item._id]: undefined }));
        showAlert("✅ Base price updated", "success");
      }
    } catch (err) {
      console.error("Update base price error:", err);
      showAlert("❌ Update failed", "error");
    } finally {
      setLoading(false);
    }
  };

  // Update Profit/Loss inline
  const updateProfitLoss = async (item) => {
    const currentValue = Number(quickProfitLoss[item._id] ?? 0);
    if (isNaN(currentValue)) {
      showAlert("❌ Invalid Profit/Loss value", "error");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.put(`${API_URL}/${item._id}`, {
        basePrice: item.basePrice || 0,
        profitLoss: currentValue,
        name: item.name,
        category: item.category?._id,
        subcategory: item.subcategory ? JSON.stringify({
          id: item.subcategory._id,
          name: item.subcategory.name
        }) : JSON.stringify(null),
        description: item.description || "",
        status: item.status
      });

      if (res.data.success) {
        await fetchItems();
        setQuickProfitLoss((p) => ({ ...p, [item._id]: undefined }));
        showAlert("✅ Profit/Loss updated", "success");
      }
    } catch (err) {
      console.error("Update profit loss error:", err);
      showAlert("❌ Update failed", "error");
    } finally {
      setLoading(false);
    }
  };

  // Handle CSV import
  const handleCSVImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check file type
    if (!file.name.endsWith('.csv')) {
      showAlert("❌ Please select a CSV file", "error");
      e.target.value = '';
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(`${API_URL}/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data?.success) {
        showAlert("✅ CSV imported successfully", "success");
        await fetchItems();
      } else {
        showAlert("❌ Import failed: " + (response.data?.message || "Unknown error"), "error");
      }
    } catch (err) {
      console.error("CSV import error:", err);
      showAlert("❌ Import failed: " + (err.response?.data?.message || err.message), "error");
    } finally {
      setLoading(false);
      e.target.value = '';
    }
  };

  // Filter items
  const filteredItems = items.filter((item) => {
    const t = search.toLowerCase();
    const matchText =
      (item.name || "").toLowerCase().includes(t) ||
      (item.category?.name || "").toLowerCase().includes(t) ||
      (item.subcategory?.name || "").toLowerCase().includes(t);

    const matchCategory = !filterCategory || item.category?._id === filterCategory;
    const matchSub = !filterSubcategory || item.subcategory?._id === filterSubcategory;

    return matchText && matchCategory && matchSub;
  });

  // Sorting
  let sortedItems = [...filteredItems];
  if (sortOrder === "low") {
    sortedItems.sort((a, b) => (Number(a.salePrice) || 0) - (Number(b.salePrice) || 0));
  } else if (sortOrder === "high") {
    sortedItems.sort((a, b) => (Number(b.salePrice) || 0) - (Number(a.salePrice) || 0));
  }

  // Pagination
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = sortedItems.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.max(1, Math.ceil(sortedItems.length / itemsPerPage));

  // Truncate text
  const truncate = (text, maxLength = 20) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // Get Teji/Maddi
  const getTejiMaddi = (item) => {
    if (item.lockedPrice === 0) return { value: 0, type: "neutral" };
    const teji = item.salePrice - item.lockedPrice;
    return {
      value: Math.abs(teji),
      type: teji >= 0 ? "positive" : "negative"
    };
  };

  // Get status color
  const getStatusColor = (status) => {
    return status === "active" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800";
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  // Calculate current value (Sale Price - Base Price)
  const calculateCurrentValue = (item) => {
    return (item.salePrice || 0) - (item.basePrice || 0);
  };

  // Handle quick profit/loss input change
  const handleQuickProfitLossChange = (id, value) => {
    setQuickProfitLoss((p) => ({ ...p, [id]: value }));
  };

  // Handle row selection for bulk edit
  const handleSelectAll = () => {
    if (selectedItems.length === filteredItems.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(filteredItems.map(item => item._id));
    }
  };

  return (
    <>
      {/* Header */}
      <div className="mb-0">
        <h1 className="text-md font-bold text-gray-800">Product Management</h1>
        <p className="text-gray-600 text-sm">Total: {filteredItems.length} items</p>
      </div>

      {/* Top Controls */}
      <div className="bg-white rounded-lg shadow p-2 md:p-6 mb-2">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-1.5 mb-2">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            className="px-1.5 py-1 border rounded text-xs md:text-sm col-span-2 md:col-span-1"
          />

          <select
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
            className="px-1.5 py-1 border rounded text-xs md:text-sm"
          >
            <option value="">All Categories</option>
            {categories.map((c) => (
              <option key={c._id} value={c._id}>{c.name}</option>
            ))}
          </select>

          <select
            value={filterSubcategory}
            onChange={(e) => setFilterSubcategory(e.target.value)}
            disabled={!filterSubs.length}
            className="px-1.5 py-1 border rounded text-xs md:text-sm disabled:opacity-50"
          >
            <option value="">All Subcategories</option>
            {filterSubs.map((s) => (
              <option key={s._id} value={s._id}>{s.name}</option>
            ))}
          </select>

          <select
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            className="px-1.5 py-1 border rounded text-xs md:text-sm"
          >
            <option value="">Default Sort</option>
            <option value="low">Price: Low → High</option>
            <option value="high">Price: High → Low</option>
          </select>

          <button
            onClick={() => {
              setShowForm(!showForm);
              if (showForm) resetForm();
            }}
            className="px-1.5 py-1 bg-blue-600 text-white rounded text-xs md:text-sm font-medium hover:bg-blue-700"
          >
            {showForm ? "Cancel Add" : "Add Product"}
          </button>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap gap-1.5">
          <button
            onClick={() => window.open(`${API_URL}/export`, "_blank")}
            className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50"
          >
            Export CSV
          </button>

          <label className="cursor-pointer">
            <span className="px-2 py-0.5 border rounded text-xs hover:bg-gray-50">
              Import CSV
            </span>
            <input
              type="file"
              accept=".csv"
              className="hidden"
              onChange={handleCSVImport}
            />
          </label>

          <button
            onClick={() => setShowCategoryModal(true)}
            className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700"
          >
            Add Category
          </button>
        </div>
      </div>

      {/* Bulk Actions */}
      {selectedItems.length > 0 && (
        <div className="bg-yellow-50 border border-yellow-200 rounded p-2 md:p-6 mb-2">
          <div className="flex items-center justify-between">
            <span className="font-medium text-xs md:text-sm">{selectedItems.length} selected</span>
            <div className="flex gap-1.5">
              <button
                onClick={handleBulkDelete}
                className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
              >
                Bulk Delete
              </button>
              <button
                onClick={() => setBulkMode(!bulkMode)}
                className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
              >
                {bulkMode ? "Cancel Edit" : "Bulk Edit"}
              </button>
              {bulkMode && (
                <button
                  onClick={handleBulkSave}
                  disabled={loading}
                  className="px-2 py-0.5 bg-green-600 text-white rounded text-xs hover:bg-green-700 disabled:opacity-50"
                >
                  {loading ? "Saving..." : "Save All"}
                </button>
              )}
            </div>
          </div>

          {/* Bulk Edit Panel - ONLY 4 FIELDS */}
          {bulkMode && (
            <div className="mt-2 pt-2 border-t border-yellow-200">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                {items
                  .filter((item) => selectedItems.includes(item._id))
                  .map((item) => {
                    return (
                      <div key={item._id} className="bg-white rounded p-2 border">
                        <h4 className="font-semibold text-xs mb-1 truncate">{truncate(item.name, 15)}</h4>
                        <div className="space-y-1">
                          {/* Product Name */}
                          <div>
                            <label className="block text-[10px] text-gray-600 mb-0.5">Product Name</label>
                            <input
                              type="text"
                              value={item.name || ""}
                              onChange={(e) => handleBulkItemChange(item._id, 'name', e.target.value)}
                              className="w-full px-1 py-0.5 border rounded text-xs"
                              placeholder="Product name"
                            />
                          </div>
                          
                          {/* Base Price */}
                          <div>
                            <label className="block text-[10px] text-gray-600 mb-0.5">Base Price</label>
                            <input
                              type="number"
                              step="0.01"
                              value={item.basePrice || ""}
                              onChange={(e) => handleBulkItemChange(item._id, 'basePrice', e.target.value)}
                              className="w-full px-1 py-0.5 border rounded text-xs"
                            />
                          </div>
                          
                          {/* Profit/Loss */}
                          <div>
                            <label className="block text-[10px] text-gray-600 mb-0.5">Profit/Loss</label>
                            <input
                              type="number"
                              step="0.01"
                              value={item.profitLoss || ""}
                              onChange={(e) => handleBulkItemChange(item._id, 'profitLoss', e.target.value)}
                              className="w-full px-1 py-0.5 border rounded text-xs"
                            />
                          </div>
                          
                          {/* Status */}
                          <div>
                            <label className="block text-[10px] text-gray-600 mb-0.5">Status</label>
                            <select
                              value={item.status || "inactive"}
                              onChange={(e) => handleBulkItemChange(item._id, 'status', e.target.value)}
                              className="w-full px-1 py-0.5 border rounded text-xs"
                            >
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          </div>
                          
                          {/* Sale Price Display (Read-only) */}
                          <div className="pt-1">
                            <div className="text-[10px] text-gray-500">
                              Sale Price: ₹{((Number(item.basePrice || 0) + Number(item.profitLoss || 0))).toFixed(2)}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              
              {/* Bulk common actions - UPDATED for only 4 fields */}
              <div className="mt-3 pt-3 border-t border-gray-200">
                <div className="text-xs font-medium text-gray-700 mb-2">Common Actions (Apply to all selected):</div>
                <div className="flex flex-wrap gap-1.5">
                  {/* Set Common Status */}
                  <button
                    onClick={() => {
                      const newStatus = prompt("Set status for all selected items (active/inactive):", "active");
                      if (newStatus === "active" || newStatus === "inactive") {
                        setItems(prevItems => prevItems.map(item => {
                          if (selectedItems.includes(item._id)) {
                            return { ...item, status: newStatus };
                          }
                          return item;
                        }));
                        showAlert("✅ Status updated for all selected items", "success");
                      }
                    }}
                    className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs hover:bg-purple-200"
                  >
                    Set Common Status
                  </button>
                  
                  {/* Adjust Base Prices */}
                  <button
                    onClick={() => {
                      const priceAdjustment = prompt("Enter amount to add/subtract from base price (use - for subtraction):", "0");
                      const adjustment = parseFloat(priceAdjustment);
                      if (!isNaN(adjustment)) {
                        setItems(prevItems => prevItems.map(item => {
                          if (selectedItems.includes(item._id)) {
                            const newBasePrice = Number(item.basePrice || 0) + adjustment;
                            return { 
                              ...item, 
                              basePrice: newBasePrice,
                              salePrice: newBasePrice + Number(item.profitLoss || 0)
                            };
                          }
                          return item;
                        }));
                        showAlert("✅ Base prices adjusted for all selected items", "success");
                      }
                    }}
                    className="px-2 py-0.5 bg-amber-100 text-amber-700 rounded text-xs hover:bg-amber-200"
                  >
                    Adjust Base Prices
                  </button>
                  
                  {/* Adjust Profit/Loss */}
                  <button
                    onClick={() => {
                      const profitAdjustment = prompt("Enter amount to add/subtract from profit/loss (use - for subtraction):", "0");
                      const adjustment = parseFloat(profitAdjustment);
                      if (!isNaN(adjustment)) {
                        setItems(prevItems => prevItems.map(item => {
                          if (selectedItems.includes(item._id)) {
                            const newProfitLoss = Number(item.profitLoss || 0) + adjustment;
                            return { 
                              ...item, 
                              profitLoss: newProfitLoss,
                              salePrice: Number(item.basePrice || 0) + newProfitLoss
                            };
                          }
                          return item;
                        }));
                        showAlert("✅ Profit/Loss adjusted for all selected items", "success");
                      }
                    }}
                    className="px-2 py-0.5 bg-teal-100 text-teal-700 rounded text-xs hover:bg-teal-200"
                  >
                    Adjust Profit/Loss
                  </button>
                  
                  {/* Set Common Name Prefix/Suffix */}
                  <button
                    onClick={() => {
                      const action = prompt("Add prefix or suffix? (type 'prefix' or 'suffix'):", "prefix").toLowerCase();
                      const text = prompt("Enter text to add:");
                      if (text && (action === 'prefix' || action === 'suffix')) {
                        setItems(prevItems => prevItems.map(item => {
                          if (selectedItems.includes(item._id)) {
                            const newName = action === 'prefix' 
                              ? `${text} ${item.name || ''}`
                              : `${item.name || ''} ${text}`;
                            return { ...item, name: newName.trim() };
                          }
                          return item;
                        }));
                        showAlert("✅ Names updated for all selected items", "success");
                      }
                    }}
                    className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-xs hover:bg-blue-200"
                  >
                    Modify Names
                  </button>
                  
                  {/* Reset Profit/Loss to Zero */}
                  <button
                    onClick={() => {
                      if (window.confirm("Reset profit/loss to 0 for all selected items?")) {
                        setItems(prevItems => prevItems.map(item => {
                          if (selectedItems.includes(item._id)) {
                            return { 
                              ...item, 
                              profitLoss: 0,
                              salePrice: Number(item.basePrice || 0)
                            };
                          }
                          return item;
                        }));
                        showAlert("✅ Profit/Loss reset to 0 for all selected items", "success");
                      }
                    }}
                    className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs hover:bg-red-200"
                  >
                    Reset Profit/Loss to 0
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Add/Edit Form */}
      {showForm && (
        <div className="bg-white rounded-lg shadow p-2 md:p-6 mb-2">
          <h3 className="font-bold mb-1.5 text-sm">{editId ? "Edit Product" : "Add New Product"}</h3>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 mb-2">
              <input
                required
                name="name"
                placeholder="Product Name"
                value={form.name}
                onChange={handleChange}
                className="px-1.5 py-1 border rounded text-xs"
              />

              <div className="flex gap-1">
                <select
                  required
                  name="category"
                  value={form.category}
                  onChange={handleChange}
                  className="flex-1 px-1.5 py-1 border rounded text-xs"
                >
                  <option value="">Select Category</option>
                  {categories.map((c) => (
                    <option key={c._id} value={c._id}>{c.name}</option>
                  ))}
                </select>
                <button
                  type="button"
                  onClick={() => setShowCategoryModal(true)}
                  className="px-1.5 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
                >
                  +
                </button>
              </div>

              <select
                name="subcategory"
                value={form.subcategory}
                onChange={handleChange}
                disabled={!formSubcategories.length}
                className="px-1.5 py-1 border rounded text-xs disabled:opacity-50"
              >
                <option value="">Select Subcategory</option>
                {formSubcategories.map((s) => (
                  <option key={s._id} value={s._id}>{s.name}</option>
                ))}
              </select>

              <input
                type="number"
                step="0.01"
                required
                name="basePrice"
                placeholder="Base Price"
                value={form.basePrice}
                onChange={handleChange}
                className="px-1.5 py-1 border rounded text-xs"
              />

              <input
                type="number"
                step="0.01"
                name="profitLoss"
                placeholder="Profit/Loss"
                value={form.profitLoss}
                onChange={handleChange}
                className="px-1.5 py-1 border rounded text-xs"
              />

              <input
                type="date"
                name="validTill"
                value={form.validTill}
                onChange={handleChange}
                className="px-1.5 py-1 border rounded text-xs"
              />

              <select
                name="status"
                value={form.status}
                onChange={handleChange}
                className="px-1.5 py-1 border rounded text-xs"
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>

              <input
                type="file"
                accept="image/*"
                onChange={handleChange}
                className="px-1.5 py-1 border rounded text-xs text-[10px]"
              />
            </div>

            <div className="mb-2">
              <textarea
                name="description"
                placeholder="Description (optional)"
                value={form.description}
                onChange={handleChange}
                rows="2"
                className="w-full px-1.5 py-1 border rounded text-xs"
              />
            </div>

            <div className="flex gap-1.5">
              <button
                type="submit"
                disabled={loading}
                className="flex-1 px-1.5 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? "Saving..." : (editId ? "Update" : "Save")}
              </button>
              <button
                type="button"
                onClick={resetForm}
                className="px-1.5 py-1 border rounded text-xs hover:bg-gray-50"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Products Table */}
      <div className="bg-white rounded-lg shadow overflow-hidden">
        {loading ? (
          <div className="p-4 text-center">
            <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
            <p className="mt-2 text-xs text-gray-600">Loading...</p>
          </div>
        ) : filteredItems.length === 0 ? (
          <div className="p-4 text-center text-gray-500 text-sm">
            No products found
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full text-xs">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="px-1 py-1 text-left w-6">
                      <input
                        type="checkbox"
                        checked={selectedItems.length === filteredItems.length && filteredItems.length > 0}
                        onChange={handleSelectAll}
                        className="rounded w-3 h-3"
                      />
                    </th>
                    <th className="px-1.5 py-1 text-left font-medium w-6">#</th>
                    <th className="px-1.5 py-1 text-left font-medium w-10">Img</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/4">Product</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/5">Category</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/6">Base Price</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/6">P/L</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/6">Sale Price</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/6">Lock Price</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/6">Teji/Maddi</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/6">Status</th>
                    <th className="px-1.5 py-1 text-left font-medium w-1/12">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {currentItems.map((item, i) => {
                    const tejiMaddi = getTejiMaddi(item);
                    const isExpanded = expandedRows[item._id];
                    const currentValue = calculateCurrentValue(item);
                    // FIXED: Ensure displayProfitLoss is a number before calling toFixed
                    const displayProfitLoss = Number(item.profitLoss || 0);
                    
                    return (
                      <React.Fragment key={item._id}>
                        <tr className="hover:bg-gray-50 align-top">
                          <td className="px-1 py-1.5">
                            <input
                              type="checkbox"
                              checked={selectedItems.includes(item._id)}
                              onChange={() =>
                                setSelectedItems((prev) =>
                                  prev.includes(item._id)
                                    ? prev.filter((x) => x !== item._id)
                                    : [...prev, item._id]
                                )
                              }
                              className="rounded w-3 h-3"
                            />
                          </td>
                          <td className="px-1.5 py-1.5 text-xs text-gray-500">
                            {indexOfFirst + i + 1}
                          </td>
                          <td className="px-1.5 py-1.5">
                            {item.image ? (
                              <img src={item.image} alt={item.name} className="w-8 h-8 rounded object-cover" />
                            ) : (
                              <div className="w-8 h-8 bg-gray-100 rounded flex items-center justify-center">
                                <span className="text-[8px] text-gray-400">No Img</span>
                              </div>
                            )}
                          </td>
                          <td className="px-1.5 py-1.5">
                            <div className="font-medium text-xs" title={item.name}>
                              {truncate(item.name, 15)}
                            </div>
                            <div className="text-[10px] text-gray-500">
                              {truncate(item.subcategory?.name || "No sub", 12)}
                            </div>
                          </td>
                          <td className="px-1.5 py-1.5">
                            <span className="text-[10px] px-1 py-0.5 bg-gray-100 rounded">
                              {truncate(item.category?.name || "-", 10)}
                            </span>
                          </td>
                          <td className="px-1.5 py-1.5">
                            <div className="flex items-center gap-1">
                              <input
                                type="number"
                                step="0.01"
                                value={quickBasePrices[item._id] !== undefined ? quickBasePrices[item._id] : item.basePrice}
                                onChange={(e) => setQuickBasePrices((p) => ({ ...p, [item._id]: e.target.value }))}
                                className="w-16 px-1 py-0.5 border rounded text-xs h-6"
                              />
                              <button
                                onClick={() => updateBasePrice(item)}
                                className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
                              >
                                ✔
                              </button>
                            </div>
                          </td>
                          <td className="px-1.5 py-1.5">
                            <div className="flex flex-col">
                              {/* Current profit/loss display - FIXED: Ensure it's a number */}
                              <div className={`text-[10px] mb-0.5 ${displayProfitLoss >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                {displayProfitLoss >= 0 ? '+' : ''}{displayProfitLoss.toFixed(2)}
                              </div>
                              {/* Current value input */}
                              <div className="flex items-center gap-1">
                                <input
                                  type="number"
                                  step="0.01"
                                  placeholder="Change"
                                  value={quickProfitLoss[item._id] !== undefined ? quickProfitLoss[item._id] : ''}
                                  onChange={(e) => handleQuickProfitLossChange(item._id, e.target.value)}
                                  className="w-16 px-1 py-0.5 border rounded text-xs h-6"
                                />
                                <button
                                  onClick={() => updateProfitLoss(item)}
                                  className="px-1 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] hover:bg-blue-200"
                                >
                                  ✔
                                </button>
                              </div>
                              {/* Current value display */}
                              <div className={`text-[9px] mt-0.5 ${currentValue >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                Current: {currentValue >= 0 ? '+' : ''}{currentValue.toFixed(2)}
                              </div>
                            </div>
                          </td>
                          <td className="px-1.5 py-1.5 font-bold text-xs">
                            ₹{(item.salePrice || 0).toFixed(2)}
                          </td>
                          <td className="px-1.5 py-1.5 text-xs">
                            ₹{(item.lockedPrice || 0).toFixed(2)}
                          </td>
                          <td className="px-1.5 py-1.5">
                            <span className={`text-xs font-medium ${
                              tejiMaddi.type === 'positive' ? 'text-green-600' :
                              tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
                            }`}>
                              {tejiMaddi.type === 'positive' ? '▲' : tejiMaddi.type === 'negative' ? '▼' : ''}
                              ₹{tejiMaddi.value.toFixed(2)}
                            </span>
                          </td>
                          <td className="px-1.5 py-1.5">
                            <button
                              onClick={() => handleStatusToggle(item)}
                              className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}
                            >
                              {item.status === "active" ? "Active" : "Inactive"}
                            </button>
                          </td>
                          <td className="px-1.5 py-1.5">
                            <div className="flex gap-1">
                              <button
                                onClick={() => handleDetailsClick(item)}
                                className={`w-6 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50 ${
                                  !isMobile && isExpanded ? 'bg-blue-50 text-blue-600' : ''
                                }`}
                                title={isMobile ? "View Details" : (isExpanded ? "Collapse Details" : "Expand Details")}
                              >
                                {!isMobile && isExpanded ? '−' : '+'}
                              </button>
                              <div className="relative">
                                <button
                                  onClick={() => setActiveMenu(activeMenu === item._id ? null : item._id)}
                                  className="w-5 h-5 flex items-center justify-center border rounded text-xs hover:bg-gray-50"
                                >
                                  ⋮
                                </button>
                                {activeMenu === item._id && (
                                  <div className="absolute right-0 mt-1 w-24 bg-white border rounded shadow-lg z-10">
                                    <button
                                      onClick={() => {
                                        handleEdit(item);
                                        setActiveMenu(null);
                                      }}
                                      className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
                                    >
                                      ✏ Edit
                                    </button>
                                    <button
                                      onClick={async () => {
                                        try {
                                          await axios.post(`${API_URL}/copy/${item._id}`);
                                          showAlert("✅ Copied successfully", "success");
                                          fetchItems();
                                          setActiveMenu(null);
                                        } catch (err) {
                                          showAlert("❌ Copy failed", "error");
                                        }
                                      }}
                                      className="block w-full px-2 py-1 text-left text-[10px] hover:bg-gray-50"
                                    >
                                      📄 Copy
                                    </button>
                                    <button
                                      onClick={() => {
                                        handleDelete(item._id);
                                        setActiveMenu(null);
                                      }}
                                      className="block w-full px-2 py-1 text-left text-[10px] text-red-600 hover:bg-red-50"
                                    >
                                      🗑 Delete
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                        
                        {/* Expanded Details Row - Only for desktop */}
                        {!isMobile && isExpanded && (
                          <tr className="bg-blue-50 border-t border-blue-100">
                            <td colSpan="12" className="px-2 md:px-6 py-3 md:py-6">
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                <div className="space-y-1">
                                  <h4 className="font-semibold text-xs text-blue-700 mb-1">Product Details</h4>
                                  <div className="grid grid-cols-2 gap-1 text-[11px]">
                                    <div className="text-gray-600">Name:</div>
                                    <div className="font-medium">{item.name || "N/A"}</div>
                                    
                                    <div className="text-gray-600">Category:</div>
                                    <div className="font-medium">{item.category?.name || "N/A"}</div>
                                    
                                    <div className="text-gray-600">Subcategory:</div>
                                    <div className="font-medium">{item.subcategory?.name || "N/A"}</div>
                                    
                                    <div className="text-gray-600">Description:</div>
                                    <div className="font-medium col-span-1">{item.description || "N/A"}</div>
                                  </div>
                                </div>
                                
                                <div className="space-y-1">
                                  <h4 className="font-semibold text-xs text-blue-700 mb-1">Price Details</h4>
                                  <div className="grid grid-cols-2 gap-1 text-[11px]">
                                    <div className="text-gray-600">Base Price:</div>
                                    <div className="font-medium">₹{(item.basePrice || 0).toFixed(2)}</div>
                                    
                                    <div className="text-gray-600">Profit/Loss:</div>
                                    <div className={`font-medium ${displayProfitLoss >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                      {displayProfitLoss >= 0 ? '+' : ''}₹{displayProfitLoss.toFixed(2)}
                                    </div>
                                    
                                    <div className="text-gray-600">Current (Sale - Base):</div>
                                    <div className={`font-medium ${currentValue >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                      {currentValue >= 0 ? '+' : ''}₹{currentValue.toFixed(2)}
                                    </div>
                                    
                                    <div className="text-gray-600">Sale Price:</div>
                                    <div className="font-bold">₹{(item.salePrice || 0).toFixed(2)}</div>
                                    
                                    <div className="text-gray-600">Locked Price:</div>
                                    <div className="font-medium">₹{(item.lockedPrice || 0).toFixed(2)}</div>
                                  </div>
                                </div>
                                
                                <div className="space-y-1">
                                  <h4 className="font-semibold text-xs text-blue-700 mb-1">Status & Timing</h4>
                                  <div className="grid grid-cols-2 gap-1 text-[11px]">
                                    <div className="text-gray-600">Status:</div>
                                    <div>
                                      <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${getStatusColor(item.status)}`}>
                                        {item.status === "active" ? "Active" : "Inactive"}
                                      </span>
                                    </div>
                                    
                                    <div className="text-gray-600">Valid Till:</div>
                                    <div className="font-medium">{formatDate(item.validTill)}</div>
                                    
                                    <div className="text-gray-600">Created:</div>
                                    <div className="font-medium">{formatDate(item.createdAt)}</div>
                                    
                                    <div className="text-gray-600">Updated:</div>
                                    <div className="font-medium">{formatDate(item.updatedAt)}</div>
                                  </div>
                                </div>
                                
                                <div className="space-y-1">
                                  <h4 className="font-semibold text-xs text-blue-700 mb-1">Market Analysis</h4>
                                  <div className="grid grid-cols-2 gap-1 text-[11px]">
                                    <div className="text-gray-600">Teji/Maddi:</div>
                                    <div className={`font-medium ${
                                      tejiMaddi.type === 'positive' ? 'text-green-600' :
                                      tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
                                    }`}>
                                      {tejiMaddi.type === 'positive' ? '▲ Teji' : 
                                       tejiMaddi.type === 'negative' ? '▼ Maddi' : 'Neutral'}
                                    </div>
                                    
                                    <div className="text-gray-600">Change Value:</div>
                                    <div className={`font-medium ${
                                      tejiMaddi.type === 'positive' ? 'text-green-600' :
                                      tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
                                    }`}>
                                      ₹{tejiMaddi.value.toFixed(2)}
                                    </div>
                                    
                                    <div className="text-gray-600">Change %:</div>
                                    <div className={`font-medium ${
                                      tejiMaddi.type === 'positive' ? 'text-green-600' :
                                      tejiMaddi.type === 'negative' ? 'text-red-600' : 'text-gray-600'
                                    }`}>
                                      {item.lockedPrice > 0 
                                        ? ((tejiMaddi.value / item.lockedPrice) * 100).toFixed(2) + '%'
                                        : '0.00%'}
                                    </div>
                                    
                                    <div className="text-gray-600">Image:</div>
                                    <div>
                                      {item.image ? (
                                        <a 
                                          href={item.image} 
                                          target="_blank" 
                                          rel="noopener noreferrer"
                                          className="text-blue-600 hover:underline text-[10px]"
                                        >
                                          View Image
                                        </a>
                                      ) : (
                                        <span className="text-gray-400">No Image</span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                              <div className="mt-2 pt-2 border-t border-blue-200">
                                <button
                                  onClick={() => setExpandedRows(prev => ({ ...prev, [item._id]: false }))}
                                  className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
                                >
                                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7"></path>
                                  </svg>
                                  Collapse Details
                                </button>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="px-2 py-1.5 border-t bg-gray-50">
                <div className="flex items-center justify-between">
                  <div className="text-[10px] text-gray-600">
                    Page {currentPage} of {totalPages} (Showing {indexOfFirst + 1}-{Math.min(indexOfLast, sortedItems.length)} of {sortedItems.length})
                  </div>
                  <div className="flex gap-1">
                    <button
                      onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                      disabled={currentPage === 1}
                      className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center hover:bg-gray-100"
                    >
                      ←
                    </button>
                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      let pageNum;
                      if (totalPages <= 5) pageNum = i + 1;
                      else if (currentPage <= 3) pageNum = i + 1;
                      else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
                      else pageNum = currentPage - 2 + i;
                      
                      if (pageNum < 1 || pageNum > totalPages) return null;
                      
                      return (
                        <button
                          key={i}
                          onClick={() => setCurrentPage(pageNum)}
                          className={`w-6 h-6 flex items-center justify-center rounded text-xs ${
                            currentPage === pageNum
                              ? "bg-blue-600 text-white"
                              : "border hover:bg-gray-100"
                          }`}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                    <button
                      onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                      disabled={currentPage === totalPages}
                      className="w-6 h-6 border rounded text-xs disabled:opacity-50 flex items-center justify-center hover:bg-gray-100"
                    >
                      →
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Mobile Details Popup */}
      {popupDetails && isMobile && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-2 z-50">
          <div 
            ref={popupRef}
            className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto"
          >
            {/* Popup Header */}
            <div className="sticky top-0 bg-white border-b px-3 py-2 flex items-center justify-between">
              <h3 className="font-bold text-sm">Product Details</h3>
              <button
                onClick={closePopup}
                className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600"
              >
                ✕
              </button>
            </div>
            
            {/* Popup Content */}
            <div className="p-3">
              {/* Product Image & Basic Info */}
              <div className="flex items-start gap-3 mb-3 pb-3 border-b">
                {popupDetails.image ? (
                  <img 
                    src={popupDetails.image} 
                    alt={popupDetails.name} 
                    className="w-16 h-16 rounded object-cover"
                  />
                ) : (
                  <div className="w-16 h-16 bg-gray-100 rounded flex items-center justify-center">
                    <span className="text-xs text-gray-400">No Image</span>
                  </div>
                )}
                <div className="flex-1">
                  <h4 className="font-bold text-sm mb-1">{popupDetails.name}</h4>
                  <div className="flex flex-wrap gap-1">
                    <span className="text-xs px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded">
                      {popupDetails.category?.name || "No Category"}
                    </span>
                    {popupDetails.subcategory?.name && (
                      <span className="text-xs px-1.5 py-0.5 bg-gray-100 text-gray-700 rounded">
                        {popupDetails.subcategory.name}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              
              {/* Price Details Grid */}
              <div className="grid grid-cols-2 gap-2 mb-3">
                <div className="bg-gray-50 rounded p-2">
                  <div className="text-xs text-gray-500 mb-1">Base Price</div>
                  <div className="font-bold text-sm">₹{(popupDetails.basePrice || 0).toFixed(2)}</div>
                </div>
                <div className="bg-gray-50 rounded p-2">
                  <div className="text-xs text-gray-500 mb-1">Profit/Loss</div>
                  <div className={`font-bold text-sm ${Number(popupDetails.profitLoss || 0) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {Number(popupDetails.profitLoss || 0) >= 0 ? '+' : ''}₹{Number(popupDetails.profitLoss || 0).toFixed(2)}
                  </div>
                </div>
                <div className="bg-gray-50 rounded p-2">
                  <div className="text-xs text-gray-500 mb-1">Sale Price</div>
                  <div className="font-bold text-lg text-blue-600">₹{(popupDetails.salePrice || 0).toFixed(2)}</div>
                </div>
                <div className="bg-gray-50 rounded p-2">
                  <div className="text-xs text-gray-500 mb-1">Locked Price</div>
                  <div className="font-medium text-sm">₹{(popupDetails.lockedPrice || 0).toFixed(2)}</div>
                </div>
              </div>
              
              {/* Teji/Maddi Display */}
              {popupDetails.lockedPrice > 0 && (
                <div className="mb-3">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-medium">Teji/Maddi</span>
                    <span className={`text-xs font-bold ${
                      getTejiMaddi(popupDetails).type === 'positive' ? 'text-green-600' :
                      getTejiMaddi(popupDetails).type === 'negative' ? 'text-red-600' : 'text-gray-600'
                    }`}>
                      {getTejiMaddi(popupDetails).type === 'positive' ? '▲ Teji' : 
                       getTejiMaddi(popupDetails).type === 'negative' ? '▼ Maddi' : 'Neutral'} 
                      ₹{getTejiMaddi(popupDetails).value.toFixed(2)}
                    </span>
                  </div>
                  {popupDetails.lockedPrice > 0 && (
                    <div className="text-xs text-gray-500 text-right">
                      {((getTejiMaddi(popupDetails).value / popupDetails.lockedPrice) * 100).toFixed(2)}% change
                    </div>
                  )}
                </div>
              )}
              
              {/* Status & Dates */}
              <div className="grid grid-cols-2 gap-2 mb-3">
                <div className="bg-gray-50 rounded p-2">
                  <div className="text-xs text-gray-500 mb-1">Status</div>
                  <button
                    onClick={() => handleStatusToggle(popupDetails)}
                    className={`px-2 py-0.5 rounded text-xs font-medium ${getStatusColor(popupDetails.status)}`}
                  >
                    {popupDetails.status === "active" ? "Active" : "Inactive"}
                  </button>
                </div>
                <div className="bg-gray-50 rounded p-2">
                  <div className="text-xs text-gray-500 mb-1">Valid Till</div>
                  <div className="font-medium text-xs">{formatDate(popupDetails.validTill)}</div>
                </div>
                <div className="bg-gray-50 rounded p-2">
                  <div className="text-xs text-gray-500 mb-1">Created</div>
                  <div className="font-medium text-xs">{formatDate(popupDetails.createdAt)}</div>
                </div>
                <div className="bg-gray-50 rounded p-2">
                  <div className="text-xs text-gray-500 mb-1">Updated</div>
                  <div className="font-medium text-xs">{formatDate(popupDetails.updatedAt)}</div>
                </div>
              </div>
              
              {/* Description */}
              {popupDetails.description && (
                <div className="mb-3">
                  <div className="text-xs font-medium text-gray-700 mb-1">Description</div>
                  <div className="text-xs text-gray-600 bg-gray-50 rounded p-2">
                    {popupDetails.description}
                  </div>
                </div>
              )}
              
              {/* Action Buttons */}
              <div className="flex gap-2 mt-4 pt-3 border-t">
                <button
                  onClick={() => {
                    handleEdit(popupDetails);
                    closePopup();
                  }}
                  className="flex-1 px-3 py-1.5 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
                >
                  Edit
                </button>
                <button
                  onClick={() => {
                    handleDelete(popupDetails._id);
                    closePopup();
                  }}
                  className="px-3 py-1.5 bg-red-100 text-red-700 rounded text-sm hover:bg-red-200"
                >
                  Delete
                </button>
                <button
                  onClick={closePopup}
                  className="px-3 py-1.5 border rounded text-sm hover:bg-gray-50"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Category Modal */}
      {showCategoryModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-2 md:p-6 z-50">
          <div className="bg-white rounded-lg p-2 md:p-6 max-w-xs w-full">
            <h3 className="font-bold mb-2 text-sm">Add Category</h3>
            <input
              type="text"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
              placeholder="Category Name"
              className="w-full px-1.5 py-1 border rounded mb-2 text-sm"
              autoFocus
              onKeyPress={(e) => e.key === 'Enter' && handleAddCategory()}
            />
            <div className="flex gap-1.5">
              <button
                onClick={handleAddCategory}
                disabled={categoryLoading}
                className="flex-1 px-1.5 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700 disabled:opacity-50"
              >
                {categoryLoading ? "Saving..." : "Save"}
              </button>
              <button
                onClick={() => setShowCategoryModal(false)}
                className="px-1.5 py-1 border rounded text-sm hover:bg-gray-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Alert */}
      {alertBox.show && (
        <div className="fixed bottom-3 right-3 z-50">
          <div className={`px-3 py-2 rounded-lg shadow-lg text-xs ${
            alertBox.type === 'success' ? 'bg-green-100 text-green-800 border border-green-200' :
            alertBox.type === 'error' ? 'bg-red-100 text-red-800 border border-red-200' :
            'bg-yellow-100 text-yellow-800 border border-yellow-200'
          }`}>
            {alertBox.message}
          </div>
        </div>
      )}
    </>
  );
}